var __create = Object.create;
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a4, b4) => {
  for (var prop in b4 || (b4 = {}))
    if (__hasOwnProp.call(b4, prop))
      __defNormalProp(a4, prop, b4[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b4)) {
      if (__propIsEnum.call(b4, prop))
        __defNormalProp(a4, prop, b4[prop]);
    }
  return a4;
};
var __spreadProps = (a4, b4) => __defProps(a4, __getOwnPropDescs(b4));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __commonJS = (cb, mod) => function __require() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));

// node_modules/.pnpm/unraw@3.0.0/node_modules/unraw/dist/errors.js
var require_errors = __commonJS({
  "node_modules/.pnpm/unraw@3.0.0/node_modules/unraw/dist/errors.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.errorMessages = exports.ErrorType = void 0;
    var ErrorType;
    (function(ErrorType2) {
      ErrorType2["MalformedUnicode"] = "MALFORMED_UNICODE";
      ErrorType2["MalformedHexadecimal"] = "MALFORMED_HEXADECIMAL";
      ErrorType2["CodePointLimit"] = "CODE_POINT_LIMIT";
      ErrorType2["OctalDeprecation"] = "OCTAL_DEPRECATION";
      ErrorType2["EndOfString"] = "END_OF_STRING";
    })(ErrorType = exports.ErrorType || (exports.ErrorType = {}));
    exports.errorMessages = /* @__PURE__ */ new Map([
      [ErrorType.MalformedUnicode, "malformed Unicode character escape sequence"],
      [
        ErrorType.MalformedHexadecimal,
        "malformed hexadecimal character escape sequence"
      ],
      [
        ErrorType.CodePointLimit,
        "Unicode codepoint must not be greater than 0x10FFFF in escape sequence"
      ],
      [
        ErrorType.OctalDeprecation,
        '"0"-prefixed octal literals and octal escape sequences are deprecated; for octal literals use the "0o" prefix instead'
      ],
      [ErrorType.EndOfString, "malformed escape sequence at end of string"]
    ]);
  }
});

// node_modules/.pnpm/unraw@3.0.0/node_modules/unraw/dist/index.js
var require_dist = __commonJS({
  "node_modules/.pnpm/unraw@3.0.0/node_modules/unraw/dist/index.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.unraw = exports.errorMessages = exports.ErrorType = void 0;
    var errors_1 = require_errors();
    Object.defineProperty(exports, "ErrorType", { enumerable: true, get: function() {
      return errors_1.ErrorType;
    } });
    Object.defineProperty(exports, "errorMessages", { enumerable: true, get: function() {
      return errors_1.errorMessages;
    } });
    function parseHexToInt(hex) {
      const isOnlyHexChars = !hex.match(/[^a-f0-9]/i);
      return isOnlyHexChars ? parseInt(hex, 16) : NaN;
    }
    function validateAndParseHex(hex, errorName, enforcedLength) {
      const parsedHex = parseHexToInt(hex);
      if (Number.isNaN(parsedHex) || enforcedLength !== void 0 && enforcedLength !== hex.length) {
        throw new SyntaxError(errors_1.errorMessages.get(errorName));
      }
      return parsedHex;
    }
    function parseHexadecimalCode(code) {
      const parsedCode = validateAndParseHex(code, errors_1.ErrorType.MalformedHexadecimal, 2);
      return String.fromCharCode(parsedCode);
    }
    function parseUnicodeCode(code, surrogateCode) {
      const parsedCode = validateAndParseHex(code, errors_1.ErrorType.MalformedUnicode, 4);
      if (surrogateCode !== void 0) {
        const parsedSurrogateCode = validateAndParseHex(surrogateCode, errors_1.ErrorType.MalformedUnicode, 4);
        return String.fromCharCode(parsedCode, parsedSurrogateCode);
      }
      return String.fromCharCode(parsedCode);
    }
    function isCurlyBraced(text) {
      return text.charAt(0) === "{" && text.charAt(text.length - 1) === "}";
    }
    function parseUnicodeCodePointCode(codePoint) {
      if (!isCurlyBraced(codePoint)) {
        throw new SyntaxError(errors_1.errorMessages.get(errors_1.ErrorType.MalformedUnicode));
      }
      const withoutBraces = codePoint.slice(1, -1);
      const parsedCode = validateAndParseHex(withoutBraces, errors_1.ErrorType.MalformedUnicode);
      try {
        return String.fromCodePoint(parsedCode);
      } catch (err) {
        throw err instanceof RangeError ? new SyntaxError(errors_1.errorMessages.get(errors_1.ErrorType.CodePointLimit)) : err;
      }
    }
    function parseOctalCode(code, error = false) {
      if (error) {
        throw new SyntaxError(errors_1.errorMessages.get(errors_1.ErrorType.OctalDeprecation));
      }
      const parsedCode = parseInt(code, 8);
      return String.fromCharCode(parsedCode);
    }
    var singleCharacterEscapes = /* @__PURE__ */ new Map([
      ["b", "\b"],
      ["f", "\f"],
      ["n", "\n"],
      ["r", "\r"],
      ["t", "	"],
      ["v", "\v"],
      ["0", "\0"]
    ]);
    function parseSingleCharacterCode(code) {
      return singleCharacterEscapes.get(code) || code;
    }
    var escapeMatch = /\\(?:(\\)|x([\s\S]{0,2})|u(\{[^}]*\}?)|u([\s\S]{4})\\u([^{][\s\S]{0,3})|u([\s\S]{0,4})|([0-3]?[0-7]{1,2})|([\s\S])|$)/g;
    function unraw2(raw, allowOctals = false) {
      return raw.replace(escapeMatch, function(_, backslash, hex, codePoint, unicodeWithSurrogate, surrogate, unicode, octal, singleCharacter) {
        if (backslash !== void 0) {
          return "\\";
        }
        if (hex !== void 0) {
          return parseHexadecimalCode(hex);
        }
        if (codePoint !== void 0) {
          return parseUnicodeCodePointCode(codePoint);
        }
        if (unicodeWithSurrogate !== void 0) {
          return parseUnicodeCode(unicodeWithSurrogate, surrogate);
        }
        if (unicode !== void 0) {
          return parseUnicodeCode(unicode);
        }
        if (octal === "0") {
          return "\0";
        }
        if (octal !== void 0) {
          return parseOctalCode(octal, !allowOctals);
        }
        if (singleCharacter !== void 0) {
          return parseSingleCharacterCode(singleCharacter);
        }
        throw new SyntaxError(errors_1.errorMessages.get(errors_1.ErrorType.EndOfString));
      });
    }
    exports.unraw = unraw2;
    exports.default = unraw2;
  }
});

// node_modules/.pnpm/moo@0.5.2/node_modules/moo/moo.js
var require_moo = __commonJS({
  "node_modules/.pnpm/moo@0.5.2/node_modules/moo/moo.js"(exports, module) {
    (function(root, factory) {
      if (typeof define === "function" && define.amd) {
        define([], factory);
      } else if (typeof module === "object" && module.exports) {
        module.exports = factory();
      } else {
        root.moo = factory();
      }
    })(exports, function() {
      "use strict";
      var hasOwnProperty = Object.prototype.hasOwnProperty;
      var toString = Object.prototype.toString;
      var hasSticky = typeof new RegExp().sticky === "boolean";
      function isRegExp(o3) {
        return o3 && toString.call(o3) === "[object RegExp]";
      }
      function isObject(o3) {
        return o3 && typeof o3 === "object" && !isRegExp(o3) && !Array.isArray(o3);
      }
      function reEscape(s3) {
        return s3.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
      }
      function reGroups(s3) {
        var re = new RegExp("|" + s3);
        return re.exec("").length - 1;
      }
      function reCapture(s3) {
        return "(" + s3 + ")";
      }
      function reUnion(regexps) {
        if (!regexps.length)
          return "(?!)";
        var source = regexps.map(function(s3) {
          return "(?:" + s3 + ")";
        }).join("|");
        return "(?:" + source + ")";
      }
      function regexpOrLiteral(obj) {
        if (typeof obj === "string") {
          return "(?:" + reEscape(obj) + ")";
        } else if (isRegExp(obj)) {
          if (obj.ignoreCase)
            throw new Error("RegExp /i flag not allowed");
          if (obj.global)
            throw new Error("RegExp /g flag is implied");
          if (obj.sticky)
            throw new Error("RegExp /y flag is implied");
          if (obj.multiline)
            throw new Error("RegExp /m flag is implied");
          return obj.source;
        } else {
          throw new Error("Not a pattern: " + obj);
        }
      }
      function pad(s3, length) {
        if (s3.length > length) {
          return s3;
        }
        return Array(length - s3.length + 1).join(" ") + s3;
      }
      function lastNLines(string2, numLines) {
        var position = string2.length;
        var lineBreaks = 0;
        while (true) {
          var idx = string2.lastIndexOf("\n", position - 1);
          if (idx === -1) {
            break;
          } else {
            lineBreaks++;
          }
          position = idx;
          if (lineBreaks === numLines) {
            break;
          }
          if (position === 0) {
            break;
          }
        }
        var startPosition = lineBreaks < numLines ? 0 : position + 1;
        return string2.substring(startPosition).split("\n");
      }
      function objectToRules(object2) {
        var keys = Object.getOwnPropertyNames(object2);
        var result = [];
        for (var i4 = 0; i4 < keys.length; i4++) {
          var key = keys[i4];
          var thing = object2[key];
          var rules = [].concat(thing);
          if (key === "include") {
            for (var j = 0; j < rules.length; j++) {
              result.push({ include: rules[j] });
            }
            continue;
          }
          var match = [];
          rules.forEach(function(rule) {
            if (isObject(rule)) {
              if (match.length)
                result.push(ruleOptions(key, match));
              result.push(ruleOptions(key, rule));
              match = [];
            } else {
              match.push(rule);
            }
          });
          if (match.length)
            result.push(ruleOptions(key, match));
        }
        return result;
      }
      function arrayToRules(array) {
        var result = [];
        for (var i4 = 0; i4 < array.length; i4++) {
          var obj = array[i4];
          if (obj.include) {
            var include = [].concat(obj.include);
            for (var j = 0; j < include.length; j++) {
              result.push({ include: include[j] });
            }
            continue;
          }
          if (!obj.type) {
            throw new Error("Rule has no type: " + JSON.stringify(obj));
          }
          result.push(ruleOptions(obj.type, obj));
        }
        return result;
      }
      function ruleOptions(type, obj) {
        if (!isObject(obj)) {
          obj = { match: obj };
        }
        if (obj.include) {
          throw new Error("Matching rules cannot also include states");
        }
        var options = {
          defaultType: type,
          lineBreaks: !!obj.error || !!obj.fallback,
          pop: false,
          next: null,
          push: null,
          error: false,
          fallback: false,
          value: null,
          type: null,
          shouldThrow: false
        };
        for (var key in obj) {
          if (hasOwnProperty.call(obj, key)) {
            options[key] = obj[key];
          }
        }
        if (typeof options.type === "string" && type !== options.type) {
          throw new Error("Type transform cannot be a string (type '" + options.type + "' for token '" + type + "')");
        }
        var match = options.match;
        options.match = Array.isArray(match) ? match : match ? [match] : [];
        options.match.sort(function(a4, b4) {
          return isRegExp(a4) && isRegExp(b4) ? 0 : isRegExp(b4) ? -1 : isRegExp(a4) ? 1 : b4.length - a4.length;
        });
        return options;
      }
      function toRules(spec) {
        return Array.isArray(spec) ? arrayToRules(spec) : objectToRules(spec);
      }
      var defaultErrorRule = ruleOptions("error", { lineBreaks: true, shouldThrow: true });
      function compileRules(rules, hasStates) {
        var errorRule = null;
        var fast = /* @__PURE__ */ Object.create(null);
        var fastAllowed = true;
        var unicodeFlag = null;
        var groups = [];
        var parts = [];
        for (var i4 = 0; i4 < rules.length; i4++) {
          if (rules[i4].fallback) {
            fastAllowed = false;
          }
        }
        for (var i4 = 0; i4 < rules.length; i4++) {
          var options = rules[i4];
          if (options.include) {
            throw new Error("Inheritance is not allowed in stateless lexers");
          }
          if (options.error || options.fallback) {
            if (errorRule) {
              if (!options.fallback === !errorRule.fallback) {
                throw new Error("Multiple " + (options.fallback ? "fallback" : "error") + " rules not allowed (for token '" + options.defaultType + "')");
              } else {
                throw new Error("fallback and error are mutually exclusive (for token '" + options.defaultType + "')");
              }
            }
            errorRule = options;
          }
          var match = options.match.slice();
          if (fastAllowed) {
            while (match.length && typeof match[0] === "string" && match[0].length === 1) {
              var word = match.shift();
              fast[word.charCodeAt(0)] = options;
            }
          }
          if (options.pop || options.push || options.next) {
            if (!hasStates) {
              throw new Error("State-switching options are not allowed in stateless lexers (for token '" + options.defaultType + "')");
            }
            if (options.fallback) {
              throw new Error("State-switching options are not allowed on fallback tokens (for token '" + options.defaultType + "')");
            }
          }
          if (match.length === 0) {
            continue;
          }
          fastAllowed = false;
          groups.push(options);
          for (var j = 0; j < match.length; j++) {
            var obj = match[j];
            if (!isRegExp(obj)) {
              continue;
            }
            if (unicodeFlag === null) {
              unicodeFlag = obj.unicode;
            } else if (unicodeFlag !== obj.unicode && options.fallback === false) {
              throw new Error("If one rule is /u then all must be");
            }
          }
          var pat = reUnion(match.map(regexpOrLiteral));
          var regexp = new RegExp(pat);
          if (regexp.test("")) {
            throw new Error("RegExp matches empty string: " + regexp);
          }
          var groupCount = reGroups(pat);
          if (groupCount > 0) {
            throw new Error("RegExp has capture groups: " + regexp + "\nUse (?: \u2026 ) instead");
          }
          if (!options.lineBreaks && regexp.test("\n")) {
            throw new Error("Rule should declare lineBreaks: " + regexp);
          }
          parts.push(reCapture(pat));
        }
        var fallbackRule = errorRule && errorRule.fallback;
        var flags = hasSticky && !fallbackRule ? "ym" : "gm";
        var suffix2 = hasSticky || fallbackRule ? "" : "|";
        if (unicodeFlag === true)
          flags += "u";
        var combined = new RegExp(reUnion(parts) + suffix2, flags);
        return { regexp: combined, groups, fast, error: errorRule || defaultErrorRule };
      }
      function compile(rules) {
        var result = compileRules(toRules(rules));
        return new Lexer({ start: result }, "start");
      }
      function checkStateGroup(g4, name, map) {
        var state = g4 && (g4.push || g4.next);
        if (state && !map[state]) {
          throw new Error("Missing state '" + state + "' (in token '" + g4.defaultType + "' of state '" + name + "')");
        }
        if (g4 && g4.pop && +g4.pop !== 1) {
          throw new Error("pop must be 1 (in token '" + g4.defaultType + "' of state '" + name + "')");
        }
      }
      function compileStates(states, start) {
        var all = states.$all ? toRules(states.$all) : [];
        delete states.$all;
        var keys = Object.getOwnPropertyNames(states);
        if (!start)
          start = keys[0];
        var ruleMap = /* @__PURE__ */ Object.create(null);
        for (var i4 = 0; i4 < keys.length; i4++) {
          var key = keys[i4];
          ruleMap[key] = toRules(states[key]).concat(all);
        }
        for (var i4 = 0; i4 < keys.length; i4++) {
          var key = keys[i4];
          var rules = ruleMap[key];
          var included = /* @__PURE__ */ Object.create(null);
          for (var j = 0; j < rules.length; j++) {
            var rule = rules[j];
            if (!rule.include)
              continue;
            var splice = [j, 1];
            if (rule.include !== key && !included[rule.include]) {
              included[rule.include] = true;
              var newRules = ruleMap[rule.include];
              if (!newRules) {
                throw new Error("Cannot include nonexistent state '" + rule.include + "' (in state '" + key + "')");
              }
              for (var k2 = 0; k2 < newRules.length; k2++) {
                var newRule = newRules[k2];
                if (rules.indexOf(newRule) !== -1)
                  continue;
                splice.push(newRule);
              }
            }
            rules.splice.apply(rules, splice);
            j--;
          }
        }
        var map = /* @__PURE__ */ Object.create(null);
        for (var i4 = 0; i4 < keys.length; i4++) {
          var key = keys[i4];
          map[key] = compileRules(ruleMap[key], true);
        }
        for (var i4 = 0; i4 < keys.length; i4++) {
          var name = keys[i4];
          var state = map[name];
          var groups = state.groups;
          for (var j = 0; j < groups.length; j++) {
            checkStateGroup(groups[j], name, map);
          }
          var fastKeys = Object.getOwnPropertyNames(state.fast);
          for (var j = 0; j < fastKeys.length; j++) {
            checkStateGroup(state.fast[fastKeys[j]], name, map);
          }
        }
        return new Lexer(map, start);
      }
      function keywordTransform(map) {
        var isMap = typeof Map !== "undefined";
        var reverseMap = isMap ? /* @__PURE__ */ new Map() : /* @__PURE__ */ Object.create(null);
        var types = Object.getOwnPropertyNames(map);
        for (var i4 = 0; i4 < types.length; i4++) {
          var tokenType = types[i4];
          var item = map[tokenType];
          var keywordList = Array.isArray(item) ? item : [item];
          keywordList.forEach(function(keyword) {
            if (typeof keyword !== "string") {
              throw new Error("keyword must be string (in keyword '" + tokenType + "')");
            }
            if (isMap) {
              reverseMap.set(keyword, tokenType);
            } else {
              reverseMap[keyword] = tokenType;
            }
          });
        }
        return function(k2) {
          return isMap ? reverseMap.get(k2) : reverseMap[k2];
        };
      }
      var Lexer = function(states, state) {
        this.startState = state;
        this.states = states;
        this.buffer = "";
        this.stack = [];
        this.reset();
      };
      Lexer.prototype.reset = function(data, info) {
        this.buffer = data || "";
        this.index = 0;
        this.line = info ? info.line : 1;
        this.col = info ? info.col : 1;
        this.queuedToken = info ? info.queuedToken : null;
        this.queuedText = info ? info.queuedText : "";
        this.queuedThrow = info ? info.queuedThrow : null;
        this.setState(info ? info.state : this.startState);
        this.stack = info && info.stack ? info.stack.slice() : [];
        return this;
      };
      Lexer.prototype.save = function() {
        return {
          line: this.line,
          col: this.col,
          state: this.state,
          stack: this.stack.slice(),
          queuedToken: this.queuedToken,
          queuedText: this.queuedText,
          queuedThrow: this.queuedThrow
        };
      };
      Lexer.prototype.setState = function(state) {
        if (!state || this.state === state)
          return;
        this.state = state;
        var info = this.states[state];
        this.groups = info.groups;
        this.error = info.error;
        this.re = info.regexp;
        this.fast = info.fast;
      };
      Lexer.prototype.popState = function() {
        this.setState(this.stack.pop());
      };
      Lexer.prototype.pushState = function(state) {
        this.stack.push(this.state);
        this.setState(state);
      };
      var eat = hasSticky ? function(re, buffer) {
        return re.exec(buffer);
      } : function(re, buffer) {
        var match = re.exec(buffer);
        if (match[0].length === 0) {
          return null;
        }
        return match;
      };
      Lexer.prototype._getGroup = function(match) {
        var groupCount = this.groups.length;
        for (var i4 = 0; i4 < groupCount; i4++) {
          if (match[i4 + 1] !== void 0) {
            return this.groups[i4];
          }
        }
        throw new Error("Cannot find token type for matched text");
      };
      function tokenToString() {
        return this.value;
      }
      Lexer.prototype.next = function() {
        var index2 = this.index;
        if (this.queuedGroup) {
          var token = this._token(this.queuedGroup, this.queuedText, index2);
          this.queuedGroup = null;
          this.queuedText = "";
          return token;
        }
        var buffer = this.buffer;
        if (index2 === buffer.length) {
          return;
        }
        var group = this.fast[buffer.charCodeAt(index2)];
        if (group) {
          return this._token(group, buffer.charAt(index2), index2);
        }
        var re = this.re;
        re.lastIndex = index2;
        var match = eat(re, buffer);
        var error = this.error;
        if (match == null) {
          return this._token(error, buffer.slice(index2, buffer.length), index2);
        }
        var group = this._getGroup(match);
        var text = match[0];
        if (error.fallback && match.index !== index2) {
          this.queuedGroup = group;
          this.queuedText = text;
          return this._token(error, buffer.slice(index2, match.index), index2);
        }
        return this._token(group, text, index2);
      };
      Lexer.prototype._token = function(group, text, offset) {
        var lineBreaks = 0;
        if (group.lineBreaks) {
          var matchNL = /\n/g;
          var nl = 1;
          if (text === "\n") {
            lineBreaks = 1;
          } else {
            while (matchNL.exec(text)) {
              lineBreaks++;
              nl = matchNL.lastIndex;
            }
          }
        }
        var token = {
          type: typeof group.type === "function" && group.type(text) || group.defaultType,
          value: typeof group.value === "function" ? group.value(text) : text,
          text,
          toString: tokenToString,
          offset,
          lineBreaks,
          line: this.line,
          col: this.col
        };
        var size = text.length;
        this.index += size;
        this.line += lineBreaks;
        if (lineBreaks !== 0) {
          this.col = size - nl + 1;
        } else {
          this.col += size;
        }
        if (group.shouldThrow) {
          var err = new Error(this.formatError(token, "invalid syntax"));
          throw err;
        }
        if (group.pop)
          this.popState();
        else if (group.push)
          this.pushState(group.push);
        else if (group.next)
          this.setState(group.next);
        return token;
      };
      if (typeof Symbol !== "undefined" && Symbol.iterator) {
        var LexerIterator = function(lexer) {
          this.lexer = lexer;
        };
        LexerIterator.prototype.next = function() {
          var token = this.lexer.next();
          return { value: token, done: !token };
        };
        LexerIterator.prototype[Symbol.iterator] = function() {
          return this;
        };
        Lexer.prototype[Symbol.iterator] = function() {
          return new LexerIterator(this);
        };
      }
      Lexer.prototype.formatError = function(token, message) {
        if (token == null) {
          var text = this.buffer.slice(this.index);
          var token = {
            text,
            offset: this.index,
            lineBreaks: text.indexOf("\n") === -1 ? 0 : 1,
            line: this.line,
            col: this.col
          };
        }
        var numLinesAround = 2;
        var firstDisplayedLine = Math.max(token.line - numLinesAround, 1);
        var lastDisplayedLine = token.line + numLinesAround;
        var lastLineDigits = String(lastDisplayedLine).length;
        var displayedLines = lastNLines(
          this.buffer,
          this.line - token.line + numLinesAround + 1
        ).slice(0, 5);
        var errorLines = [];
        errorLines.push(message + " at line " + token.line + " col " + token.col + ":");
        errorLines.push("");
        for (var i4 = 0; i4 < displayedLines.length; i4++) {
          var line = displayedLines[i4];
          var lineNo = firstDisplayedLine + i4;
          errorLines.push(pad(String(lineNo), lastLineDigits) + "  " + line);
          if (lineNo === token.line) {
            errorLines.push(pad("", lastLineDigits + token.col + 1) + "^");
          }
        }
        return errorLines.join("\n");
      };
      Lexer.prototype.clone = function() {
        return new Lexer(this.states, this.state);
      };
      Lexer.prototype.has = function(tokenType) {
        return true;
      };
      return {
        compile,
        states: compileStates,
        error: Object.freeze({ error: true }),
        fallback: Object.freeze({ fallback: true }),
        keywords: keywordTransform
      };
    });
  }
});

// node_modules/.pnpm/@messageformat+parser@5.1.0/node_modules/@messageformat/parser/lib/lexer.js
var require_lexer = __commonJS({
  "node_modules/.pnpm/@messageformat+parser@5.1.0/node_modules/@messageformat/parser/lib/lexer.js"(exports) {
    "use strict";
    var __importDefault = exports && exports.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.lexer = exports.states = void 0;
    var moo_1 = __importDefault(require_moo());
    exports.states = {
      body: {
        doubleapos: { match: "''", value: () => "'" },
        quoted: {
          lineBreaks: true,
          match: /'[{}#](?:[^]*?[^'])?'(?!')/u,
          value: (src) => src.slice(1, -1).replace(/''/g, "'")
        },
        argument: {
          lineBreaks: true,
          match: /\{\s*[^\p{Pat_Syn}\p{Pat_WS}]+\s*/u,
          push: "arg",
          value: (src) => src.substring(1).trim()
        },
        octothorpe: "#",
        end: { match: "}", pop: 1 },
        content: { lineBreaks: true, match: /[^][^{}#']*/u }
      },
      arg: {
        select: {
          lineBreaks: true,
          match: /,\s*(?:plural|select|selectordinal)\s*,\s*/u,
          next: "select",
          value: (src) => src.split(",")[1].trim()
        },
        "func-args": {
          lineBreaks: true,
          match: /,\s*[^\p{Pat_Syn}\p{Pat_WS}]+\s*,/u,
          next: "body",
          value: (src) => src.split(",")[1].trim()
        },
        "func-simple": {
          lineBreaks: true,
          match: /,\s*[^\p{Pat_Syn}\p{Pat_WS}]+\s*/u,
          value: (src) => src.substring(1).trim()
        },
        end: { match: "}", pop: 1 }
      },
      select: {
        offset: {
          lineBreaks: true,
          match: /\s*offset\s*:\s*\d+\s*/u,
          value: (src) => src.split(":")[1].trim()
        },
        case: {
          lineBreaks: true,
          match: /\s*(?:=\d+|[^\p{Pat_Syn}\p{Pat_WS}]+)\s*\{/u,
          push: "body",
          value: (src) => src.substring(0, src.indexOf("{")).trim()
        },
        end: { match: /\s*\}/u, pop: 1 }
      }
    };
    exports.lexer = moo_1.default.states(exports.states);
  }
});

// node_modules/.pnpm/@messageformat+parser@5.1.0/node_modules/@messageformat/parser/lib/parser.js
var require_parser = __commonJS({
  "node_modules/.pnpm/@messageformat+parser@5.1.0/node_modules/@messageformat/parser/lib/parser.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.parse = exports.ParseError = void 0;
    var lexer_js_1 = require_lexer();
    var getContext = (lt) => ({
      offset: lt.offset,
      line: lt.line,
      col: lt.col,
      text: lt.text,
      lineBreaks: lt.lineBreaks
    });
    var isSelectType = (type) => type === "plural" || type === "select" || type === "selectordinal";
    function strictArgStyleParam(lt, param) {
      let value = "";
      let text = "";
      for (const p4 of param) {
        const pText = p4.ctx.text;
        text += pText;
        switch (p4.type) {
          case "content":
            value += p4.value;
            break;
          case "argument":
          case "function":
          case "octothorpe":
            value += pText;
            break;
          default:
            throw new ParseError(lt, `Unsupported part in strict mode function arg style: ${pText}`);
        }
      }
      const c4 = {
        type: "content",
        value: value.trim(),
        ctx: Object.assign({}, param[0].ctx, { text })
      };
      return [c4];
    }
    var strictArgTypes = [
      "number",
      "date",
      "time",
      "spellout",
      "ordinal",
      "duration"
    ];
    var defaultPluralKeys = ["zero", "one", "two", "few", "many", "other"];
    var ParseError = class extends Error {
      /** @internal */
      constructor(lt, msg) {
        super(lexer_js_1.lexer.formatError(lt, msg));
      }
    };
    exports.ParseError = ParseError;
    var Parser = class {
      constructor(src, opt) {
        var _a, _b, _c, _d;
        this.lexer = lexer_js_1.lexer.reset(src);
        this.cardinalKeys = (_a = opt === null || opt === void 0 ? void 0 : opt.cardinal) !== null && _a !== void 0 ? _a : defaultPluralKeys;
        this.ordinalKeys = (_b = opt === null || opt === void 0 ? void 0 : opt.ordinal) !== null && _b !== void 0 ? _b : defaultPluralKeys;
        this.strict = (_c = opt === null || opt === void 0 ? void 0 : opt.strict) !== null && _c !== void 0 ? _c : false;
        this.strictPluralKeys = (_d = opt === null || opt === void 0 ? void 0 : opt.strictPluralKeys) !== null && _d !== void 0 ? _d : true;
      }
      parse() {
        return this.parseBody(false, true);
      }
      checkSelectKey(lt, type, key) {
        if (key[0] === "=") {
          if (type === "select")
            throw new ParseError(lt, `The case ${key} is not valid with select`);
        } else if (type !== "select") {
          const keys = type === "plural" ? this.cardinalKeys : this.ordinalKeys;
          if (this.strictPluralKeys && keys.length > 0 && !keys.includes(key)) {
            const msg = `The ${type} case ${key} is not valid in this locale`;
            throw new ParseError(lt, msg);
          }
        }
      }
      parseSelect({ value: arg }, inPlural, ctx, type) {
        const sel = { type, arg, cases: [], ctx };
        if (type === "plural" || type === "selectordinal")
          inPlural = true;
        else if (this.strict)
          inPlural = false;
        for (const lt of this.lexer) {
          switch (lt.type) {
            case "offset":
              if (type === "select")
                throw new ParseError(lt, "Unexpected plural offset for select");
              if (sel.cases.length > 0)
                throw new ParseError(lt, "Plural offset must be set before cases");
              sel.pluralOffset = Number(lt.value);
              ctx.text += lt.text;
              ctx.lineBreaks += lt.lineBreaks;
              break;
            case "case": {
              this.checkSelectKey(lt, type, lt.value);
              sel.cases.push({
                key: lt.value,
                tokens: this.parseBody(inPlural),
                ctx: getContext(lt)
              });
              break;
            }
            case "end":
              return sel;
            default:
              throw new ParseError(lt, `Unexpected lexer token: ${lt.type}`);
          }
        }
        throw new ParseError(null, "Unexpected message end");
      }
      parseArgToken(lt, inPlural) {
        const ctx = getContext(lt);
        const argType = this.lexer.next();
        if (!argType)
          throw new ParseError(null, "Unexpected message end");
        ctx.text += argType.text;
        ctx.lineBreaks += argType.lineBreaks;
        if (this.strict && (argType.type === "func-simple" || argType.type === "func-args") && !strictArgTypes.includes(argType.value)) {
          const msg = `Invalid strict mode function arg type: ${argType.value}`;
          throw new ParseError(lt, msg);
        }
        switch (argType.type) {
          case "end":
            return { type: "argument", arg: lt.value, ctx };
          case "func-simple": {
            const end = this.lexer.next();
            if (!end)
              throw new ParseError(null, "Unexpected message end");
            if (end.type !== "end")
              throw new ParseError(end, `Unexpected lexer token: ${end.type}`);
            ctx.text += end.text;
            if (isSelectType(argType.value.toLowerCase()))
              throw new ParseError(argType, `Invalid type identifier: ${argType.value}`);
            return {
              type: "function",
              arg: lt.value,
              key: argType.value,
              ctx
            };
          }
          case "func-args": {
            if (isSelectType(argType.value.toLowerCase())) {
              const msg = `Invalid type identifier: ${argType.value}`;
              throw new ParseError(argType, msg);
            }
            let param = this.parseBody(this.strict ? false : inPlural);
            if (this.strict && param.length > 0)
              param = strictArgStyleParam(lt, param);
            return {
              type: "function",
              arg: lt.value,
              key: argType.value,
              param,
              ctx
            };
          }
          case "select":
            if (isSelectType(argType.value))
              return this.parseSelect(lt, inPlural, ctx, argType.value);
            else
              throw new ParseError(argType, `Unexpected select type ${argType.value}`);
          default:
            throw new ParseError(argType, `Unexpected lexer token: ${argType.type}`);
        }
      }
      parseBody(inPlural, atRoot) {
        const tokens = [];
        let content = null;
        for (const lt of this.lexer) {
          if (lt.type === "argument") {
            if (content)
              content = null;
            tokens.push(this.parseArgToken(lt, inPlural));
          } else if (lt.type === "octothorpe" && inPlural) {
            if (content)
              content = null;
            tokens.push({ type: "octothorpe", ctx: getContext(lt) });
          } else if (lt.type === "end" && !atRoot) {
            return tokens;
          } else {
            let value = lt.value;
            if (!inPlural && lt.type === "quoted" && value[0] === "#") {
              if (value.includes("{")) {
                const errMsg = `Unsupported escape pattern: ${value}`;
                throw new ParseError(lt, errMsg);
              }
              value = lt.text;
            }
            if (content) {
              content.value += value;
              content.ctx.text += lt.text;
              content.ctx.lineBreaks += lt.lineBreaks;
            } else {
              content = { type: "content", value, ctx: getContext(lt) };
              tokens.push(content);
            }
          }
        }
        if (atRoot)
          return tokens;
        throw new ParseError(null, "Unexpected message end");
      }
    };
    function parse2(src, options = {}) {
      const parser = new Parser(src, options);
      return parser.parse();
    }
    exports.parse = parse2;
  }
});

// node_modules/.pnpm/react-is@16.13.1/node_modules/react-is/cjs/react-is.development.js
var require_react_is_development = __commonJS({
  "node_modules/.pnpm/react-is@16.13.1/node_modules/react-is/cjs/react-is.development.js"(exports) {
    "use strict";
    if (true) {
      (function() {
        "use strict";
        var hasSymbol = typeof Symbol === "function" && Symbol.for;
        var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for("react.element") : 60103;
        var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for("react.portal") : 60106;
        var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for("react.fragment") : 60107;
        var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for("react.strict_mode") : 60108;
        var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for("react.profiler") : 60114;
        var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for("react.provider") : 60109;
        var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for("react.context") : 60110;
        var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for("react.async_mode") : 60111;
        var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for("react.concurrent_mode") : 60111;
        var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for("react.forward_ref") : 60112;
        var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for("react.suspense") : 60113;
        var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for("react.suspense_list") : 60120;
        var REACT_MEMO_TYPE = hasSymbol ? Symbol.for("react.memo") : 60115;
        var REACT_LAZY_TYPE = hasSymbol ? Symbol.for("react.lazy") : 60116;
        var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for("react.block") : 60121;
        var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for("react.fundamental") : 60117;
        var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for("react.responder") : 60118;
        var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for("react.scope") : 60119;
        function isValidElementType(type) {
          return typeof type === "string" || typeof type === "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
          type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === "object" && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
        }
        function typeOf(object2) {
          if (typeof object2 === "object" && object2 !== null) {
            var $$typeof = object2.$$typeof;
            switch ($$typeof) {
              case REACT_ELEMENT_TYPE:
                var type = object2.type;
                switch (type) {
                  case REACT_ASYNC_MODE_TYPE:
                  case REACT_CONCURRENT_MODE_TYPE:
                  case REACT_FRAGMENT_TYPE:
                  case REACT_PROFILER_TYPE:
                  case REACT_STRICT_MODE_TYPE:
                  case REACT_SUSPENSE_TYPE:
                    return type;
                  default:
                    var $$typeofType = type && type.$$typeof;
                    switch ($$typeofType) {
                      case REACT_CONTEXT_TYPE:
                      case REACT_FORWARD_REF_TYPE:
                      case REACT_LAZY_TYPE:
                      case REACT_MEMO_TYPE:
                      case REACT_PROVIDER_TYPE:
                        return $$typeofType;
                      default:
                        return $$typeof;
                    }
                }
              case REACT_PORTAL_TYPE:
                return $$typeof;
            }
          }
          return void 0;
        }
        var AsyncMode = REACT_ASYNC_MODE_TYPE;
        var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
        var ContextConsumer = REACT_CONTEXT_TYPE;
        var ContextProvider = REACT_PROVIDER_TYPE;
        var Element2 = REACT_ELEMENT_TYPE;
        var ForwardRef = REACT_FORWARD_REF_TYPE;
        var Fragment4 = REACT_FRAGMENT_TYPE;
        var Lazy = REACT_LAZY_TYPE;
        var Memo = REACT_MEMO_TYPE;
        var Portal = REACT_PORTAL_TYPE;
        var Profiler = REACT_PROFILER_TYPE;
        var StrictMode = REACT_STRICT_MODE_TYPE;
        var Suspense = REACT_SUSPENSE_TYPE;
        var hasWarnedAboutDeprecatedIsAsyncMode = false;
        function isAsyncMode(object2) {
          {
            if (!hasWarnedAboutDeprecatedIsAsyncMode) {
              hasWarnedAboutDeprecatedIsAsyncMode = true;
              console["warn"]("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.");
            }
          }
          return isConcurrentMode(object2) || typeOf(object2) === REACT_ASYNC_MODE_TYPE;
        }
        function isConcurrentMode(object2) {
          return typeOf(object2) === REACT_CONCURRENT_MODE_TYPE;
        }
        function isContextConsumer(object2) {
          return typeOf(object2) === REACT_CONTEXT_TYPE;
        }
        function isContextProvider(object2) {
          return typeOf(object2) === REACT_PROVIDER_TYPE;
        }
        function isElement(object2) {
          return typeof object2 === "object" && object2 !== null && object2.$$typeof === REACT_ELEMENT_TYPE;
        }
        function isForwardRef(object2) {
          return typeOf(object2) === REACT_FORWARD_REF_TYPE;
        }
        function isFragment(object2) {
          return typeOf(object2) === REACT_FRAGMENT_TYPE;
        }
        function isLazy(object2) {
          return typeOf(object2) === REACT_LAZY_TYPE;
        }
        function isMemo(object2) {
          return typeOf(object2) === REACT_MEMO_TYPE;
        }
        function isPortal(object2) {
          return typeOf(object2) === REACT_PORTAL_TYPE;
        }
        function isProfiler(object2) {
          return typeOf(object2) === REACT_PROFILER_TYPE;
        }
        function isStrictMode(object2) {
          return typeOf(object2) === REACT_STRICT_MODE_TYPE;
        }
        function isSuspense(object2) {
          return typeOf(object2) === REACT_SUSPENSE_TYPE;
        }
        exports.AsyncMode = AsyncMode;
        exports.ConcurrentMode = ConcurrentMode;
        exports.ContextConsumer = ContextConsumer;
        exports.ContextProvider = ContextProvider;
        exports.Element = Element2;
        exports.ForwardRef = ForwardRef;
        exports.Fragment = Fragment4;
        exports.Lazy = Lazy;
        exports.Memo = Memo;
        exports.Portal = Portal;
        exports.Profiler = Profiler;
        exports.StrictMode = StrictMode;
        exports.Suspense = Suspense;
        exports.isAsyncMode = isAsyncMode;
        exports.isConcurrentMode = isConcurrentMode;
        exports.isContextConsumer = isContextConsumer;
        exports.isContextProvider = isContextProvider;
        exports.isElement = isElement;
        exports.isForwardRef = isForwardRef;
        exports.isFragment = isFragment;
        exports.isLazy = isLazy;
        exports.isMemo = isMemo;
        exports.isPortal = isPortal;
        exports.isProfiler = isProfiler;
        exports.isStrictMode = isStrictMode;
        exports.isSuspense = isSuspense;
        exports.isValidElementType = isValidElementType;
        exports.typeOf = typeOf;
      })();
    }
  }
});

// node_modules/.pnpm/react-is@16.13.1/node_modules/react-is/index.js
var require_react_is = __commonJS({
  "node_modules/.pnpm/react-is@16.13.1/node_modules/react-is/index.js"(exports, module) {
    "use strict";
    if (false) {
      module.exports = null;
    } else {
      module.exports = require_react_is_development();
    }
  }
});

// node_modules/.pnpm/object-assign@4.1.1/node_modules/object-assign/index.js
var require_object_assign = __commonJS({
  "node_modules/.pnpm/object-assign@4.1.1/node_modules/object-assign/index.js"(exports, module) {
    "use strict";
    var getOwnPropertySymbols = Object.getOwnPropertySymbols;
    var hasOwnProperty = Object.prototype.hasOwnProperty;
    var propIsEnumerable = Object.prototype.propertyIsEnumerable;
    function toObject(val) {
      if (val === null || val === void 0) {
        throw new TypeError("Object.assign cannot be called with null or undefined");
      }
      return Object(val);
    }
    function shouldUseNative() {
      try {
        if (!Object.assign) {
          return false;
        }
        var test1 = new String("abc");
        test1[5] = "de";
        if (Object.getOwnPropertyNames(test1)[0] === "5") {
          return false;
        }
        var test2 = {};
        for (var i4 = 0; i4 < 10; i4++) {
          test2["_" + String.fromCharCode(i4)] = i4;
        }
        var order2 = Object.getOwnPropertyNames(test2).map(function(n4) {
          return test2[n4];
        });
        if (order2.join("") !== "0123456789") {
          return false;
        }
        var test3 = {};
        "abcdefghijklmnopqrst".split("").forEach(function(letter) {
          test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") {
          return false;
        }
        return true;
      } catch (err) {
        return false;
      }
    }
    module.exports = shouldUseNative() ? Object.assign : function(target, source) {
      var from;
      var to = toObject(target);
      var symbols;
      for (var s3 = 1; s3 < arguments.length; s3++) {
        from = Object(arguments[s3]);
        for (var key in from) {
          if (hasOwnProperty.call(from, key)) {
            to[key] = from[key];
          }
        }
        if (getOwnPropertySymbols) {
          symbols = getOwnPropertySymbols(from);
          for (var i4 = 0; i4 < symbols.length; i4++) {
            if (propIsEnumerable.call(from, symbols[i4])) {
              to[symbols[i4]] = from[symbols[i4]];
            }
          }
        }
      }
      return to;
    };
  }
});

// node_modules/.pnpm/prop-types@15.8.1/node_modules/prop-types/lib/ReactPropTypesSecret.js
var require_ReactPropTypesSecret = __commonJS({
  "node_modules/.pnpm/prop-types@15.8.1/node_modules/prop-types/lib/ReactPropTypesSecret.js"(exports, module) {
    "use strict";
    var ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
    module.exports = ReactPropTypesSecret;
  }
});

// node_modules/.pnpm/prop-types@15.8.1/node_modules/prop-types/lib/has.js
var require_has = __commonJS({
  "node_modules/.pnpm/prop-types@15.8.1/node_modules/prop-types/lib/has.js"(exports, module) {
    module.exports = Function.call.bind(Object.prototype.hasOwnProperty);
  }
});

// node_modules/.pnpm/prop-types@15.8.1/node_modules/prop-types/checkPropTypes.js
var require_checkPropTypes = __commonJS({
  "node_modules/.pnpm/prop-types@15.8.1/node_modules/prop-types/checkPropTypes.js"(exports, module) {
    "use strict";
    var printWarning = function() {
    };
    if (true) {
      ReactPropTypesSecret = require_ReactPropTypesSecret();
      loggedTypeFailures = {};
      has = require_has();
      printWarning = function(text) {
        var message = "Warning: " + text;
        if (typeof console !== "undefined") {
          console.error(message);
        }
        try {
          throw new Error(message);
        } catch (x3) {
        }
      };
    }
    var ReactPropTypesSecret;
    var loggedTypeFailures;
    var has;
    function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
      if (true) {
        for (var typeSpecName in typeSpecs) {
          if (has(typeSpecs, typeSpecName)) {
            var error;
            try {
              if (typeof typeSpecs[typeSpecName] !== "function") {
                var err = Error(
                  (componentName || "React class") + ": " + location + " type `" + typeSpecName + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof typeSpecs[typeSpecName] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
                );
                err.name = "Invariant Violation";
                throw err;
              }
              error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
            } catch (ex) {
              error = ex;
            }
            if (error && !(error instanceof Error)) {
              printWarning(
                (componentName || "React class") + ": type specification of " + location + " `" + typeSpecName + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof error + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
              );
            }
            if (error instanceof Error && !(error.message in loggedTypeFailures)) {
              loggedTypeFailures[error.message] = true;
              var stack = getStack ? getStack() : "";
              printWarning(
                "Failed " + location + " type: " + error.message + (stack != null ? stack : "")
              );
            }
          }
        }
      }
    }
    checkPropTypes.resetWarningCache = function() {
      if (true) {
        loggedTypeFailures = {};
      }
    };
    module.exports = checkPropTypes;
  }
});

// node_modules/.pnpm/prop-types@15.8.1/node_modules/prop-types/factoryWithTypeCheckers.js
var require_factoryWithTypeCheckers = __commonJS({
  "node_modules/.pnpm/prop-types@15.8.1/node_modules/prop-types/factoryWithTypeCheckers.js"(exports, module) {
    "use strict";
    var ReactIs = require_react_is();
    var assign = require_object_assign();
    var ReactPropTypesSecret = require_ReactPropTypesSecret();
    var has = require_has();
    var checkPropTypes = require_checkPropTypes();
    var printWarning = function() {
    };
    if (true) {
      printWarning = function(text) {
        var message = "Warning: " + text;
        if (typeof console !== "undefined") {
          console.error(message);
        }
        try {
          throw new Error(message);
        } catch (x3) {
        }
      };
    }
    function emptyFunctionThatReturnsNull() {
      return null;
    }
    module.exports = function(isValidElement2, throwOnDirectAccess) {
      var ITERATOR_SYMBOL = typeof Symbol === "function" && Symbol.iterator;
      var FAUX_ITERATOR_SYMBOL = "@@iterator";
      function getIteratorFn(maybeIterable) {
        var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
        if (typeof iteratorFn === "function") {
          return iteratorFn;
        }
      }
      var ANONYMOUS = "<<anonymous>>";
      var ReactPropTypes = {
        array: createPrimitiveTypeChecker("array"),
        bigint: createPrimitiveTypeChecker("bigint"),
        bool: createPrimitiveTypeChecker("boolean"),
        func: createPrimitiveTypeChecker("function"),
        number: createPrimitiveTypeChecker("number"),
        object: createPrimitiveTypeChecker("object"),
        string: createPrimitiveTypeChecker("string"),
        symbol: createPrimitiveTypeChecker("symbol"),
        any: createAnyTypeChecker(),
        arrayOf: createArrayOfTypeChecker,
        element: createElementTypeChecker(),
        elementType: createElementTypeTypeChecker(),
        instanceOf: createInstanceTypeChecker,
        node: createNodeChecker(),
        objectOf: createObjectOfTypeChecker,
        oneOf: createEnumTypeChecker,
        oneOfType: createUnionTypeChecker,
        shape: createShapeTypeChecker,
        exact: createStrictShapeTypeChecker
      };
      function is(x3, y4) {
        if (x3 === y4) {
          return x3 !== 0 || 1 / x3 === 1 / y4;
        } else {
          return x3 !== x3 && y4 !== y4;
        }
      }
      function PropTypeError(message, data) {
        this.message = message;
        this.data = data && typeof data === "object" ? data : {};
        this.stack = "";
      }
      PropTypeError.prototype = Error.prototype;
      function createChainableTypeChecker(validate) {
        if (true) {
          var manualPropTypeCallCache = {};
          var manualPropTypeWarningCount = 0;
        }
        function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
          componentName = componentName || ANONYMOUS;
          propFullName = propFullName || propName;
          if (secret !== ReactPropTypesSecret) {
            if (throwOnDirectAccess) {
              var err = new Error(
                "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
              );
              err.name = "Invariant Violation";
              throw err;
            } else if (typeof console !== "undefined") {
              var cacheKey2 = componentName + ":" + propName;
              if (!manualPropTypeCallCache[cacheKey2] && // Avoid spamming the console because they are often not actionable except for lib authors
              manualPropTypeWarningCount < 3) {
                printWarning(
                  "You are manually calling a React.PropTypes validation function for the `" + propFullName + "` prop on `" + componentName + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
                );
                manualPropTypeCallCache[cacheKey2] = true;
                manualPropTypeWarningCount++;
              }
            }
          }
          if (props[propName] == null) {
            if (isRequired) {
              if (props[propName] === null) {
                return new PropTypeError("The " + location + " `" + propFullName + "` is marked as required " + ("in `" + componentName + "`, but its value is `null`."));
              }
              return new PropTypeError("The " + location + " `" + propFullName + "` is marked as required in " + ("`" + componentName + "`, but its value is `undefined`."));
            }
            return null;
          } else {
            return validate(props, propName, componentName, location, propFullName);
          }
        }
        var chainedCheckType = checkType.bind(null, false);
        chainedCheckType.isRequired = checkType.bind(null, true);
        return chainedCheckType;
      }
      function createPrimitiveTypeChecker(expectedType) {
        function validate(props, propName, componentName, location, propFullName, secret) {
          var propValue = props[propName];
          var propType = getPropType(propValue);
          if (propType !== expectedType) {
            var preciseType = getPreciseType(propValue);
            return new PropTypeError(
              "Invalid " + location + " `" + propFullName + "` of type " + ("`" + preciseType + "` supplied to `" + componentName + "`, expected ") + ("`" + expectedType + "`."),
              { expectedType }
            );
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function createAnyTypeChecker() {
        return createChainableTypeChecker(emptyFunctionThatReturnsNull);
      }
      function createArrayOfTypeChecker(typeChecker) {
        function validate(props, propName, componentName, location, propFullName) {
          if (typeof typeChecker !== "function") {
            return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside arrayOf.");
          }
          var propValue = props[propName];
          if (!Array.isArray(propValue)) {
            var propType = getPropType(propValue);
            return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an array."));
          }
          for (var i4 = 0; i4 < propValue.length; i4++) {
            var error = typeChecker(propValue, i4, componentName, location, propFullName + "[" + i4 + "]", ReactPropTypesSecret);
            if (error instanceof Error) {
              return error;
            }
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function createElementTypeChecker() {
        function validate(props, propName, componentName, location, propFullName) {
          var propValue = props[propName];
          if (!isValidElement2(propValue)) {
            var propType = getPropType(propValue);
            return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected a single ReactElement."));
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function createElementTypeTypeChecker() {
        function validate(props, propName, componentName, location, propFullName) {
          var propValue = props[propName];
          if (!ReactIs.isValidElementType(propValue)) {
            var propType = getPropType(propValue);
            return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected a single ReactElement type."));
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function createInstanceTypeChecker(expectedClass) {
        function validate(props, propName, componentName, location, propFullName) {
          if (!(props[propName] instanceof expectedClass)) {
            var expectedClassName = expectedClass.name || ANONYMOUS;
            var actualClassName = getClassName(props[propName]);
            return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + actualClassName + "` supplied to `" + componentName + "`, expected ") + ("instance of `" + expectedClassName + "`."));
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function createEnumTypeChecker(expectedValues) {
        if (!Array.isArray(expectedValues)) {
          if (true) {
            if (arguments.length > 1) {
              printWarning(
                "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
              );
            } else {
              printWarning("Invalid argument supplied to oneOf, expected an array.");
            }
          }
          return emptyFunctionThatReturnsNull;
        }
        function validate(props, propName, componentName, location, propFullName) {
          var propValue = props[propName];
          for (var i4 = 0; i4 < expectedValues.length; i4++) {
            if (is(propValue, expectedValues[i4])) {
              return null;
            }
          }
          var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
            var type = getPreciseType(value);
            if (type === "symbol") {
              return String(value);
            }
            return value;
          });
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` of value `" + String(propValue) + "` " + ("supplied to `" + componentName + "`, expected one of " + valuesString + "."));
        }
        return createChainableTypeChecker(validate);
      }
      function createObjectOfTypeChecker(typeChecker) {
        function validate(props, propName, componentName, location, propFullName) {
          if (typeof typeChecker !== "function") {
            return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside objectOf.");
          }
          var propValue = props[propName];
          var propType = getPropType(propValue);
          if (propType !== "object") {
            return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an object."));
          }
          for (var key in propValue) {
            if (has(propValue, key)) {
              var error = typeChecker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
              if (error instanceof Error) {
                return error;
              }
            }
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function createUnionTypeChecker(arrayOfTypeCheckers) {
        if (!Array.isArray(arrayOfTypeCheckers)) {
          true ? printWarning("Invalid argument supplied to oneOfType, expected an instance of array.") : void 0;
          return emptyFunctionThatReturnsNull;
        }
        for (var i4 = 0; i4 < arrayOfTypeCheckers.length; i4++) {
          var checker = arrayOfTypeCheckers[i4];
          if (typeof checker !== "function") {
            printWarning(
              "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + getPostfixForTypeWarning(checker) + " at index " + i4 + "."
            );
            return emptyFunctionThatReturnsNull;
          }
        }
        function validate(props, propName, componentName, location, propFullName) {
          var expectedTypes = [];
          for (var i5 = 0; i5 < arrayOfTypeCheckers.length; i5++) {
            var checker2 = arrayOfTypeCheckers[i5];
            var checkerResult = checker2(props, propName, componentName, location, propFullName, ReactPropTypesSecret);
            if (checkerResult == null) {
              return null;
            }
            if (checkerResult.data && has(checkerResult.data, "expectedType")) {
              expectedTypes.push(checkerResult.data.expectedType);
            }
          }
          var expectedTypesMessage = expectedTypes.length > 0 ? ", expected one of type [" + expectedTypes.join(", ") + "]" : "";
          return new PropTypeError("Invalid " + location + " `" + propFullName + "` supplied to " + ("`" + componentName + "`" + expectedTypesMessage + "."));
        }
        return createChainableTypeChecker(validate);
      }
      function createNodeChecker() {
        function validate(props, propName, componentName, location, propFullName) {
          if (!isNode(props[propName])) {
            return new PropTypeError("Invalid " + location + " `" + propFullName + "` supplied to " + ("`" + componentName + "`, expected a ReactNode."));
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function invalidValidatorError(componentName, location, propFullName, key, type) {
        return new PropTypeError(
          (componentName || "React class") + ": " + location + " type `" + propFullName + "." + key + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + type + "`."
        );
      }
      function createShapeTypeChecker(shapeTypes) {
        function validate(props, propName, componentName, location, propFullName) {
          var propValue = props[propName];
          var propType = getPropType(propValue);
          if (propType !== "object") {
            return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `object`."));
          }
          for (var key in shapeTypes) {
            var checker = shapeTypes[key];
            if (typeof checker !== "function") {
              return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
            }
            var error = checker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
            if (error) {
              return error;
            }
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function createStrictShapeTypeChecker(shapeTypes) {
        function validate(props, propName, componentName, location, propFullName) {
          var propValue = props[propName];
          var propType = getPropType(propValue);
          if (propType !== "object") {
            return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `object`."));
          }
          var allKeys = assign({}, props[propName], shapeTypes);
          for (var key in allKeys) {
            var checker = shapeTypes[key];
            if (has(shapeTypes, key) && typeof checker !== "function") {
              return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
            }
            if (!checker) {
              return new PropTypeError(
                "Invalid " + location + " `" + propFullName + "` key `" + key + "` supplied to `" + componentName + "`.\nBad object: " + JSON.stringify(props[propName], null, "  ") + "\nValid keys: " + JSON.stringify(Object.keys(shapeTypes), null, "  ")
              );
            }
            var error = checker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
            if (error) {
              return error;
            }
          }
          return null;
        }
        return createChainableTypeChecker(validate);
      }
      function isNode(propValue) {
        switch (typeof propValue) {
          case "number":
          case "string":
          case "undefined":
            return true;
          case "boolean":
            return !propValue;
          case "object":
            if (Array.isArray(propValue)) {
              return propValue.every(isNode);
            }
            if (propValue === null || isValidElement2(propValue)) {
              return true;
            }
            var iteratorFn = getIteratorFn(propValue);
            if (iteratorFn) {
              var iterator = iteratorFn.call(propValue);
              var step2;
              if (iteratorFn !== propValue.entries) {
                while (!(step2 = iterator.next()).done) {
                  if (!isNode(step2.value)) {
                    return false;
                  }
                }
              } else {
                while (!(step2 = iterator.next()).done) {
                  var entry = step2.value;
                  if (entry) {
                    if (!isNode(entry[1])) {
                      return false;
                    }
                  }
                }
              }
            } else {
              return false;
            }
            return true;
          default:
            return false;
        }
      }
      function isSymbol(propType, propValue) {
        if (propType === "symbol") {
          return true;
        }
        if (!propValue) {
          return false;
        }
        if (propValue["@@toStringTag"] === "Symbol") {
          return true;
        }
        if (typeof Symbol === "function" && propValue instanceof Symbol) {
          return true;
        }
        return false;
      }
      function getPropType(propValue) {
        var propType = typeof propValue;
        if (Array.isArray(propValue)) {
          return "array";
        }
        if (propValue instanceof RegExp) {
          return "object";
        }
        if (isSymbol(propType, propValue)) {
          return "symbol";
        }
        return propType;
      }
      function getPreciseType(propValue) {
        if (typeof propValue === "undefined" || propValue === null) {
          return "" + propValue;
        }
        var propType = getPropType(propValue);
        if (propType === "object") {
          if (propValue instanceof Date) {
            return "date";
          } else if (propValue instanceof RegExp) {
            return "regexp";
          }
        }
        return propType;
      }
      function getPostfixForTypeWarning(value) {
        var type = getPreciseType(value);
        switch (type) {
          case "array":
          case "object":
            return "an " + type;
          case "boolean":
          case "date":
          case "regexp":
            return "a " + type;
          default:
            return type;
        }
      }
      function getClassName(propValue) {
        if (!propValue.constructor || !propValue.constructor.name) {
          return ANONYMOUS;
        }
        return propValue.constructor.name;
      }
      ReactPropTypes.checkPropTypes = checkPropTypes;
      ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
      ReactPropTypes.PropTypes = ReactPropTypes;
      return ReactPropTypes;
    };
  }
});

// node_modules/.pnpm/prop-types@15.8.1/node_modules/prop-types/index.js
var require_prop_types = __commonJS({
  "node_modules/.pnpm/prop-types@15.8.1/node_modules/prop-types/index.js"(exports, module) {
    if (true) {
      ReactIs = require_react_is();
      throwOnDirectAccess = true;
      module.exports = require_factoryWithTypeCheckers()(ReactIs.isElement, throwOnDirectAccess);
    } else {
      module.exports = null();
    }
    var ReactIs;
    var throwOnDirectAccess;
  }
});

// packages/_helpers/clickable.tsx
import React4 from "react";

// node_modules/.pnpm/@chbphone55+classnames@2.0.0/node_modules/@chbphone55/classnames/dist/index.m.js
var r = function() {
  for (var t2 = [], n4 = arguments.length; n4--; )
    t2[n4] = arguments[n4];
  return t2.reduce(function(t3, n5) {
    return t3.concat("string" == typeof n5 ? n5 : Array.isArray(n5) ? r.apply(void 0, n5) : "object" == typeof n5 && n5 ? Object.keys(n5).map(function(r5) {
      return n5[r5] ? r5 : "";
    }) : "");
  }, []).join(" ");
};

// node_modules/.pnpm/@warp-ds+css@1.8.4/node_modules/@warp-ds/css/component-classes/index.js
var badge = {
  base: "py-4 px-8 border-0 rounded-4 text-xs inline-flex",
  neutral: "bg-[--w-color-badge-neutral-background] s-text",
  info: "bg-[--w-color-badge-info-background] s-text",
  positive: "bg-[--w-color-badge-positive-background] s-text",
  warning: "bg-[--w-color-badge-warning-background] s-text",
  negative: "bg-[--w-color-badge-negative-background] s-text",
  disabled: "s-bg-disabled s-text",
  price: "bg-[--w-black/70] s-text-inverted",
  sponsored: "bg-[--w-color-badge-sponsored-background] s-text",
  // Notification badge is deprecated: Do not use!
  notification: "i-bg-$color-badge-notification-background i-text-$color-badge-notification-text",
  positionBase: "absolute backdrop-blur",
  positionTL: "rounded-tl-0 rounded-tr-0 rounded-bl-0 top-0 left-0",
  positionTR: "rounded-tl-0 rounded-tr-0 rounded-br-0 top-0 right-0",
  positionBR: "rounded-tr-0 rounded-br-0 rounded-bl-0 bottom-0 right-0",
  positionBL: "rounded-tl-0 rounded-br-0 rounded-bl-0 bottom-0 left-0"
};
var slider = {
  wrapper: "touch-pan-y relative w-full h-44 py-2",
  track: "absolute s-bg-disabled h-4 top-20 rounded-4 w-full ",
  trackDisabled: "pointer-events-none",
  activeTrack: "absolute s-bg-primary h-6 top-[19px] rounded-4",
  activeTrackDisabled: "absolute s-bg-disabled h-6 top-[19px] rounded-4 pointer-events-none",
  thumb: "absolute transition-shadow w-24 h-24 bottom-10 rounded-4 outline-none",
  thumbEnabled: "border-2 shadow-[--w-shadow-slider] cursor-pointer s-bg-primary s-border-primary hover:s-bg-primary-hover hover:s-border-primary-hover hover:shadow-[--w-shadow-slider-handle-hover] active:s-bg-primary-active active:s-border-primary-active active:shadow-[--w-shadow-slider-handle-active] focus:shadow-[--w-shadow-slider-handle-hover] focus:s-border-primary-hover focus:s-bg-primary-hover",
  thumbDisabled: "s-bg-disabled cursor-disabled pointer-events-none"
};
var box = {
  box: "group block relative break-words last-child:mb-0 p-16 rounded-8",
  // Relative here enables w-clickable
  bleed: "-mx-16 sm:mx-0 rounded-l-0 rounded-r-0 sm:rounded-8",
  // We target L and R to override the default rounded-8
  info: "s-bg-info-subtle",
  neutral: "s-bg-subtle",
  bordered: "border-2 s-border s-bg",
  infoClickable: "hover:s-bg-info-subtle-hover active:s-bg-info-subtle-hover",
  neutralClickable: "hover:s-bg-subtle-hover active:s-bg-subtle-hover",
  borderedClickable: "hover:s-bg-hover active:s-bg-hover hover:s-border-hover active:s-border-hover"
};
var pill = {
  pill: "flex items-center",
  button: "inline-flex items-center focusable text-xs transition-all",
  suggestion: "i-bg-$color-pill-suggestion-background hover:i-bg-$color-pill-suggestion-background-hover active:i-bg-$color-pill-suggestion-background-active s-text font-bold",
  filter: "s-bg-primary hover:s-bg-primary-hover active:s-bg-primary-active s-text-inverted",
  label: "pl-12 py-8 rounded-l-full",
  labelWithoutClose: "pr-12 rounded-r-full",
  labelWithClose: "pr-2",
  close: "pr-12 pl-4 py-8 rounded-r-full",
  a11y: "sr-only"
};
var step = {
  step: "group/step",
  stepVertical: "group/stepv grid-rows-[20px_auto] grid grid-flow-col gap-x-16",
  stepVerticalLeft: "grid-cols-[20px_1fr]",
  stepVerticalRight: "grid-cols-[1fr_20px] text-right",
  stepHorizontal: "group/steph grid-rows-[auto_20px] grid-cols-[1fr_20px_1fr] flex-1 grid gap-y-16 items-center",
  stepDot: "rounded-full border-2 h-20 w-20 transition-colors duration-300 s-icon-inverted",
  stepDotVerticalRight: "col-start-2",
  stepDotHorizontal: "row-start-2 justify-self-end",
  stepDotActive: "s-border-primary s-bg-primary",
  stepDotIncomplete: "s-border s-bg",
  stepLine: "group-last/stepv:hidden transition-colors duration-300",
  stepLineVertical: "w-2 h-full justify-self-center",
  stepLineVerticalRight: "col-start-2",
  stepLineHorizontal: "h-2 w-full row-start-2",
  stepLineHorizontalRight: "group-last/steph:bg-transparent",
  stepLineHorizontalLeft: "group-first/steph:bg-transparent",
  stepLineIncomplete: "s-bg-disabled",
  stepLineComplete: "s-bg-primary",
  content: "last:mb-0 group-last/step:last:pb-0",
  contentVertical: "row-span-2 pb-32",
  contentHorizontal: "col-span-3 px-16 row-start-1 text-center"
};
var steps = {
  steps: "w-full",
  stepsHorizontal: "flex"
};
var card = {
  card: "cursor-pointer overflow-hidden relative transition-all",
  cardShadow: "rounded-8 shadow-s hover:shadow-m hover:s-bg-subtle-hover tap-highlight-transparent",
  cardFlat: "border-2 rounded-4",
  cardFlatUnselected: "s-bg s-border hover:s-bg-subtle-hover hover:s-border-hover active:s-bg-active active:s-border-active",
  cardFlatSelected: "s-border-selected s-bg-selected hover:s-bg-selected-hover hover:s-border-selected-hover active:s-border-selected-active active:s-bg-selected-active",
  cardUnselected: "s-bg",
  cardSelected: "s-border-selected s-bg-selected hover:s-border-selected-hover hover:s-bg-selected-hover active:s-border-selected-active active:s-bg-selected-active",
  cardOutline: "active:s-border absolute rounded-8 inset-0 transition-all border-2",
  cardOutlineUnselected: "border-transparent",
  cardOutlineSelected: "s-border-selected hover:s-border-selected-hover",
  a11y: "sr-only"
};
var switchToggle = {
  switch: "tap-highlight-transparent",
  label: "block relative h-24 w-44 cursor-pointer group",
  labelDisabled: "pointer-events-none",
  track: "absolute top-0 left-0 h-full w-full rounded-full transition-colors",
  trackActive: "s-bg-primary group-hover:s-bg-primary-hover",
  trackInactive: "bg-[--w-color-switch-track-background] group-hover:bg-[--w-color-switch-track-background-hover]",
  trackDisabled: "s-bg-disabled-subtle",
  handle: "absolute transform-gpu h-16 w-16 top-4 left-4 rounded-full transition-transform",
  handleSelected: "translate-x-20",
  handleNotDisabled: "s-bg shadow-s",
  handleDisabled: "s-bg-disabled",
  a11y: "sr-only"
};
var tabs = {
  tabContainer: "inline-grid relative",
  wunderbar: "absolute s-border-selected -bottom-0 border-b-4 transition-all",
  wrapperUnderlined: "border-b border-transparent -mx-16 sm:mx-0 px-4 sm:px-0 mb-32 "
};
var tab = {
  tab: "grid items-center font-bold gap-8 focusable antialias p-16 pb-8 border-b-4 bg-transparent s-text-subtle border-transparent hover:s-text-link hover:s-border-primary",
  tabActive: "s-text-link",
  icon: "mx-auto hover:s-text-link",
  iconUnderlinedActive: "s-text-link",
  content: "flex items-center justify-center gap-8",
  contentUnderlined: "content-underlined",
  // content-underlined is a no-op that prevents a quirk in how Vue handles class bindings
  contentUnderlinedActive: "s-text-link"
};
var gridLayout = {
  cols1: "grid-cols-1",
  cols2: "grid-cols-2",
  cols3: "grid-cols-3",
  cols4: "grid-cols-4",
  cols5: "grid-cols-5",
  cols6: "grid-cols-6",
  cols7: "grid-cols-7",
  cols8: "grid-cols-8",
  cols9: "grid-cols-9"
};
var buttonReset = "focus:outline-none appearance-none cursor-pointer bg-transparent border-0 m-0 p-0 inline-block";
var expandable = {
  expandable: "will-change-height",
  expandableTitle: "font-bold s-text",
  expandableBox: "s-bg-subtle hover:s-bg-subtle-hover py-0 px-0 " + box.box,
  expandableInfo: "s-bg-info-subtle! hover:s-bg-info-subtle-hover!",
  expandableBleed: box.bleed,
  chevron: "inline-block align-middle s-icon",
  chevronNonBox: "ml-8",
  chevronBox: "",
  chevronTransform: "transform transition-transform transform-gpu ease-in-out",
  chevronExpand: "-rotate-180",
  chevronCollapse: "rotate-180",
  elementsTransformChevronDownPart: "part-[w-icon-chevron-down-16-part]:transform part-[w-icon-chevron-down-16-part]:transition-transform part-[w-icon-chevron-down-16-part]:transform-gpu part-[w-icon-chevron-down-16-part]:ease-in-out",
  elementsChevronDownExpandPart: "part-[w-icon-chevron-down-16-part]:-rotate-180",
  elementsTransformChevronUpPart: "part-[w-icon-chevron-up-16-part]:transform part-[w-icon-chevron-up-16-part]:transition-transform part-[w-icon-chevron-up-16-part]:transform-gpu part-[w-icon-chevron-up-16-part]:ease-in-out",
  elementsChevronUpCollapsePart: "part-[w-icon-chevron-up-16-part]:rotate-180",
  expansion: "overflow-hidden",
  expansionNotExpanded: "h-0 invisible",
  button: buttonReset + " hover:underline focus-visible:underline",
  buttonBox: "w-full text-left relative inline-flex items-center justify-between " + box.box,
  paddingTop: "pt-0",
  title: "flex w-full justify-between items-center",
  titleType: "h4"
};
var buttonDefaultStyling = "font-bold focusable justify-center transition-colors ease-in-out";
var buttonColors = {
  primary: "s-text-inverted bg-[--w-color-button-primary-background] hover:bg-[--w-color-button-primary-background-hover] active:bg-[--w-color-button-primary-background-active]",
  secondary: "s-text-link s-border s-bg hover:s-bg-hover hover:s-border-hover active:s-bg-active",
  utility: "s-text s-bg hover:s-bg-hover s-border hover:s-border-hover active:s-border-active",
  destructive: "s-bg-negative s-text-inverted hover:s-bg-negative-hover active:s-bg-negative-active",
  pill: "s-icon hover:s-icon-hover active:s-icon-active bg-transparent hover:bg-[--w-color-button-pill-background-hover] active:bg-[--w-color-button-pill-background-active]",
  disabled: "s-text-inverted s-bg-disabled",
  quiet: "bg-transparent s-text-link hover:s-bg-hover active:s-bg-active",
  utilityQuiet: "s-text bg-transparent hover:s-bg-subtle-hover",
  negativeQuiet: "bg-transparent s-text-negative hover:s-bg-negative-subtle-hover active:s-bg-negative-subtle-active",
  loading: "s-text s-bg-subtle",
  link: "s-text-link"
};
var buttonTypes = {
  primary: `border-0 rounded-8 ${buttonDefaultStyling}`,
  secondary: `border-2 rounded-8 ${buttonDefaultStyling}`,
  utility: `border rounded-4 ${buttonDefaultStyling}`,
  negative: `border-0 rounded-8 ${buttonDefaultStyling}`,
  pill: `p-4 rounded-full border-0 inline-flex items-center justify-center hover:bg-clip-padding ${buttonDefaultStyling}`,
  link: `bg-transparent focusable ease-in-out inline active:underline hover:underline ${buttonColors.link}`
};
var buttonSizes = {
  xsmall: "py-6 px-16",
  small: "py-8 px-16",
  medium: "py-10 px-14",
  large: "py-12 px-16",
  utility: "py-[11px] px-[15px]",
  smallUtility: "py-[7px] px-[15px]",
  pill: "min-h-[44px] min-w-[44px]",
  pillSmall: "min-h-32 min-w-32",
  link: "p-0"
};
var buttonTextSizes = {
  medium: "text-m leading-[24]",
  xsmall: "text-xs"
};
var buttonVariants = {
  inProgress: `border-transparent animate-inprogress pointer-events-none ${buttonColors.loading}`,
  // .button--in-progress, a.button--in-progress:visited
  quiet: `border-0 rounded-8 ${buttonDefaultStyling}`,
  utilityQuiet: `border-0 rounded-4 ${buttonDefaultStyling}`,
  negativeQuiet: `border-0 rounded-8 ${buttonDefaultStyling}`,
  isDisabled: `font-bold justify-center transition-colors ease-in-out cursor-default pointer-events-none ${buttonColors.disabled}`
  // .button:disabled, .button--is-disabled
};
var button = {
  // Buttontypes
  secondary: `${buttonSizes.medium} ${buttonTextSizes.medium} ${buttonTypes.secondary} ${buttonColors.secondary}`,
  // .button--secondary, .button--default, .button
  secondaryHref: `${buttonSizes.medium} ${buttonTextSizes.medium} ${buttonTypes.secondary} ${buttonColors.secondary}`,
  secondaryDisabled: `${buttonSizes.medium} ${buttonTextSizes.medium} ${buttonTypes.secondary} ${buttonVariants.isDisabled}`,
  secondarySmall: `${buttonTextSizes.xsmall} ${buttonSizes.xsmall} ${buttonTypes.secondary} ${buttonColors.secondary}`,
  secondarySmallDisabled: `${buttonTextSizes.xsmall} ${buttonSizes.xsmall} ${buttonTypes.secondary} ${buttonVariants.isDisabled}`,
  secondaryQuiet: `${buttonSizes.medium} ${buttonTextSizes.medium} ${buttonVariants.quiet} ${buttonColors.quiet}`,
  secondaryQuietDisabled: `${buttonSizes.medium} ${buttonTextSizes.medium} ${buttonVariants.quiet} ${buttonVariants.isDisabled}`,
  secondarySmallQuiet: `${buttonTextSizes.xsmall} ${buttonSizes.xsmall} ${buttonVariants.quiet} ${buttonColors.quiet}`,
  secondarySmallQuietDisabled: `${buttonTextSizes.xsmall} ${buttonSizes.xsmall} ${buttonVariants.quiet} ${buttonVariants.isDisabled}`,
  secondaryLoading: `${buttonSizes.medium} ${buttonTextSizes.medium} ${buttonTypes.secondary} ${buttonVariants.inProgress}`,
  secondarySmallLoading: `${buttonTextSizes.xsmall} ${buttonSizes.xsmall}  ${buttonTypes.secondary} ${buttonVariants.inProgress}`,
  secondarySmallQuietLoading: `${buttonTextSizes.xsmall} ${buttonSizes.xsmall} ${buttonVariants.quiet} ${buttonVariants.inProgress}`,
  secondaryQuietLoading: `${buttonSizes.medium} ${buttonTextSizes.medium} ${buttonVariants.quiet} ${buttonVariants.inProgress}`,
  primary: `${buttonSizes.large} ${buttonTextSizes.medium} ${buttonTypes.primary} ${buttonColors.primary}`,
  // .button--primary, .button--cta
  primaryDisabled: `${buttonSizes.large} ${buttonTextSizes.medium} ${buttonVariants.isDisabled} ${buttonTypes.primary}`,
  primarySmall: `${buttonSizes.small} ${buttonTextSizes.xsmall} ${buttonTypes.primary} ${buttonColors.primary}`,
  primarySmallDisabled: `${buttonSizes.small} ${buttonTextSizes.xsmall} ${buttonVariants.isDisabled} ${buttonTypes.primary} `,
  primaryQuiet: `${buttonSizes.large} ${buttonTextSizes.medium} ${buttonVariants.quiet} ${buttonColors.quiet}`,
  primaryQuietDisabled: `${buttonSizes.large} ${buttonTextSizes.medium} ${buttonVariants.quiet} ${buttonVariants.isDisabled}`,
  primarySmallQuiet: `${buttonSizes.small} ${buttonTextSizes.xsmall} ${buttonVariants.quiet} ${buttonColors.quiet}`,
  primarySmallQuietDisabled: `${buttonSizes.small} ${buttonTextSizes.xsmall} ${buttonVariants.quiet} ${buttonVariants.isDisabled}`,
  primaryLoading: `${buttonSizes.large} ${buttonTextSizes.medium} ${buttonVariants.inProgress} ${buttonTypes.primary}`,
  primarySmallLoading: `${buttonSizes.small} ${buttonTextSizes.xsmall}  ${buttonVariants.inProgress} ${buttonTypes.primary}`,
  primarySmallQuietLoading: `${buttonSizes.small} ${buttonTextSizes.xsmall} ${buttonVariants.quiet} ${buttonVariants.inProgress} ${buttonTypes.primary}`,
  primaryQuietLoading: `${buttonSizes.large} ${buttonTextSizes.medium} ${buttonVariants.quiet} ${buttonVariants.inProgress}`,
  utility: `${buttonSizes.utility} ${buttonTextSizes.medium} ${buttonTypes.utility} ${buttonColors.utility}`,
  // .button--utility
  utilityDisabled: `${buttonSizes.utility} ${buttonTextSizes.medium} ${buttonTypes.utility} ${buttonVariants.isDisabled}`,
  utilityQuiet: `${buttonSizes.large} ${buttonTextSizes.medium} ${buttonVariants.utilityQuiet} ${buttonColors.utilityQuiet}`,
  // .button--utility-flat
  utilityQuietDisabled: `${buttonSizes.large} ${buttonTextSizes.medium} ${buttonVariants.utilityQuiet} ${buttonVariants.isDisabled}`,
  utilitySmall: `${buttonSizes.smallUtility} ${buttonTextSizes.xsmall} ${buttonTypes.utility} ${buttonColors.utility}`,
  utilitySmallDisabled: `${buttonSizes.smallUtility} ${buttonTextSizes.xsmall} ${buttonTypes.utility} ${buttonVariants.isDisabled}`,
  utilitySmallQuiet: `${buttonSizes.smallUtility} ${buttonTextSizes.xsmall} ${buttonVariants.utilityQuiet} ${buttonColors.utilityQuiet}`,
  utilitySmallQuietDisabled: `${buttonSizes.smallUtility} ${buttonTextSizes.xsmall} ${buttonVariants.utilityQuiet} ${buttonVariants.isDisabled}`,
  utilityLoading: `${buttonSizes.large} ${buttonTextSizes.medium} ${buttonTypes.utility} ${buttonVariants.inProgress}`,
  utilitySmallLoading: `${buttonSizes.smallUtility} ${buttonTextSizes.xsmall} ${buttonTypes.utility} ${buttonVariants.inProgress}`,
  utilityQuietLoading: `${buttonSizes.large} ${buttonTextSizes.medium} ${buttonVariants.inProgress} ${buttonVariants.utilityQuiet}`,
  utilitySmallQuietLoading: `${buttonSizes.smallUtility} ${buttonTextSizes.xsmall} ${buttonVariants.inProgress} ${buttonVariants.utilityQuiet}`,
  negative: `${buttonSizes.large} ${buttonTextSizes.medium} ${buttonTypes.negative} ${buttonColors.destructive}`,
  // .button--destructive
  negativeDisabled: `${buttonSizes.large} ${buttonTextSizes.medium} ${buttonTypes.negative} ${buttonVariants.isDisabled}`,
  negativeQuiet: `${buttonSizes.large} ${buttonTextSizes.medium} ${buttonVariants.negativeQuiet} ${buttonColors.negativeQuiet}`,
  // .button--destructive-flat
  negativeQuietDisabled: `${buttonSizes.large} ${buttonTextSizes.medium} ${buttonVariants.negativeQuiet}${buttonVariants.isDisabled}`,
  negativeSmall: `${buttonSizes.small} ${buttonTextSizes.xsmall} ${buttonTypes.negative} ${buttonColors.destructive}`,
  negativeSmallDisabled: `${buttonSizes.small} ${buttonTextSizes.xsmall} ${buttonTypes.negative} ${buttonVariants.isDisabled}`,
  negativeSmallQuiet: `${buttonSizes.small} ${buttonTextSizes.xsmall} ${buttonVariants.negativeQuiet} ${buttonColors.negativeQuiet}`,
  negativeSmallQuietDisabled: `${buttonSizes.small} ${buttonTextSizes.xsmall} ${buttonVariants.negativeQuiet} ${buttonVariants.isDisabled}`,
  negativeLoading: `${buttonSizes.large} ${buttonTextSizes.medium} ${buttonTypes.negative} ${buttonVariants.inProgress}`,
  negativeSmallLoading: `${buttonSizes.small} ${buttonTextSizes.xsmall} ${buttonVariants.inProgress} ${buttonTypes.negative}`,
  negativeQuietLoading: `${buttonSizes.large} ${buttonTextSizes.medium} ${buttonVariants.negativeQuiet} ${buttonTypes.negative} ${buttonVariants.inProgress}`,
  negativeSmallQuietLoading: `${buttonSizes.small} ${buttonTextSizes.xsmall} ${buttonVariants.negativeQuiet} ${buttonVariants.inProgress}`,
  pill: `${buttonSizes.pill} ${buttonTextSizes.medium} ${buttonTypes.pill} ${buttonColors.pill}`,
  // .button--pill
  pillSmall: `${buttonSizes.pillSmall} ${buttonTextSizes.xsmall} ${buttonTypes.pill} ${buttonColors.pill}`,
  pillLoading: `${buttonSizes.pill} ${buttonTextSizes.medium} ${buttonTypes.pill} ${buttonVariants.inProgress}`,
  pillSmallLoading: `${buttonSizes.pillSmall} ${buttonTextSizes.xsmall} ${buttonTypes.pill} ${buttonVariants.inProgress}`,
  link: `${buttonSizes.link} ${buttonTextSizes.medium} ${buttonTypes.link}`,
  linkSmall: `${buttonSizes.link} ${buttonTextSizes.xsmall} ${buttonTypes.link}`,
  linkAsButton: "inline-block hover:no-underline text-center",
  a11y: "sr-only",
  fullWidth: "w-full max-w-full",
  contentWidth: "max-w-max"
};
var modal = {
  //TODO: transparentBg can be removed when it has been removed in React and Vue - previously used for opacity before changing to a rgba background in backdrop
  transparentBg: "",
  backdrop: "fixed inset-0 flex sm:place-content-center sm:place-items-center items-end z-30 [--w-modal-max-height:80%] [--w-modal-width:640px] bg-[--w-black/25]",
  modal: "pb-safe-[32] shadow-m max-h-[--w-modal-max-height] min-h-[--w-modal-min-height] w-[--w-modal-width] h-[--w-modal-height] relative transition-300 ease-in-out backface-hidden will-change-height rounded-8 mx-0 sm:mx-16 s-bg flex flex-col overflow-hidden outline-none space-y-16 pt-8 sm:pt-32 sm:pb-32 rounded-b-0 sm:rounded-b-8",
  content: "block overflow-y-auto overflow-x-hidden last-child:mb-0 grow shrink px-16 sm:px-32 relative",
  footer: "flex justify-end shrink-0 px-16 sm:px-32",
  transitionTitle: "transition-all duration-300",
  transitionTitleCenter: "justify-self-center self-center",
  transitionTitleColSpan: "col-span-2",
  title: "py-8 sm:py-0 -mt-4 sm:-mt-8 min-h-40 sm:min-h-48 grid gap-8 sm:gap-16 grid-cols-[auto_1fr_auto] items-start px-16 sm:px-32 border-b sm:border-b-0 shrink-0",
  titleText: "mb-0 h4 sm:h3",
  titleButton: `${buttonTextSizes.medium} ${buttonTypes.pill} ${buttonColors.pill} sm:min-h-[44px] sm:min-w-[44px] min-h-[32px] min-w-[32px]`,
  titleButtonLeft: "-ml-8 sm:-ml-12 justify-self-start",
  titleButtonRight: "-mr-8 sm:-mr-12 justify-self-end",
  titleButtonIcon: "h-16 w-16 sm:h-24 sm:w-24",
  titleButtonIconRotated: "transform rotate-90"
};
var alert = {
  alert: "flex p-16 border border-l-4 rounded-4 s-text",
  willChangeHeight: "will-change-height",
  textWrapper: "last-child:mb-0 text-s",
  title: "text-s",
  icon: "w-16 mr-8 min-w-16",
  negative: "s-border-negative-subtle s-border-l-negative s-bg-negative-subtle",
  negativeIcon: "s-icon-negative",
  positive: "s-border-positive-subtle s-border-l-positive s-bg-positive-subtle",
  positiveIcon: "s-icon-positive",
  warning: "s-border-warning-subtle s-border-l-warning s-bg-warning-subtle",
  warningIcon: "s-icon-warning",
  info: "s-border-info-subtle s-border-l-info s-bg-info-subtle",
  infoIcon: "s-icon-info"
};
var input = {
  default: "block text-m mb-0 leading-m s-text s-bg s-border hover:s-border-hover active:s-border-selected rounded-4 py-12 px-8 block border-1 w-full focusable focus:[--w-outline-offset:-2px] caret-current",
  textArea: "min-h-[42] sm:min-h-[45]",
  disabled: "s-bg-disabled-subtle s-border-disabled hover:s-border-disabled! s-text-disabled pointer-events-none",
  invalid: "s-border-negative s-text-negative!",
  readOnly: "pl-0 bg-transparent! border-0! pointer-events-none",
  placeholder: "placeholder:s-text-placeholder",
  wrapper: "relative",
  suffix: "pr-40",
  prefix: "pl-40"
};
var select = {
  default: "block text-m mb-0 leading-m s-text s-bg s-border hover:s-border-hover active:s-border-active rounded-4 py-12 px-8 block border-1 w-full focusable focus:[--w-outline-offset:-2px] appearance-none pr-32 cursor-pointer caret-current",
  disabled: "s-bg-disabled-subtle s-border-disabled hover:s-border-disabled! active:s-border-disabled! s-text-disabled pointer-events-none",
  invalid: "s-border-negative",
  readOnly: "pl-0 bg-transparent border-0 pointer-events-none before:hidden",
  wrapper: "relative",
  selectWrapper: `relative before:block before:absolute before:right-0 before:bottom-0 before:w-32 before:h-full before:pointer-events-none `,
  chevron: "absolute top-[30%] block right-0 bottom-0 w-32 h-full s-icon pointer-events-none cursor-pointer",
  chevronDisabled: "opacity-25"
};
var label = {
  label: "antialiased block relative text-s font-bold pb-4 cursor-pointer s-text",
  labelInvalid: "s-text-negative",
  optional: "pl-8 font-normal text-s s-text"
};
var helpText = {
  helpText: "text-xs mt-4 block s-text-subtle",
  helpTextValid: "s-text-positive",
  helpTextInvalid: "s-text-negative"
};
var prefixSuffixWrapperBase = "absolute top-0 bottom-0 flex justify-center items-center focusable focus:[--w-outline-offset:-2px] bg-transparent ";
var suffix = {
  wrapper: prefixSuffixWrapperBase + "right-0",
  wrapperWithLabel: "w-max pr-12",
  wrapperWithIcon: "w-40",
  label: "antialiased block relative cursor-default pb-0 font-bold text-xs s-text"
};
var prefix = {
  wrapper: prefixSuffixWrapperBase + "left-0",
  wrapperWithLabel: "w-max pl-12",
  wrapperWithIcon: "w-40",
  label: "antialiased block relative cursor-default pb-0 font-bold text-xs s-text"
};
var breadcrumbs = {
  wrapper: "flex space-x-8",
  text: "s-text",
  link: "s-text-link",
  separator: "select-none s-icon",
  a11y: "sr-only"
};
var toggle = {
  // wrapper classes
  field: "relative text-m",
  // true
  wrapper: "relative py-1",
  // true
  wrapperRadioButtons: "inline-flex font-bold rounded-8 focus-within:focusable",
  // isRadioButton && !isEqualWidth
  wrapperRadioButtonsJustified: "flex font-bold rounded-8 focus-within:focusable",
  // isRadioButton && isEqualWidth,
  // group classes
  radioButtonsGroup: "group",
  // isRadioButton
  radioButtonsGroupJustified: "grow-1 shrink-0 basis-auto",
  // isRadioButton && isEqualWidth
  // input classes
  input: "peer",
  a11y: "sr-only",
  // label classes
  label: "peer-focus:focusable cursor-pointer text-m s-text s-border py-2 pl-28 select-none relative block before:border before:absolute before:transition-all before:left-0 before:w-20 before:h-20 before:top-2",
  // !isRadioButton
  labelBefore: 'before:content-[""] before:block',
  // !isRadioButton && !isIndeterminate
  checkbox: "before:s-bg before:rounded-2 hover:before:s-border-primary hover:before:s-bg-subtle peer-checked:before:bg-center peer-checked:before:bg-[url(var(--w-form-check-mark))] peer-checked:before:s-border-primary peer-checked:before:s-bg-primary peer-checked:peer-hover:before:s-border-primary-hover peer-checked:peer-hover:before:s-bg-primary-hover",
  // isCheckbox && !isIndeterminate && !isInvalid && !isDisabled
  checkboxInvalid: "before:s-bg before:s-border-negative before:rounded-2 hover:before:s-bg-negative-subtle-hover hover:before:s-border-negative-hover peer-checked:before:bg-center peer-checked:before:bg-[url(var(--w-form-check-mark))] peer-checked:before:s-bg-negative peer-checked:before:s-border-negative peer-checked:peer-hover:before:s-bg-negative-hover peer-checked:peer-hover:before:s-border-negative-hover",
  // isCheckbox && !isIndeterminate && isInvalid && !isDisabled
  checkboxDisabled: "before:s-bg-disabled-subtle before:s-border-disabled pointer-events-none before:rounded-2 peer-checked:before:bg-center peer-checked:before:bg-[url(var(--w-form-check-mark))] peer-checked:before:s-border-disabled peer-checked:before:s-bg-disabled",
  // isCheckbox && !isIndeterminate && !isInvalid && isDisabled
  indeterminate: 'before:content-["\u2013"] before:rounded-2 before:leading-xs before:text-center before:font-bold before:s-icon-inverted peer-indeterminate:before:s-border-primary peer-indeterminate:before:s-bg-primary peer-indeterminate:hover:before:s-border-primary-hover peer-indeterminate:hover:before:s-bg-primary-hover',
  // isCheckbox && isIndeterminate && !isInvalid && !isDisabled
  indeterminateInvalid: 'before:content-["\u2013"] before:rounded-2 before:leading-xs before:text-center before:font-bold before:s-icon-inverted peer-indeterminate:before:s-border-negative peer-indeterminate:before:s-bg-negative peer-indeterminate:hover:before:s-border-negative-hover peer-indeterminate:hover:before:s-bg-negative-hover',
  // isCheckbox && isIndeterminate && isInvalid && !isDisabled
  indeterminateDisabled: 'before:content-["\u2013"] before:rounded-2 before:leading-xs before:text-center before:font-bold pointer-events-none before:s-icon-inverted peer-indeterminate:before:s-border-disabled peer-indeterminate:before:s-bg-disabled',
  // isCheckbox && isIndeterminate && !isInvalid && isDisabled
  radio: "before:s-bg before:rounded-full peer-checked:before:border-[6] peer-checked:before:s-border-selected peer-checked:peer-hover:before:s-border-selected-hover peer-hover:before:s-border-primary peer-hover:before:s-bg-primary-subtle",
  // isRadio && !isDisabled && !isInvalid
  radioInvalid: "before:s-bg before:s-border-negative before:rounded-full peer-checked:before:border-[6] peer-hover:before:s-bg-negative-subtle peer-hover:before:s-border-negative-hover peer-checked:before:s-border-negative peer-checked:peer-hover:before:s-border-negative-hover",
  // isRadio && isInvalid && !isDisabled
  radioDisabled: "before:s-bg-disabled-subtle before:s-border-disabled pointer-events-none before:rounded-full peer-checked:before:border-[6]",
  // isRadio && !isInvalid && isDisabled
  radioButtonsLabel: "peer-hover:peer-not-checked:s-bg-hover peer-checked:s-text-inverted peer-checked:s-bg-primary peer-checked:s-border-primary block relative font-bold cursor-pointer s-text-link text-center s-bg border-2 s-border group-first-of-type:rounded-tl-8 group-first-of-type:rounded-bl-8 group-last-of-type:rounded-tr-8 group-last-of-type:rounded-br-8 group-not-last-of-type:border-r-0 peer-checked:z-10 group-not-first:-ml-2",
  // isRadioButtons
  radioButtonsRegular: "text-s py-8 pl-12 pr-14",
  // isRadioButtons && !isSmall
  radioButtonsSmall: "text-xs py-[5px] px-[8px]"
  // isRadioButtons && isSmall
};
var deadToggle = {
  wrapper: `${toggle.wrapper} h-20 w-20 pointer-events-none`,
  input: `${toggle.input} hidden`,
  inputVue: "hidden",
  labelRadio: `${toggle.label} ${toggle.labelBefore} ${toggle.radio}`,
  labelCheckbox: `${toggle.label} ${toggle.labelBefore} ${toggle.checkbox}`,
  labelVue: "-mt-2"
};
var clickable = {
  toggle: "absolute inset-0 h-full w-full appearance-none cursor-pointer focusable focusable-inset",
  label: `px-12 ${label.label} py-8! cursor-pointer focusable focusable-inset`,
  buttonOrLink: "bg-transparent focusable",
  buttonOrLinkStretch: "inset-0 absolute"
};
var combobox = {
  wrapper: "relative",
  combobox: "absolute left-0 right-0 pb-8 rounded-8 s-bg shadow-m",
  textMatch: "font-bold",
  listbox: "m-0 p-0 select-none list-none",
  option: "block cursor-pointer p-8 hover:s-bg-hover",
  optionSelected: "s-bg-selected hover:s-bg-selected-hover",
  a11y: "sr-only"
};
var attention = {
  base: "border-2 relative flex items-start",
  tooltip: "s-bg-inverted border-[--w-s-color-background-inverted] shadow-m s-text-inverted rounded-4 py-6 px-8",
  callout: "bg-[--w-color-callout-background] border-[--w-color-callout-border] s-text py-8 px-16 rounded-8",
  highlight: "bg-[--w-color-callout-background] border-[--w-color-callout-border] s-text py-8 px-16 rounded-8 drop-shadow-m",
  popover: "s-bg border-[--w-s-color-background] s-text rounded-8 p-16 drop-shadow-m",
  arrowBase: "absolute h-[14px] w-[14px] border-2 border-b-0 border-r-0 rounded-tl-4 transform",
  arrowDirectionLeft: "-left-[8px]",
  arrowDirectionRight: "-right-[8px]",
  arrowDirectionBottom: "-bottom-[8px]",
  arrowDirectionTop: "-top-[8px]",
  arrowTooltip: "s-bg-inverted border-[--w-s-color-background-inverted]",
  arrowCallout: "bg-[--w-color-callout-background] border-[--w-color-callout-border]",
  arrowPopover: "s-bg border-[--w-s-color-background]",
  arrowHighlight: "bg-[--w-color-callout-background] border-[--w-color-callout-border]",
  content: "last-child:mb-0",
  notCallout: "absolute z-50",
  closeBtn: `${buttonTextSizes.medium} ${buttonTypes.pill} ${buttonColors.pill} justify-self-end -mr-8 ml-8`
};
var pagination = {
  link: "hover:no-underline focus:no-underline focusable inline-flex justify-center items-center transition-colors ease-in-out min-h-[44px] min-w-[44px] p-4 rounded-full border-0 hover:bg-clip-padding",
  currentPage: "block md:hidden p-8 font-bold",
  icon: "s-icon hover:bg-[--w-color-button-pill-background-hover] active:bg-[--w-color-button-pill-background-active]",
  containerNav: "flex items-center justify-center p-8",
  a11y: "sr-only",
  pages: "hidden md:block s-text-link",
  active: "s-bg-primary s-text-inverted",
  notActive: "hover:bg-[--w-color-button-pill-background-hover] active:bg-[--w-color-button-pill-background-active]"
};

// packages/toggle/src/item.tsx
import React3 from "react";

// packages/utils/src/useElementSizeObserver.ts
import { useCallback, useState } from "react";

// node_modules/.pnpm/resize-observer-polyfill@1.5.1/node_modules/resize-observer-polyfill/dist/ResizeObserver.es.js
var MapShim = function() {
  if (typeof Map !== "undefined") {
    return Map;
  }
  function getIndex(arr, key) {
    var result = -1;
    arr.some(function(entry, index2) {
      if (entry[0] === key) {
        result = index2;
        return true;
      }
      return false;
    });
    return result;
  }
  return (
    /** @class */
    function() {
      function class_1() {
        this.__entries__ = [];
      }
      Object.defineProperty(class_1.prototype, "size", {
        /**
         * @returns {boolean}
         */
        get: function() {
          return this.__entries__.length;
        },
        enumerable: true,
        configurable: true
      });
      class_1.prototype.get = function(key) {
        var index2 = getIndex(this.__entries__, key);
        var entry = this.__entries__[index2];
        return entry && entry[1];
      };
      class_1.prototype.set = function(key, value) {
        var index2 = getIndex(this.__entries__, key);
        if (~index2) {
          this.__entries__[index2][1] = value;
        } else {
          this.__entries__.push([key, value]);
        }
      };
      class_1.prototype.delete = function(key) {
        var entries = this.__entries__;
        var index2 = getIndex(entries, key);
        if (~index2) {
          entries.splice(index2, 1);
        }
      };
      class_1.prototype.has = function(key) {
        return !!~getIndex(this.__entries__, key);
      };
      class_1.prototype.clear = function() {
        this.__entries__.splice(0);
      };
      class_1.prototype.forEach = function(callback, ctx) {
        if (ctx === void 0) {
          ctx = null;
        }
        for (var _i = 0, _a = this.__entries__; _i < _a.length; _i++) {
          var entry = _a[_i];
          callback.call(ctx, entry[1], entry[0]);
        }
      };
      return class_1;
    }()
  );
}();
var isBrowser = typeof window !== "undefined" && typeof document !== "undefined" && window.document === document;
var global$1 = function() {
  if (typeof global !== "undefined" && global.Math === Math) {
    return global;
  }
  if (typeof self !== "undefined" && self.Math === Math) {
    return self;
  }
  if (typeof window !== "undefined" && window.Math === Math) {
    return window;
  }
  return Function("return this")();
}();
var requestAnimationFrame$1 = function() {
  if (typeof requestAnimationFrame === "function") {
    return requestAnimationFrame.bind(global$1);
  }
  return function(callback) {
    return setTimeout(function() {
      return callback(Date.now());
    }, 1e3 / 60);
  };
}();
var trailingTimeout = 2;
function throttle(callback, delay) {
  var leadingCall = false, trailingCall = false, lastCallTime = 0;
  function resolvePending() {
    if (leadingCall) {
      leadingCall = false;
      callback();
    }
    if (trailingCall) {
      proxy();
    }
  }
  function timeoutCallback() {
    requestAnimationFrame$1(resolvePending);
  }
  function proxy() {
    var timeStamp = Date.now();
    if (leadingCall) {
      if (timeStamp - lastCallTime < trailingTimeout) {
        return;
      }
      trailingCall = true;
    } else {
      leadingCall = true;
      trailingCall = false;
      setTimeout(timeoutCallback, delay);
    }
    lastCallTime = timeStamp;
  }
  return proxy;
}
var REFRESH_DELAY = 20;
var transitionKeys = ["top", "right", "bottom", "left", "width", "height", "size", "weight"];
var mutationObserverSupported = typeof MutationObserver !== "undefined";
var ResizeObserverController = (
  /** @class */
  function() {
    function ResizeObserverController2() {
      this.connected_ = false;
      this.mutationEventsAdded_ = false;
      this.mutationsObserver_ = null;
      this.observers_ = [];
      this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
      this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
    }
    ResizeObserverController2.prototype.addObserver = function(observer) {
      if (!~this.observers_.indexOf(observer)) {
        this.observers_.push(observer);
      }
      if (!this.connected_) {
        this.connect_();
      }
    };
    ResizeObserverController2.prototype.removeObserver = function(observer) {
      var observers2 = this.observers_;
      var index2 = observers2.indexOf(observer);
      if (~index2) {
        observers2.splice(index2, 1);
      }
      if (!observers2.length && this.connected_) {
        this.disconnect_();
      }
    };
    ResizeObserverController2.prototype.refresh = function() {
      var changesDetected = this.updateObservers_();
      if (changesDetected) {
        this.refresh();
      }
    };
    ResizeObserverController2.prototype.updateObservers_ = function() {
      var activeObservers = this.observers_.filter(function(observer) {
        return observer.gatherActive(), observer.hasActive();
      });
      activeObservers.forEach(function(observer) {
        return observer.broadcastActive();
      });
      return activeObservers.length > 0;
    };
    ResizeObserverController2.prototype.connect_ = function() {
      if (!isBrowser || this.connected_) {
        return;
      }
      document.addEventListener("transitionend", this.onTransitionEnd_);
      window.addEventListener("resize", this.refresh);
      if (mutationObserverSupported) {
        this.mutationsObserver_ = new MutationObserver(this.refresh);
        this.mutationsObserver_.observe(document, {
          attributes: true,
          childList: true,
          characterData: true,
          subtree: true
        });
      } else {
        document.addEventListener("DOMSubtreeModified", this.refresh);
        this.mutationEventsAdded_ = true;
      }
      this.connected_ = true;
    };
    ResizeObserverController2.prototype.disconnect_ = function() {
      if (!isBrowser || !this.connected_) {
        return;
      }
      document.removeEventListener("transitionend", this.onTransitionEnd_);
      window.removeEventListener("resize", this.refresh);
      if (this.mutationsObserver_) {
        this.mutationsObserver_.disconnect();
      }
      if (this.mutationEventsAdded_) {
        document.removeEventListener("DOMSubtreeModified", this.refresh);
      }
      this.mutationsObserver_ = null;
      this.mutationEventsAdded_ = false;
      this.connected_ = false;
    };
    ResizeObserverController2.prototype.onTransitionEnd_ = function(_a) {
      var _b = _a.propertyName, propertyName = _b === void 0 ? "" : _b;
      var isReflowProperty = transitionKeys.some(function(key) {
        return !!~propertyName.indexOf(key);
      });
      if (isReflowProperty) {
        this.refresh();
      }
    };
    ResizeObserverController2.getInstance = function() {
      if (!this.instance_) {
        this.instance_ = new ResizeObserverController2();
      }
      return this.instance_;
    };
    ResizeObserverController2.instance_ = null;
    return ResizeObserverController2;
  }()
);
var defineConfigurable = function(target, props) {
  for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
    var key = _a[_i];
    Object.defineProperty(target, key, {
      value: props[key],
      enumerable: false,
      writable: false,
      configurable: true
    });
  }
  return target;
};
var getWindowOf = function(target) {
  var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
  return ownerGlobal || global$1;
};
var emptyRect = createRectInit(0, 0, 0, 0);
function toFloat(value) {
  return parseFloat(value) || 0;
}
function getBordersSize(styles) {
  var positions = [];
  for (var _i = 1; _i < arguments.length; _i++) {
    positions[_i - 1] = arguments[_i];
  }
  return positions.reduce(function(size, position) {
    var value = styles["border-" + position + "-width"];
    return size + toFloat(value);
  }, 0);
}
function getPaddings(styles) {
  var positions = ["top", "right", "bottom", "left"];
  var paddings = {};
  for (var _i = 0, positions_1 = positions; _i < positions_1.length; _i++) {
    var position = positions_1[_i];
    var value = styles["padding-" + position];
    paddings[position] = toFloat(value);
  }
  return paddings;
}
function getSVGContentRect(target) {
  var bbox = target.getBBox();
  return createRectInit(0, 0, bbox.width, bbox.height);
}
function getHTMLElementContentRect(target) {
  var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
  if (!clientWidth && !clientHeight) {
    return emptyRect;
  }
  var styles = getWindowOf(target).getComputedStyle(target);
  var paddings = getPaddings(styles);
  var horizPad = paddings.left + paddings.right;
  var vertPad = paddings.top + paddings.bottom;
  var width = toFloat(styles.width), height = toFloat(styles.height);
  if (styles.boxSizing === "border-box") {
    if (Math.round(width + horizPad) !== clientWidth) {
      width -= getBordersSize(styles, "left", "right") + horizPad;
    }
    if (Math.round(height + vertPad) !== clientHeight) {
      height -= getBordersSize(styles, "top", "bottom") + vertPad;
    }
  }
  if (!isDocumentElement(target)) {
    var vertScrollbar = Math.round(width + horizPad) - clientWidth;
    var horizScrollbar = Math.round(height + vertPad) - clientHeight;
    if (Math.abs(vertScrollbar) !== 1) {
      width -= vertScrollbar;
    }
    if (Math.abs(horizScrollbar) !== 1) {
      height -= horizScrollbar;
    }
  }
  return createRectInit(paddings.left, paddings.top, width, height);
}
var isSVGGraphicsElement = function() {
  if (typeof SVGGraphicsElement !== "undefined") {
    return function(target) {
      return target instanceof getWindowOf(target).SVGGraphicsElement;
    };
  }
  return function(target) {
    return target instanceof getWindowOf(target).SVGElement && typeof target.getBBox === "function";
  };
}();
function isDocumentElement(target) {
  return target === getWindowOf(target).document.documentElement;
}
function getContentRect(target) {
  if (!isBrowser) {
    return emptyRect;
  }
  if (isSVGGraphicsElement(target)) {
    return getSVGContentRect(target);
  }
  return getHTMLElementContentRect(target);
}
function createReadOnlyRect(_a) {
  var x3 = _a.x, y4 = _a.y, width = _a.width, height = _a.height;
  var Constr = typeof DOMRectReadOnly !== "undefined" ? DOMRectReadOnly : Object;
  var rect = Object.create(Constr.prototype);
  defineConfigurable(rect, {
    x: x3,
    y: y4,
    width,
    height,
    top: y4,
    right: x3 + width,
    bottom: height + y4,
    left: x3
  });
  return rect;
}
function createRectInit(x3, y4, width, height) {
  return { x: x3, y: y4, width, height };
}
var ResizeObservation = (
  /** @class */
  function() {
    function ResizeObservation2(target) {
      this.broadcastWidth = 0;
      this.broadcastHeight = 0;
      this.contentRect_ = createRectInit(0, 0, 0, 0);
      this.target = target;
    }
    ResizeObservation2.prototype.isActive = function() {
      var rect = getContentRect(this.target);
      this.contentRect_ = rect;
      return rect.width !== this.broadcastWidth || rect.height !== this.broadcastHeight;
    };
    ResizeObservation2.prototype.broadcastRect = function() {
      var rect = this.contentRect_;
      this.broadcastWidth = rect.width;
      this.broadcastHeight = rect.height;
      return rect;
    };
    return ResizeObservation2;
  }()
);
var ResizeObserverEntry = (
  /** @class */
  /* @__PURE__ */ function() {
    function ResizeObserverEntry2(target, rectInit) {
      var contentRect = createReadOnlyRect(rectInit);
      defineConfigurable(this, { target, contentRect });
    }
    return ResizeObserverEntry2;
  }()
);
var ResizeObserverSPI = (
  /** @class */
  function() {
    function ResizeObserverSPI2(callback, controller, callbackCtx) {
      this.activeObservations_ = [];
      this.observations_ = new MapShim();
      if (typeof callback !== "function") {
        throw new TypeError("The callback provided as parameter 1 is not a function.");
      }
      this.callback_ = callback;
      this.controller_ = controller;
      this.callbackCtx_ = callbackCtx;
    }
    ResizeObserverSPI2.prototype.observe = function(target) {
      if (!arguments.length) {
        throw new TypeError("1 argument required, but only 0 present.");
      }
      if (typeof Element === "undefined" || !(Element instanceof Object)) {
        return;
      }
      if (!(target instanceof getWindowOf(target).Element)) {
        throw new TypeError('parameter 1 is not of type "Element".');
      }
      var observations = this.observations_;
      if (observations.has(target)) {
        return;
      }
      observations.set(target, new ResizeObservation(target));
      this.controller_.addObserver(this);
      this.controller_.refresh();
    };
    ResizeObserverSPI2.prototype.unobserve = function(target) {
      if (!arguments.length) {
        throw new TypeError("1 argument required, but only 0 present.");
      }
      if (typeof Element === "undefined" || !(Element instanceof Object)) {
        return;
      }
      if (!(target instanceof getWindowOf(target).Element)) {
        throw new TypeError('parameter 1 is not of type "Element".');
      }
      var observations = this.observations_;
      if (!observations.has(target)) {
        return;
      }
      observations.delete(target);
      if (!observations.size) {
        this.controller_.removeObserver(this);
      }
    };
    ResizeObserverSPI2.prototype.disconnect = function() {
      this.clearActive();
      this.observations_.clear();
      this.controller_.removeObserver(this);
    };
    ResizeObserverSPI2.prototype.gatherActive = function() {
      var _this = this;
      this.clearActive();
      this.observations_.forEach(function(observation) {
        if (observation.isActive()) {
          _this.activeObservations_.push(observation);
        }
      });
    };
    ResizeObserverSPI2.prototype.broadcastActive = function() {
      if (!this.hasActive()) {
        return;
      }
      var ctx = this.callbackCtx_;
      var entries = this.activeObservations_.map(function(observation) {
        return new ResizeObserverEntry(observation.target, observation.broadcastRect());
      });
      this.callback_.call(ctx, entries, ctx);
      this.clearActive();
    };
    ResizeObserverSPI2.prototype.clearActive = function() {
      this.activeObservations_.splice(0);
    };
    ResizeObserverSPI2.prototype.hasActive = function() {
      return this.activeObservations_.length > 0;
    };
    return ResizeObserverSPI2;
  }()
);
var observers = typeof WeakMap !== "undefined" ? /* @__PURE__ */ new WeakMap() : new MapShim();
var ResizeObserver2 = (
  /** @class */
  /* @__PURE__ */ function() {
    function ResizeObserver3(callback) {
      if (!(this instanceof ResizeObserver3)) {
        throw new TypeError("Cannot call a class as a function.");
      }
      if (!arguments.length) {
        throw new TypeError("1 argument required, but only 0 present.");
      }
      var controller = ResizeObserverController.getInstance();
      var observer = new ResizeObserverSPI(callback, controller, this);
      observers.set(this, observer);
    }
    return ResizeObserver3;
  }()
);
[
  "observe",
  "unobserve",
  "disconnect"
].forEach(function(method) {
  ResizeObserver2.prototype[method] = function() {
    var _a;
    return (_a = observers.get(this))[method].apply(_a, arguments);
  };
});
var index = function() {
  if (typeof global$1.ResizeObserver !== "undefined") {
    return global$1.ResizeObserver;
  }
  return ResizeObserver2;
}();

// packages/utils/src/useIsomorphicLayoutEffect.ts
import { useLayoutEffect as useLayoutEffectSafely, useEffect } from "react";
var useLayoutEffect = typeof window !== "undefined" ? useLayoutEffectSafely : useEffect;

// packages/utils/src/useId.ts
import React2 from "react";
var useReactId = React2.useId;
var useId = (hasFallback) => {
  if (hasFallback) {
    return hasFallback;
  }
  if (typeof useReactId === "function") {
    return useReactId().replace(/:/g, "");
  } else {
    const [elId] = React2.useState(generateId());
    return elId;
  }
};
function generateId() {
  return Date.now().toString(36) + Math.random().toString(36).slice(2, 5);
}

// packages/utils/src/useLogDeprecationWarning.ts
import { useEffect as useEffect2, useRef } from "react";
var useLogDeprecationWarning = ({
  condition,
  message
}) => {
  const loggedOnce = useRef(false);
  useEffect2(() => {
    if (loggedOnce.current) {
      return;
    }
    if (condition) {
      console.warn(message);
      loggedOnce.current = true;
    }
  }, [condition, message]);
};

// packages/toggle/src/item.tsx
function Item(_a) {
  var _b = _a, {
    controlled,
    option,
    children,
    label: label2,
    invalid,
    value,
    helpId,
    indeterminate = false,
    checked,
    defaultChecked,
    noVisibleLabel,
    labelClassName,
    inputClassName,
    groupClassName,
    multiple
  } = _b, props = __objRest(_b, [
    "controlled",
    "option",
    "children",
    "label",
    "invalid",
    "value",
    "helpId",
    "indeterminate",
    "checked",
    "defaultChecked",
    "noVisibleLabel",
    "labelClassName",
    "inputClassName",
    "groupClassName",
    "multiple"
  ]);
  const id = useId();
  const checkboxRef = React3.useRef(null);
  const labelContent = !children ? label2 || (option == null ? void 0 : option.label) : children;
  React3.useEffect(() => {
    if (!checkboxRef.current) {
      return;
    }
    checkboxRef.current.indeterminate = indeterminate;
  }, [indeterminate, checkboxRef]);
  const Item2 = /* @__PURE__ */ React3.createElement(React3.Fragment, null, /* @__PURE__ */ React3.createElement(
    "input",
    __spreadProps(__spreadValues({
      ref: checkboxRef,
      id,
      checked: controlled ? checked : void 0,
      defaultChecked,
      "aria-invalid": invalid,
      "aria-errormessage": invalid ? helpId : void 0,
      value: label2 ? void 0 : value != null ? value : void 0,
      className: inputClassName
    }, props), {
      onChange: (e2) => props.onChange(
        label2 ? e2.target.checked : option ? { label: option == null ? void 0 : option.label, value: option == null ? void 0 : option.value } : false
      )
    })
  ), /* @__PURE__ */ React3.createElement("label", { htmlFor: id, className: labelClassName }, noVisibleLabel ? /* @__PURE__ */ React3.createElement("span", { className: toggle.a11y }, labelContent) : labelContent));
  if (multiple) {
    return /* @__PURE__ */ React3.createElement("div", { className: groupClassName }, Item2);
  }
  return Item2;
}

// packages/_helpers/clickable.tsx
function Clickable(_a) {
  var _b = _a, {
    children,
    radio,
    checkbox,
    value
  } = _b, props = __objRest(_b, [
    "children",
    "radio",
    "checkbox",
    "value"
  ]);
  const id = useId();
  const type = radio ? "radio" : "checkbox";
  return radio || checkbox ? /* @__PURE__ */ React4.createElement(
    Item,
    {
      labelClassName: r(props.labelClassName),
      className: clickable.toggle,
      type,
      controlled: false,
      onChange: props.onClick ? props.onClick : () => void 0,
      value,
      name: `${props.name || id}:toggle`
    },
    children
  ) : React4.createElement(
    props.href ? "a" : "button",
    __spreadProps(__spreadValues({}, props), {
      className: r(clickable.buttonOrLink, props.className),
      type: props.href ? void 0 : props.type || "button"
    }),
    /* @__PURE__ */ React4.createElement(React4.Fragment, null, /* @__PURE__ */ React4.createElement("span", { className: clickable.buttonOrLinkStretch, "aria-hidden": "true" }), children)
  );
}

// packages/_helpers/dead-toggle.tsx
import React5 from "react";
function DeadToggle(props) {
  const type = props.radio ? "radio" : "checkbox";
  return /* @__PURE__ */ React5.createElement(
    "div",
    {
      className: r(props.className, deadToggle.wrapper),
      "aria-hidden": "true"
    },
    /* @__PURE__ */ React5.createElement(
      Item,
      {
        type,
        inputClassName: deadToggle.input,
        labelClassName: r(props.labelClassName, {
          [deadToggle.labelRadio]: props.radio,
          [deadToggle.labelCheckbox]: props.checkbox
        }),
        name: "dead-toggle",
        controlled: true,
        onChange: () => void 0,
        value: props.value,
        checked: props.checked
      }
    )
  );
}

// packages/_helpers/affix.tsx
import React8 from "react";

// node_modules/.pnpm/@warp-ds+icons@2.0.0/node_modules/@warp-ds/icons/dist/react/close-16.js
import React6 from "react";

// node_modules/.pnpm/@lingui+core@4.7.0/node_modules/@lingui/core/dist/index.mjs
var import_unraw = __toESM(require_dist(), 1);

// node_modules/.pnpm/@lingui+message-utils@4.7.0/node_modules/@lingui/message-utils/dist/compileMessage.mjs
var import_parser = __toESM(require_parser(), 1);
function processTokens(tokens, mapText) {
  if (!tokens.filter((token) => token.type !== "content").length) {
    return tokens.map((token) => mapText(token.value)).join("");
  }
  return tokens.map((token) => {
    var _a;
    if (token.type === "content") {
      return mapText(token.value);
    } else if (token.type === "octothorpe") {
      return "#";
    } else if (token.type === "argument") {
      return [token.arg];
    } else if (token.type === "function") {
      const _param = (_a = token == null ? void 0 : token.param) == null ? void 0 : _a[0];
      if (_param) {
        return [token.arg, token.key, _param.value.trim()];
      } else {
        return [token.arg, token.key];
      }
    }
    const offset = token.pluralOffset;
    const formatProps = {};
    token.cases.forEach((item) => {
      formatProps[item.key.replace(/^=(.)+/, "$1")] = processTokens(
        item.tokens,
        mapText
      );
    });
    return [
      token.arg,
      token.type,
      __spreadValues({
        offset
      }, formatProps)
    ];
  });
}
function compileMessage(message, mapText = (v3) => v3) {
  try {
    return processTokens((0, import_parser.parse)(message), mapText);
  } catch (e2) {
    console.error(`${e2.message} 

Message: ${message}`);
    return message;
  }
}

// node_modules/.pnpm/@lingui+core@4.7.0/node_modules/@lingui/core/dist/index.mjs
var isString = (s3) => typeof s3 === "string";
var isFunction = (f4) => typeof f4 === "function";
var cache = /* @__PURE__ */ new Map();
var defaultLocale = "en";
function normalizeLocales(locales) {
  const out = Array.isArray(locales) ? locales : [locales];
  return [...out, defaultLocale];
}
function date(locales, value, format) {
  const _locales = normalizeLocales(locales);
  const formatter = getMemoized(
    () => cacheKey("date", _locales, format),
    () => new Intl.DateTimeFormat(_locales, format)
  );
  return formatter.format(isString(value) ? new Date(value) : value);
}
function number(locales, value, format) {
  const _locales = normalizeLocales(locales);
  const formatter = getMemoized(
    () => cacheKey("number", _locales, format),
    () => new Intl.NumberFormat(_locales, format)
  );
  return formatter.format(value);
}
function plural(locales, ordinal, value, _a) {
  var _b = _a, { offset = 0 } = _b, rules = __objRest(_b, ["offset"]);
  var _a2, _b2;
  const _locales = normalizeLocales(locales);
  const plurals = ordinal ? getMemoized(
    () => cacheKey("plural-ordinal", _locales),
    () => new Intl.PluralRules(_locales, { type: "ordinal" })
  ) : getMemoized(
    () => cacheKey("plural-cardinal", _locales),
    () => new Intl.PluralRules(_locales, { type: "cardinal" })
  );
  return (_b2 = (_a2 = rules[value]) != null ? _a2 : rules[plurals.select(value - offset)]) != null ? _b2 : rules.other;
}
function getMemoized(getKey, construct) {
  const key = getKey();
  let formatter = cache.get(key);
  if (!formatter) {
    formatter = construct();
    cache.set(key, formatter);
  }
  return formatter;
}
function cacheKey(type, locales, options) {
  const localeKey = locales.join("-");
  return `${type}-${localeKey}-${JSON.stringify(options)}`;
}
var UNICODE_REGEX = /\\u[a-fA-F0-9]{4}|\\x[a-fA-F0-9]{2}/g;
var getDefaultFormats = (locale, passedLocales, formats = {}) => {
  const locales = passedLocales || locale;
  const style = (format) => {
    return typeof format === "object" ? format : formats[format] || { style: format };
  };
  const replaceOctothorpe = (value, message) => {
    const numberFormat = Object.keys(formats).length ? style("number") : void 0;
    const valueStr = number(locales, value, numberFormat);
    return message.replace("#", valueStr);
  };
  return {
    plural: (value, cases) => {
      const { offset = 0 } = cases;
      const message = plural(locales, false, value, cases);
      return replaceOctothorpe(value - offset, message);
    },
    selectordinal: (value, cases) => {
      const { offset = 0 } = cases;
      const message = plural(locales, true, value, cases);
      return replaceOctothorpe(value - offset, message);
    },
    select: selectFormatter,
    number: (value, format) => number(locales, value, style(format)),
    date: (value, format) => date(locales, value, style(format)),
    undefined: undefinedFormatter
  };
};
var selectFormatter = (value, rules) => {
  var _a;
  return (_a = rules[value]) != null ? _a : rules.other;
};
var undefinedFormatter = (value) => value;
function interpolate(translation, locale, locales) {
  return (values = {}, formats) => {
    const formatters = getDefaultFormats(locale, locales, formats);
    const formatMessage = (message) => {
      if (!Array.isArray(message))
        return message;
      return message.reduce((message2, token) => {
        if (isString(token))
          return message2 + token;
        const [name, type, format] = token;
        let interpolatedFormat = {};
        if (format != null && typeof format === "object") {
          Object.entries(format).forEach(([key, value2]) => {
            interpolatedFormat[key] = formatMessage(value2);
          });
        } else {
          interpolatedFormat = format;
        }
        const formatter = formatters[type];
        const value = formatter(values[name], interpolatedFormat);
        if (value == null)
          return message2;
        return message2 + value;
      }, "");
    };
    const result = formatMessage(translation);
    if (isString(result) && UNICODE_REGEX.test(result)) {
      return (0, import_unraw.default)(result.trim());
    }
    if (isString(result))
      return result.trim();
    return result ? String(result) : "";
  };
}
var __defProp$1 = Object.defineProperty;
var __defNormalProp$1 = (obj, key, value) => key in obj ? __defProp$1(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField$1 = (obj, key, value) => {
  __defNormalProp$1(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
var EventEmitter = class {
  constructor() {
    __publicField$1(this, "_events", {});
  }
  on(event, listener) {
    var _a2;
    var _a;
    (_a2 = (_a = this._events)[event]) != null ? _a2 : _a[event] = [];
    this._events[event].push(listener);
    return () => this.removeListener(event, listener);
  }
  removeListener(event, listener) {
    const maybeListeners = this._getListeners(event);
    if (!maybeListeners)
      return;
    const index2 = maybeListeners.indexOf(listener);
    if (~index2)
      maybeListeners.splice(index2, 1);
  }
  emit(event, ...args) {
    const maybeListeners = this._getListeners(event);
    if (!maybeListeners)
      return;
    maybeListeners.map((listener) => listener.apply(this, args));
  }
  _getListeners(event) {
    const maybeListeners = this._events[event];
    return Array.isArray(maybeListeners) ? maybeListeners : false;
  }
};
var __defProp2 = Object.defineProperty;
var __defNormalProp2 = (obj, key, value) => key in obj ? __defProp2(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp2(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
var I18n = class extends EventEmitter {
  constructor(params) {
    var _a;
    super();
    __publicField(this, "_locale", "");
    __publicField(this, "_locales");
    __publicField(this, "_localeData", {});
    __publicField(this, "_messages", {});
    __publicField(this, "_missing");
    __publicField(this, "t", this._.bind(this));
    if (params.missing != null)
      this._missing = params.missing;
    if (params.messages != null)
      this.load(params.messages);
    if (params.localeData != null)
      this.loadLocaleData(params.localeData);
    if (typeof params.locale === "string" || params.locales) {
      this.activate((_a = params.locale) != null ? _a : defaultLocale, params.locales);
    }
  }
  get locale() {
    return this._locale;
  }
  get locales() {
    return this._locales;
  }
  get messages() {
    var _a;
    return (_a = this._messages[this._locale]) != null ? _a : {};
  }
  /**
   * @deprecated this has no effect. Please remove this from the code. Deprecated in v4
   */
  get localeData() {
    var _a;
    return (_a = this._localeData[this._locale]) != null ? _a : {};
  }
  _loadLocaleData(locale, localeData) {
    const maybeLocaleData = this._localeData[locale];
    if (!maybeLocaleData) {
      this._localeData[locale] = localeData;
    } else {
      Object.assign(maybeLocaleData, localeData);
    }
  }
  /**
   * @deprecated Plurals automatically used from Intl.PluralRules you can safely remove this call. Deprecated in v4
   */
  // @ts-ignore deprecated, so ignore the reported error
  loadLocaleData(localeOrAllData, localeData) {
    if (localeData != null) {
      this._loadLocaleData(localeOrAllData, localeData);
    } else {
      Object.keys(localeOrAllData).forEach(
        (locale) => this._loadLocaleData(locale, localeOrAllData[locale])
      );
    }
    this.emit("change");
  }
  _load(locale, messages64) {
    const maybeMessages = this._messages[locale];
    if (!maybeMessages) {
      this._messages[locale] = messages64;
    } else {
      Object.assign(maybeMessages, messages64);
    }
  }
  load(localeOrMessages, messages64) {
    if (typeof localeOrMessages == "string" && typeof messages64 === "object") {
      this._load(localeOrMessages, messages64);
    } else {
      Object.entries(localeOrMessages).forEach(
        ([locale, messages217]) => this._load(locale, messages217)
      );
    }
    this.emit("change");
  }
  /**
   * @param options {@link LoadAndActivateOptions}
   */
  loadAndActivate({ locale, locales, messages: messages64 }) {
    this._locale = locale;
    this._locales = locales || void 0;
    this._messages[this._locale] = messages64;
    this.emit("change");
  }
  activate(locale, locales) {
    if (true) {
      if (!this._messages[locale]) {
        console.warn(`Messages for locale "${locale}" not loaded.`);
      }
    }
    this._locale = locale;
    this._locales = locales;
    this.emit("change");
  }
  _(id, values, options) {
    let message = options == null ? void 0 : options.message;
    if (!isString(id)) {
      values = id.values || values;
      message = id.message;
      id = id.id;
    }
    const messageForId = this.messages[id];
    const messageMissing = messageForId === void 0;
    const missing = this._missing;
    if (missing && messageMissing) {
      return isFunction(missing) ? missing(this._locale, id) : missing;
    }
    if (messageMissing) {
      this.emit("missing", { id, locale: this._locale });
    }
    let translation = messageForId || message || id;
    if (true) {
      translation = isString(translation) ? compileMessage(translation) : translation;
    }
    if (isString(translation) && UNICODE_REGEX.test(translation))
      return JSON.parse(`"${translation}"`);
    if (isString(translation))
      return translation;
    return interpolate(
      translation,
      this._locale,
      this._locales
    )(values, options == null ? void 0 : options.formats);
  }
  date(value, format) {
    return date(this._locales || this._locale, value, format);
  }
  number(value, format) {
    return number(this._locales || this._locale, value, format);
  }
};
function setupI18n(params = {}) {
  return new I18n(params);
}
var i18n = setupI18n();

// node_modules/.pnpm/@warp-ds+icons@2.0.0/node_modules/@warp-ds/icons/dist/react/close-16.js
var __defProp3 = Object.defineProperty;
var __getOwnPropSymbols2 = Object.getOwnPropertySymbols;
var __hasOwnProp2 = Object.prototype.hasOwnProperty;
var __propIsEnum2 = Object.prototype.propertyIsEnumerable;
var __defNormalProp3 = (obj, key, value) => key in obj ? __defProp3(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues2 = (a4, b4) => {
  for (var prop in b4 || (b4 = {}))
    if (__hasOwnProp2.call(b4, prop))
      __defNormalProp3(a4, prop, b4[prop]);
  if (__getOwnPropSymbols2)
    for (var prop of __getOwnPropSymbols2(b4)) {
      if (__propIsEnum2.call(b4, prop))
        __defNormalProp3(a4, prop, b4[prop]);
    }
  return a4;
};
var messages = JSON.parse('{"icon.title.close":"Kryss"}');
var messages2 = JSON.parse('{"icon.title.close":"Cross"}');
var messages3 = JSON.parse('{"icon.title.close":"Rasti"}');
var supportedLocales = ["en", "nb", "fi", "da", "sv"];
var defaultLocale2 = "en";
var detectByBrand = () => {
  let value;
  switch (process.env.NMP_BRAND) {
    case "FINN":
      value = "nb";
      break;
    case "TORI":
      value = "fi";
      break;
    case "BLOCKET":
      value = "sv";
      break;
    case "DBA":
      value = "da";
      break;
    default:
      value = "en";
  }
  return value;
};
var detectByHost = () => {
  var _a;
  const hostname = (_a = document == null ? void 0 : document.location) == null ? void 0 : _a.hostname;
  if (hostname.includes("finn")) {
    return "nb";
  } else if (hostname.includes("tori")) {
    return "fi";
  } else if (hostname.includes("blocket")) {
    return "sv";
  } else if (hostname.includes("dba")) {
    return "da";
  } else {
    return defaultLocale2;
  }
};
var getSupportedLocale = (usedLocale) => {
  return supportedLocales.find(
    (locale) => usedLocale === locale || usedLocale.toLowerCase().includes(locale)
  ) || detectByHost();
};
function detectLocale() {
  var _a;
  if (typeof window === "undefined") {
    const serverLocale = detectByBrand();
    return getSupportedLocale(serverLocale);
  }
  try {
    const htmlLocale = (_a = document == null ? void 0 : document.documentElement) == null ? void 0 : _a.lang;
    const hostLocale = detectByHost();
    if (!supportedLocales.includes(htmlLocale)) {
      console.warn("Unsupported locale set in html lang tag, falling back to detection by hostname");
      return getSupportedLocale(hostLocale);
    }
    return getSupportedLocale(htmlLocale != null ? htmlLocale : hostLocale);
  } catch (e2) {
    console.warn("could not detect locale, falling back to source locale", e2);
    return defaultLocale2;
  }
}
var getMessages = (locale, enMsg, nbMsg, fiMsg) => {
  if (locale === "nb")
    return nbMsg;
  if (locale === "fi")
    return fiMsg;
  return enMsg;
};
var activateI18n = (enMessages, nbMessages, fiMessages) => {
  const locale = detectLocale();
  const messages410 = getMessages(locale, enMessages, nbMessages, fiMessages);
  i18n.load(locale, messages410);
  i18n.activate(locale);
};
activateI18n(messages2, messages, messages3);
var title = i18n.t({ message: `Cross`, id: "icon.title.close", comment: "Title for close icon" });
var IconClose16 = (attrs) => React6.createElement("svg", __spreadValues2({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", fill: "none", viewBox: "0 0 16 16", dangerouslySetInnerHTML: { __html: `<title>${title}</title><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="m12.5 3.5-9 9m0-9 9 9"></path>` } }, attrs));
var close_16_default = IconClose16;

// node_modules/.pnpm/@warp-ds+icons@2.0.0/node_modules/@warp-ds/icons/dist/react/search-16.js
import React7 from "react";
var __defProp4 = Object.defineProperty;
var __getOwnPropSymbols3 = Object.getOwnPropertySymbols;
var __hasOwnProp3 = Object.prototype.hasOwnProperty;
var __propIsEnum3 = Object.prototype.propertyIsEnumerable;
var __defNormalProp4 = (obj, key, value) => key in obj ? __defProp4(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues3 = (a4, b4) => {
  for (var prop in b4 || (b4 = {}))
    if (__hasOwnProp3.call(b4, prop))
      __defNormalProp4(a4, prop, b4[prop]);
  if (__getOwnPropSymbols3)
    for (var prop of __getOwnPropSymbols3(b4)) {
      if (__propIsEnum3.call(b4, prop))
        __defNormalProp4(a4, prop, b4[prop]);
    }
  return a4;
};
var messages4 = JSON.parse('{"icon.title.search":"Forst\xF8rrelsesglass"}');
var messages22 = JSON.parse('{"icon.title.search":"Magnifying glass"}');
var messages32 = JSON.parse('{"icon.title.search":"Suurennuslasi"}');
var supportedLocales2 = ["en", "nb", "fi", "da", "sv"];
var defaultLocale3 = "en";
var detectByBrand2 = () => {
  let value;
  switch (process.env.NMP_BRAND) {
    case "FINN":
      value = "nb";
      break;
    case "TORI":
      value = "fi";
      break;
    case "BLOCKET":
      value = "sv";
      break;
    case "DBA":
      value = "da";
      break;
    default:
      value = "en";
  }
  return value;
};
var detectByHost2 = () => {
  var _a;
  const hostname = (_a = document == null ? void 0 : document.location) == null ? void 0 : _a.hostname;
  if (hostname.includes("finn")) {
    return "nb";
  } else if (hostname.includes("tori")) {
    return "fi";
  } else if (hostname.includes("blocket")) {
    return "sv";
  } else if (hostname.includes("dba")) {
    return "da";
  } else {
    return defaultLocale3;
  }
};
var getSupportedLocale2 = (usedLocale) => {
  return supportedLocales2.find(
    (locale) => usedLocale === locale || usedLocale.toLowerCase().includes(locale)
  ) || detectByHost2();
};
function detectLocale2() {
  var _a;
  if (typeof window === "undefined") {
    const serverLocale = detectByBrand2();
    return getSupportedLocale2(serverLocale);
  }
  try {
    const htmlLocale = (_a = document == null ? void 0 : document.documentElement) == null ? void 0 : _a.lang;
    const hostLocale = detectByHost2();
    if (!supportedLocales2.includes(htmlLocale)) {
      console.warn("Unsupported locale set in html lang tag, falling back to detection by hostname");
      return getSupportedLocale2(hostLocale);
    }
    return getSupportedLocale2(htmlLocale != null ? htmlLocale : hostLocale);
  } catch (e2) {
    console.warn("could not detect locale, falling back to source locale", e2);
    return defaultLocale3;
  }
}
var getMessages2 = (locale, enMsg, nbMsg, fiMsg) => {
  if (locale === "nb")
    return nbMsg;
  if (locale === "fi")
    return fiMsg;
  return enMsg;
};
var activateI18n2 = (enMessages, nbMessages, fiMessages) => {
  const locale = detectLocale2();
  const messages410 = getMessages2(locale, enMessages, nbMessages, fiMessages);
  i18n.load(locale, messages410);
  i18n.activate(locale);
};
activateI18n2(messages22, messages4, messages32);
var title2 = i18n.t({ message: `Magnifying glass`, id: "icon.title.search", comment: "Title for search icon" });
var IconSearch16 = (attrs) => React7.createElement("svg", __spreadValues3({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", fill: "none", viewBox: "0 0 16 16", dangerouslySetInnerHTML: { __html: `<title>${title2}</title><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" d="M8.905 12.102A6.042 6.042 0 1 0 4.18.981a6.042 6.042 0 0 0 4.726 11.121Zm1.909-1.289L15.5 15.5"></path>` } }, attrs));
var search_16_default = IconSearch16;

// packages/_helpers/affix.tsx
function Affix(props) {
  const classBase = props.prefix ? prefix : suffix;
  return React8.createElement(
    props.label ? "div" : "button",
    {
      "aria-label": !props.label ? props["aria-label"] : void 0,
      type: props.search ? "submit" : props.clear ? "reset" : void 0,
      onClick: props.onClick,
      className: r({
        [classBase.wrapper]: true,
        [classBase.wrapperWithLabel]: props.label,
        [classBase.wrapperWithIcon]: !props.label
      })
    },
    /* @__PURE__ */ React8.createElement(React8.Fragment, null, props.clear && /* @__PURE__ */ React8.createElement(close_16_default, null), props.search && /* @__PURE__ */ React8.createElement(search_16_default, null), props.label && /* @__PURE__ */ React8.createElement("span", { className: classBase.label }, props.label))
  );
}

// packages/_helpers/expand-transition.tsx
import React9, { useEffect as useEffect3, useRef as useRef2, useState as useState2 } from "react";

// node_modules/.pnpm/element-collapse@1.1.0/node_modules/element-collapse/index.js
var windowExists = typeof window !== "undefined";
var prefersMotion = true;
if (windowExists) {
  const query = window.matchMedia("(prefers-reduced-motion: reduce)");
  const callback = ({ matches }) => prefersMotion = !matches;
  if (query.addEventListener)
    query.addEventListener("change", callback);
  callback(query);
}
var removeTransition = (el) => {
  el.style.transition = null;
  el.style.backfaceVisibility = null;
  el.style.overflow = null;
};
var addTransition = (el) => {
  const timing = prefersMotion ? "var(--f-expansion-duration, 0.3s)" : "0.01s";
  el.style.transition = `height ${timing}`;
  el.style.backfaceVisibility = "hidden";
  el.style.overflow = "hidden";
};
var getAfterExpandCallback = (el, done) => () => {
  el.style.height = "auto";
  el.style.overflow = null;
  if (done)
    done();
};
var getAfterCollapseCallback = (done) => () => {
  if (done)
    done();
};
var expand = (el, done) => {
  const returnPromise = (() => {
    if (!done)
      return new Promise((r5) => {
        done = r5;
      });
  })();
  const afterExpandCallback = getAfterExpandCallback(el, done);
  removeTransition(el);
  el.style.height = "auto";
  let dest = el.scrollHeight;
  windowExists && requestAnimationFrame(() => {
    el.addEventListener("transitionend", afterExpandCallback, { once: true });
    el.style.height = "0px";
    el.style.transitionTimingFunction = "ease-out";
    addTransition(el);
    requestAnimationFrame(() => el.style.height = dest + "px");
  });
  if (returnPromise)
    return returnPromise;
};
var collapse = (el, done) => {
  const returnPromise = (() => {
    if (!done)
      return new Promise((r5) => {
        done = r5;
      });
  })();
  const afterCollapseCallback = getAfterCollapseCallback(done);
  removeTransition(el);
  let original = el.scrollHeight;
  windowExists && requestAnimationFrame(() => {
    el.addEventListener("transitionend", afterCollapseCallback, { once: true });
    el.style.height = original + "px";
    el.style.transitionTimingFunction = "ease-in";
    addTransition(el);
    requestAnimationFrame(() => el.style.height = "0px");
  });
  if (returnPromise)
    return returnPromise;
};

// packages/_helpers/expand-transition.tsx
function ExpandTransition({
  show,
  children
}) {
  const [removeElement, setRemoveElement] = useState2(!show);
  const expandableRef = useRef2(null);
  const isMounted = useRef2(false);
  const initialShow = useRef2(show === true);
  function collapseElement(el) {
    collapse(el, () => setRemoveElement(true));
  }
  function expandElement(el) {
    expand(el);
  }
  if (show && removeElement) {
    setRemoveElement(false);
  }
  useEffect3(() => {
    if (!isMounted.current) {
      isMounted.current = true;
      return;
    }
    if (!expandableRef.current)
      return;
    if (show) {
      expandElement(expandableRef.current);
    } else {
      collapseElement(expandableRef.current);
    }
  }, [show]);
  const initialStyle = !initialShow.current ? "overflow-hidden h-0" : void 0;
  return /* @__PURE__ */ React9.createElement(
    "div",
    {
      className: initialStyle,
      ref: expandableRef,
      "aria-hidden": !show ? true : void 0
    },
    removeElement ? null : children
  );
}

// packages/_helpers/unstyled-heading.tsx
import React10 from "react";
var UnstyledHeading = (_a) => {
  var _b = _a, {
    level,
    children
  } = _b, attrs = __objRest(_b, [
    "level",
    "children"
  ]);
  if (!level) {
    return /* @__PURE__ */ React10.createElement(React10.Fragment, null, children);
  }
  const Heading = `h${level}`;
  return /* @__PURE__ */ React10.createElement(
    Heading,
    __spreadValues({
      style: {
        margin: 0,
        fontWeight: "unset",
        fontSize: "unset",
        lineHeight: "unset"
      }
    }, attrs),
    children
  );
};

// packages/alert/src/component.tsx
import React15 from "react";

// node_modules/.pnpm/@warp-ds+icons@2.0.0/node_modules/@warp-ds/icons/dist/react/error-16.js
import React11 from "react";
var __defProp5 = Object.defineProperty;
var __getOwnPropSymbols4 = Object.getOwnPropertySymbols;
var __hasOwnProp4 = Object.prototype.hasOwnProperty;
var __propIsEnum4 = Object.prototype.propertyIsEnumerable;
var __defNormalProp5 = (obj, key, value) => key in obj ? __defProp5(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues4 = (a4, b4) => {
  for (var prop in b4 || (b4 = {}))
    if (__hasOwnProp4.call(b4, prop))
      __defNormalProp5(a4, prop, b4[prop]);
  if (__getOwnPropSymbols4)
    for (var prop of __getOwnPropSymbols4(b4)) {
      if (__propIsEnum4.call(b4, prop))
        __defNormalProp5(a4, prop, b4[prop]);
    }
  return a4;
};
var messages5 = JSON.parse('{"icon.title.error":"\xC5ttekant med utropstegn"}');
var messages23 = JSON.parse('{"icon.title.error":"Octagon with exclamation point"}');
var messages33 = JSON.parse('{"icon.title.error":"Kahdeksankulmio, jonka sis\xE4ll\xE4 on huutomerkki"}');
var supportedLocales3 = ["en", "nb", "fi", "da", "sv"];
var defaultLocale4 = "en";
var detectByBrand3 = () => {
  let value;
  switch (process.env.NMP_BRAND) {
    case "FINN":
      value = "nb";
      break;
    case "TORI":
      value = "fi";
      break;
    case "BLOCKET":
      value = "sv";
      break;
    case "DBA":
      value = "da";
      break;
    default:
      value = "en";
  }
  return value;
};
var detectByHost3 = () => {
  var _a;
  const hostname = (_a = document == null ? void 0 : document.location) == null ? void 0 : _a.hostname;
  if (hostname.includes("finn")) {
    return "nb";
  } else if (hostname.includes("tori")) {
    return "fi";
  } else if (hostname.includes("blocket")) {
    return "sv";
  } else if (hostname.includes("dba")) {
    return "da";
  } else {
    return defaultLocale4;
  }
};
var getSupportedLocale3 = (usedLocale) => {
  return supportedLocales3.find(
    (locale) => usedLocale === locale || usedLocale.toLowerCase().includes(locale)
  ) || detectByHost3();
};
function detectLocale3() {
  var _a;
  if (typeof window === "undefined") {
    const serverLocale = detectByBrand3();
    return getSupportedLocale3(serverLocale);
  }
  try {
    const htmlLocale = (_a = document == null ? void 0 : document.documentElement) == null ? void 0 : _a.lang;
    const hostLocale = detectByHost3();
    if (!supportedLocales3.includes(htmlLocale)) {
      console.warn("Unsupported locale set in html lang tag, falling back to detection by hostname");
      return getSupportedLocale3(hostLocale);
    }
    return getSupportedLocale3(htmlLocale != null ? htmlLocale : hostLocale);
  } catch (e2) {
    console.warn("could not detect locale, falling back to source locale", e2);
    return defaultLocale4;
  }
}
var getMessages3 = (locale, enMsg, nbMsg, fiMsg) => {
  if (locale === "nb")
    return nbMsg;
  if (locale === "fi")
    return fiMsg;
  return enMsg;
};
var activateI18n3 = (enMessages, nbMessages, fiMessages) => {
  const locale = detectLocale3();
  const messages410 = getMessages3(locale, enMessages, nbMessages, fiMessages);
  i18n.load(locale, messages410);
  i18n.activate(locale);
};
activateI18n3(messages23, messages5, messages33);
var title3 = i18n.t({ message: `Octagon with exclamation point`, id: "icon.title.error", comment: "Title for error icon" });
var IconError16 = (attrs) => React11.createElement("svg", __spreadValues4({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", fill: "none", viewBox: "0 0 16 16", dangerouslySetInnerHTML: { __html: `<title>${title3}</title><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" d="M.5 11.107 4.748 15.5h6.503l4.248-4.393V4.893L11.252.5H4.748L.5 4.893z"></path><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" d="M8 11.398a.25.25 0 1 1 0-.5m0 .5a.25.25 0 1 0 0-.5"></path><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M8 8.5V3"></path>` } }, attrs));
var error_16_default = IconError16;

// node_modules/.pnpm/@warp-ds+icons@2.0.0/node_modules/@warp-ds/icons/dist/react/info-16.js
import React12 from "react";
var __defProp6 = Object.defineProperty;
var __getOwnPropSymbols5 = Object.getOwnPropertySymbols;
var __hasOwnProp5 = Object.prototype.hasOwnProperty;
var __propIsEnum5 = Object.prototype.propertyIsEnumerable;
var __defNormalProp6 = (obj, key, value) => key in obj ? __defProp6(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues5 = (a4, b4) => {
  for (var prop in b4 || (b4 = {}))
    if (__hasOwnProp5.call(b4, prop))
      __defNormalProp6(a4, prop, b4[prop]);
  if (__getOwnPropSymbols5)
    for (var prop of __getOwnPropSymbols5(b4)) {
      if (__propIsEnum5.call(b4, prop))
        __defNormalProp6(a4, prop, b4[prop]);
    }
  return a4;
};
var messages6 = JSON.parse('{"icon.title.info":"Informasjonssirkel"}');
var messages24 = JSON.parse('{"icon.title.info":"Information circle"}');
var messages34 = JSON.parse('{"icon.title.info":"Ympyr\xE4, jonka sis\xE4ll\xE4 on i-kirjain"}');
var supportedLocales4 = ["en", "nb", "fi", "da", "sv"];
var defaultLocale5 = "en";
var detectByBrand4 = () => {
  let value;
  switch (process.env.NMP_BRAND) {
    case "FINN":
      value = "nb";
      break;
    case "TORI":
      value = "fi";
      break;
    case "BLOCKET":
      value = "sv";
      break;
    case "DBA":
      value = "da";
      break;
    default:
      value = "en";
  }
  return value;
};
var detectByHost4 = () => {
  var _a;
  const hostname = (_a = document == null ? void 0 : document.location) == null ? void 0 : _a.hostname;
  if (hostname.includes("finn")) {
    return "nb";
  } else if (hostname.includes("tori")) {
    return "fi";
  } else if (hostname.includes("blocket")) {
    return "sv";
  } else if (hostname.includes("dba")) {
    return "da";
  } else {
    return defaultLocale5;
  }
};
var getSupportedLocale4 = (usedLocale) => {
  return supportedLocales4.find(
    (locale) => usedLocale === locale || usedLocale.toLowerCase().includes(locale)
  ) || detectByHost4();
};
function detectLocale4() {
  var _a;
  if (typeof window === "undefined") {
    const serverLocale = detectByBrand4();
    return getSupportedLocale4(serverLocale);
  }
  try {
    const htmlLocale = (_a = document == null ? void 0 : document.documentElement) == null ? void 0 : _a.lang;
    const hostLocale = detectByHost4();
    if (!supportedLocales4.includes(htmlLocale)) {
      console.warn("Unsupported locale set in html lang tag, falling back to detection by hostname");
      return getSupportedLocale4(hostLocale);
    }
    return getSupportedLocale4(htmlLocale != null ? htmlLocale : hostLocale);
  } catch (e2) {
    console.warn("could not detect locale, falling back to source locale", e2);
    return defaultLocale5;
  }
}
var getMessages4 = (locale, enMsg, nbMsg, fiMsg) => {
  if (locale === "nb")
    return nbMsg;
  if (locale === "fi")
    return fiMsg;
  return enMsg;
};
var activateI18n4 = (enMessages, nbMessages, fiMessages) => {
  const locale = detectLocale4();
  const messages410 = getMessages4(locale, enMessages, nbMessages, fiMessages);
  i18n.load(locale, messages410);
  i18n.activate(locale);
};
activateI18n4(messages24, messages6, messages34);
var title4 = i18n.t({ message: `Information circle`, id: "icon.title.info", comment: "Title for info icon" });
var IconInfo16 = (attrs) => React12.createElement("svg", __spreadValues5({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", fill: "none", viewBox: "0 0 16 16", dangerouslySetInnerHTML: { __html: `<title>${title4}</title><path stroke="currentColor" stroke-linecap="round" stroke-miterlimit="10" d="M8 6.5v5"></path><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" d="M8 4v.5"></path><path stroke="currentColor" stroke-miterlimit="10" d="M8 .5a7.5 7.5 0 1 1 0 15 7.5 7.5 0 0 1 0-15Z"></path>` } }, attrs));
var info_16_default = IconInfo16;

// node_modules/.pnpm/@warp-ds+icons@2.0.0/node_modules/@warp-ds/icons/dist/react/success-16.js
import React13 from "react";
var __defProp7 = Object.defineProperty;
var __getOwnPropSymbols6 = Object.getOwnPropertySymbols;
var __hasOwnProp6 = Object.prototype.hasOwnProperty;
var __propIsEnum6 = Object.prototype.propertyIsEnumerable;
var __defNormalProp7 = (obj, key, value) => key in obj ? __defProp7(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues6 = (a4, b4) => {
  for (var prop in b4 || (b4 = {}))
    if (__hasOwnProp6.call(b4, prop))
      __defNormalProp7(a4, prop, b4[prop]);
  if (__getOwnPropSymbols6)
    for (var prop of __getOwnPropSymbols6(b4)) {
      if (__propIsEnum6.call(b4, prop))
        __defNormalProp7(a4, prop, b4[prop]);
    }
  return a4;
};
var messages7 = JSON.parse('{"icon.title.success":"Sirkel med sjekkmerke"}');
var messages25 = JSON.parse('{"icon.title.success":"Circle with checkmark"}');
var messages35 = JSON.parse('{"icon.title.success":"Ympyr\xE4, jonka sis\xE4ll\xE4 on valintamerkki"}');
var supportedLocales5 = ["en", "nb", "fi", "da", "sv"];
var defaultLocale6 = "en";
var detectByBrand5 = () => {
  let value;
  switch (process.env.NMP_BRAND) {
    case "FINN":
      value = "nb";
      break;
    case "TORI":
      value = "fi";
      break;
    case "BLOCKET":
      value = "sv";
      break;
    case "DBA":
      value = "da";
      break;
    default:
      value = "en";
  }
  return value;
};
var detectByHost5 = () => {
  var _a;
  const hostname = (_a = document == null ? void 0 : document.location) == null ? void 0 : _a.hostname;
  if (hostname.includes("finn")) {
    return "nb";
  } else if (hostname.includes("tori")) {
    return "fi";
  } else if (hostname.includes("blocket")) {
    return "sv";
  } else if (hostname.includes("dba")) {
    return "da";
  } else {
    return defaultLocale6;
  }
};
var getSupportedLocale5 = (usedLocale) => {
  return supportedLocales5.find(
    (locale) => usedLocale === locale || usedLocale.toLowerCase().includes(locale)
  ) || detectByHost5();
};
function detectLocale5() {
  var _a;
  if (typeof window === "undefined") {
    const serverLocale = detectByBrand5();
    return getSupportedLocale5(serverLocale);
  }
  try {
    const htmlLocale = (_a = document == null ? void 0 : document.documentElement) == null ? void 0 : _a.lang;
    const hostLocale = detectByHost5();
    if (!supportedLocales5.includes(htmlLocale)) {
      console.warn("Unsupported locale set in html lang tag, falling back to detection by hostname");
      return getSupportedLocale5(hostLocale);
    }
    return getSupportedLocale5(htmlLocale != null ? htmlLocale : hostLocale);
  } catch (e2) {
    console.warn("could not detect locale, falling back to source locale", e2);
    return defaultLocale6;
  }
}
var getMessages5 = (locale, enMsg, nbMsg, fiMsg) => {
  if (locale === "nb")
    return nbMsg;
  if (locale === "fi")
    return fiMsg;
  return enMsg;
};
var activateI18n5 = (enMessages, nbMessages, fiMessages) => {
  const locale = detectLocale5();
  const messages410 = getMessages5(locale, enMessages, nbMessages, fiMessages);
  i18n.load(locale, messages410);
  i18n.activate(locale);
};
activateI18n5(messages25, messages7, messages35);
var title5 = i18n.t({ message: `Circle with checkmark`, id: "icon.title.success", comment: "Title for success icon" });
var IconSuccess16 = (attrs) => React13.createElement("svg", __spreadValues6({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", fill: "none", viewBox: "0 0 16 16", dangerouslySetInnerHTML: { __html: `<title>${title5}</title><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" d="m4 8.815 1.633 2.318a.7.7 0 0 0 1.138.034l5.228-6.615"></path><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" d="M.5 7.999a7.5 7.5 0 1 0 15 0 7.5 7.5 0 0 0-15 0"></path>` } }, attrs));
var success_16_default = IconSuccess16;

// node_modules/.pnpm/@warp-ds+icons@2.0.0/node_modules/@warp-ds/icons/dist/react/warning-16.js
import React14 from "react";
var __defProp8 = Object.defineProperty;
var __getOwnPropSymbols7 = Object.getOwnPropertySymbols;
var __hasOwnProp7 = Object.prototype.hasOwnProperty;
var __propIsEnum7 = Object.prototype.propertyIsEnumerable;
var __defNormalProp8 = (obj, key, value) => key in obj ? __defProp8(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues7 = (a4, b4) => {
  for (var prop in b4 || (b4 = {}))
    if (__hasOwnProp7.call(b4, prop))
      __defNormalProp8(a4, prop, b4[prop]);
  if (__getOwnPropSymbols7)
    for (var prop of __getOwnPropSymbols7(b4)) {
      if (__propIsEnum7.call(b4, prop))
        __defNormalProp8(a4, prop, b4[prop]);
    }
  return a4;
};
var messages8 = JSON.parse('{"icon.title.warning":"Varseltrekant med utropstegn"}');
var messages26 = JSON.parse('{"icon.title.warning":"Warning triangle with exclamation point"}');
var messages36 = JSON.parse('{"icon.title.warning":"Varoituskolmio, jonka sis\xE4ll\xE4 on huutomerkki"}');
var supportedLocales6 = ["en", "nb", "fi", "da", "sv"];
var defaultLocale7 = "en";
var detectByBrand6 = () => {
  let value;
  switch (process.env.NMP_BRAND) {
    case "FINN":
      value = "nb";
      break;
    case "TORI":
      value = "fi";
      break;
    case "BLOCKET":
      value = "sv";
      break;
    case "DBA":
      value = "da";
      break;
    default:
      value = "en";
  }
  return value;
};
var detectByHost6 = () => {
  var _a;
  const hostname = (_a = document == null ? void 0 : document.location) == null ? void 0 : _a.hostname;
  if (hostname.includes("finn")) {
    return "nb";
  } else if (hostname.includes("tori")) {
    return "fi";
  } else if (hostname.includes("blocket")) {
    return "sv";
  } else if (hostname.includes("dba")) {
    return "da";
  } else {
    return defaultLocale7;
  }
};
var getSupportedLocale6 = (usedLocale) => {
  return supportedLocales6.find(
    (locale) => usedLocale === locale || usedLocale.toLowerCase().includes(locale)
  ) || detectByHost6();
};
function detectLocale6() {
  var _a;
  if (typeof window === "undefined") {
    const serverLocale = detectByBrand6();
    return getSupportedLocale6(serverLocale);
  }
  try {
    const htmlLocale = (_a = document == null ? void 0 : document.documentElement) == null ? void 0 : _a.lang;
    const hostLocale = detectByHost6();
    if (!supportedLocales6.includes(htmlLocale)) {
      console.warn("Unsupported locale set in html lang tag, falling back to detection by hostname");
      return getSupportedLocale6(hostLocale);
    }
    return getSupportedLocale6(htmlLocale != null ? htmlLocale : hostLocale);
  } catch (e2) {
    console.warn("could not detect locale, falling back to source locale", e2);
    return defaultLocale7;
  }
}
var getMessages6 = (locale, enMsg, nbMsg, fiMsg) => {
  if (locale === "nb")
    return nbMsg;
  if (locale === "fi")
    return fiMsg;
  return enMsg;
};
var activateI18n6 = (enMessages, nbMessages, fiMessages) => {
  const locale = detectLocale6();
  const messages410 = getMessages6(locale, enMessages, nbMessages, fiMessages);
  i18n.load(locale, messages410);
  i18n.activate(locale);
};
activateI18n6(messages26, messages8, messages36);
var title6 = i18n.t({ message: `Warning triangle with exclamation point`, id: "icon.title.warning", comment: "Title for warning icon" });
var IconWarning16 = (attrs) => React14.createElement("svg", __spreadValues7({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", fill: "none", viewBox: "0 0 16 16", dangerouslySetInnerHTML: { __html: `<title>${title6}</title><path stroke="currentColor" d="m.712 14.07 6.25-12.994a1 1 0 0 1 1.792-.022l6.635 12.995a1 1 0 0 1-.89 1.455H1.613a1 1 0 0 1-.902-1.434Z"></path><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" d="M8 6v4.992M8 13v.333"></path>` } }, attrs));
var warning_16_default = IconWarning16;

// packages/alert/src/component.tsx
function Alert(_a) {
  var _b = _a, {
    show,
    type,
    role = "alert",
    children
  } = _b, props = __objRest(_b, [
    "show",
    "type",
    "role",
    "children"
  ]);
  const variantClasses2 = alert[type];
  const iconVariantClasses = alert[`${type}Icon`];
  return /* @__PURE__ */ React15.createElement(ExpandTransition, { show }, /* @__PURE__ */ React15.createElement(
    "div",
    {
      role,
      className: r(
        props.className,
        `${alert.alert} ${variantClasses2}`
      ),
      style: props.style
    },
    /* @__PURE__ */ React15.createElement("div", { className: `${alert.icon} ${iconVariantClasses}` }, iconMap[type]),
    /* @__PURE__ */ React15.createElement("div", { className: alert.textWrapper }, children)
  ));
}
var iconMap = {
  negative: /* @__PURE__ */ React15.createElement(error_16_default, null),
  positive: /* @__PURE__ */ React15.createElement(success_16_default, null),
  warning: /* @__PURE__ */ React15.createElement(warning_16_default, null),
  info: /* @__PURE__ */ React15.createElement(info_16_default, null)
};

// packages/attention/src/component.tsx
import React16, { forwardRef, useEffect as useEffect4, useRef as useRef3, useState as useState3 } from "react";

// node_modules/.pnpm/@floating-ui+core@0.7.3/node_modules/@floating-ui/core/dist/floating-ui.core.browser.min.mjs
function t(t2) {
  return t2.split("-")[0];
}
function e(t2) {
  return t2.split("-")[1];
}
function n(e2) {
  return ["top", "bottom"].includes(t(e2)) ? "x" : "y";
}
function r2(t2) {
  return "y" === t2 ? "height" : "width";
}
function i(i4, o3, a4) {
  let { reference: l3, floating: s3 } = i4;
  const c4 = l3.x + l3.width / 2 - s3.width / 2, f4 = l3.y + l3.height / 2 - s3.height / 2, u4 = n(o3), m4 = r2(u4), g4 = l3[m4] / 2 - s3[m4] / 2, d4 = "x" === u4;
  let p4;
  switch (t(o3)) {
    case "top":
      p4 = { x: c4, y: l3.y - s3.height };
      break;
    case "bottom":
      p4 = { x: c4, y: l3.y + l3.height };
      break;
    case "right":
      p4 = { x: l3.x + l3.width, y: f4 };
      break;
    case "left":
      p4 = { x: l3.x - s3.width, y: f4 };
      break;
    default:
      p4 = { x: l3.x, y: l3.y };
  }
  switch (e(o3)) {
    case "start":
      p4[u4] -= g4 * (a4 && d4 ? -1 : 1);
      break;
    case "end":
      p4[u4] += g4 * (a4 && d4 ? -1 : 1);
  }
  return p4;
}
var o = async (t2, e2, n4) => {
  const { placement: r5 = "bottom", strategy: o3 = "absolute", middleware: a4 = [], platform: l3 } = n4, s3 = await (null == l3.isRTL ? void 0 : l3.isRTL(e2));
  let c4 = await l3.getElementRects({ reference: t2, floating: e2, strategy: o3 }), { x: f4, y: u4 } = i(c4, r5, s3), m4 = r5, g4 = {}, d4 = 0;
  for (let n5 = 0; n5 < a4.length; n5++) {
    const { name: p4, fn: h4 } = a4[n5], { x: y4, y: x3, data: w3, reset: v3 } = await h4({ x: f4, y: u4, initialPlacement: r5, placement: m4, strategy: o3, middlewareData: g4, rects: c4, platform: l3, elements: { reference: t2, floating: e2 } });
    f4 = null != y4 ? y4 : f4, u4 = null != x3 ? x3 : u4, g4 = __spreadProps(__spreadValues({}, g4), { [p4]: __spreadValues(__spreadValues({}, g4[p4]), w3) }), v3 && d4 <= 50 && (d4++, "object" == typeof v3 && (v3.placement && (m4 = v3.placement), v3.rects && (c4 = true === v3.rects ? await l3.getElementRects({ reference: t2, floating: e2, strategy: o3 }) : v3.rects), { x: f4, y: u4 } = i(c4, m4, s3)), n5 = -1);
  }
  return { x: f4, y: u4, placement: m4, strategy: o3, middlewareData: g4 };
};
function a(t2) {
  return "number" != typeof t2 ? function(t3) {
    return __spreadValues({ top: 0, right: 0, bottom: 0, left: 0 }, t3);
  }(t2) : { top: t2, right: t2, bottom: t2, left: t2 };
}
function l(t2) {
  return __spreadProps(__spreadValues({}, t2), { top: t2.y, left: t2.x, right: t2.x + t2.width, bottom: t2.y + t2.height });
}
async function s(t2, e2) {
  var n4;
  void 0 === e2 && (e2 = {});
  const { x: r5, y: i4, platform: o3, rects: s3, elements: c4, strategy: f4 } = t2, { boundary: u4 = "clippingAncestors", rootBoundary: m4 = "viewport", elementContext: g4 = "floating", altBoundary: d4 = false, padding: p4 = 0 } = e2, h4 = a(p4), y4 = c4[d4 ? "floating" === g4 ? "reference" : "floating" : g4], x3 = l(await o3.getClippingRect({ element: null == (n4 = await (null == o3.isElement ? void 0 : o3.isElement(y4))) || n4 ? y4 : y4.contextElement || await (null == o3.getDocumentElement ? void 0 : o3.getDocumentElement(c4.floating)), boundary: u4, rootBoundary: m4, strategy: f4 })), w3 = l(o3.convertOffsetParentRelativeRectToViewportRelativeRect ? await o3.convertOffsetParentRelativeRectToViewportRelativeRect({ rect: "floating" === g4 ? __spreadProps(__spreadValues({}, s3.floating), { x: r5, y: i4 }) : s3.reference, offsetParent: await (null == o3.getOffsetParent ? void 0 : o3.getOffsetParent(c4.floating)), strategy: f4 }) : s3[g4]);
  return { top: x3.top - w3.top + h4.top, bottom: w3.bottom - x3.bottom + h4.bottom, left: x3.left - w3.left + h4.left, right: w3.right - x3.right + h4.right };
}
var c = Math.min;
var f = Math.max;
function u(t2, e2, n4) {
  return f(t2, c(e2, n4));
}
var m = (t2) => ({ name: "arrow", options: t2, async fn(i4) {
  const { element: o3, padding: l3 = 0 } = null != t2 ? t2 : {}, { x: s3, y: c4, placement: f4, rects: m4, platform: g4 } = i4;
  if (null == o3)
    return {};
  const d4 = a(l3), p4 = { x: s3, y: c4 }, h4 = n(f4), y4 = e(f4), x3 = r2(h4), w3 = await g4.getDimensions(o3), v3 = "y" === h4 ? "top" : "left", b4 = "y" === h4 ? "bottom" : "right", R2 = m4.reference[x3] + m4.reference[h4] - p4[h4] - m4.floating[x3], A = p4[h4] - m4.reference[h4], P2 = await (null == g4.getOffsetParent ? void 0 : g4.getOffsetParent(o3));
  let T4 = P2 ? "y" === h4 ? P2.clientHeight || 0 : P2.clientWidth || 0 : 0;
  0 === T4 && (T4 = m4.floating[x3]);
  const O2 = R2 / 2 - A / 2, D3 = d4[v3], L3 = T4 - w3[x3] - d4[b4], k2 = T4 / 2 - w3[x3] / 2 + O2, E4 = u(D3, k2, L3), C2 = ("start" === y4 ? d4[v3] : d4[b4]) > 0 && k2 !== E4 && m4.reference[x3] <= m4.floating[x3];
  return { [h4]: p4[h4] - (C2 ? k2 < D3 ? D3 - k2 : L3 - k2 : 0), data: { [h4]: E4, centerOffset: k2 - E4 } };
} });
var g = { left: "right", right: "left", bottom: "top", top: "bottom" };
function d(t2) {
  return t2.replace(/left|right|bottom|top/g, (t3) => g[t3]);
}
function p(t2, i4, o3) {
  void 0 === o3 && (o3 = false);
  const a4 = e(t2), l3 = n(t2), s3 = r2(l3);
  let c4 = "x" === l3 ? a4 === (o3 ? "end" : "start") ? "right" : "left" : "start" === a4 ? "bottom" : "top";
  return i4.reference[s3] > i4.floating[s3] && (c4 = d(c4)), { main: c4, cross: d(c4) };
}
var h = { start: "end", end: "start" };
function y(t2) {
  return t2.replace(/start|end/g, (t3) => h[t3]);
}
var x = ["top", "right", "bottom", "left"];
var w = x.reduce((t2, e2) => t2.concat(e2, e2 + "-start", e2 + "-end"), []);
var b = function(e2) {
  return void 0 === e2 && (e2 = {}), { name: "flip", options: e2, async fn(n4) {
    var r5;
    const { placement: i4, middlewareData: o3, rects: a4, initialPlacement: l3, platform: c4, elements: f4 } = n4, _a = e2, { mainAxis: u4 = true, crossAxis: m4 = true, fallbackPlacements: g4, fallbackStrategy: h4 = "bestFit", flipAlignment: x3 = true } = _a, w3 = __objRest(_a, ["mainAxis", "crossAxis", "fallbackPlacements", "fallbackStrategy", "flipAlignment"]), v3 = t(i4), b4 = g4 || (v3 === l3 || !x3 ? [d(l3)] : function(t2) {
      const e3 = d(t2);
      return [y(t2), e3, y(e3)];
    }(l3)), R2 = [l3, ...b4], A = await s(n4, w3), P2 = [];
    let T4 = (null == (r5 = o3.flip) ? void 0 : r5.overflows) || [];
    if (u4 && P2.push(A[v3]), m4) {
      const { main: t2, cross: e3 } = p(i4, a4, await (null == c4.isRTL ? void 0 : c4.isRTL(f4.floating)));
      P2.push(A[t2], A[e3]);
    }
    if (T4 = [...T4, { placement: i4, overflows: P2 }], !P2.every((t2) => t2 <= 0)) {
      var O2, D3;
      const t2 = (null != (O2 = null == (D3 = o3.flip) ? void 0 : D3.index) ? O2 : 0) + 1, e3 = R2[t2];
      if (e3)
        return { data: { index: t2, overflows: T4 }, reset: { placement: e3 } };
      let n5 = "bottom";
      switch (h4) {
        case "bestFit": {
          var L3;
          const t3 = null == (L3 = T4.map((t4) => [t4, t4.overflows.filter((t5) => t5 > 0).reduce((t5, e4) => t5 + e4, 0)]).sort((t4, e4) => t4[1] - e4[1])[0]) ? void 0 : L3[0].placement;
          t3 && (n5 = t3);
          break;
        }
        case "initialPlacement":
          n5 = l3;
      }
      if (i4 !== n5)
        return { reset: { placement: n5 } };
    }
    return {};
  } };
};
var T = function(r5) {
  return void 0 === r5 && (r5 = 0), { name: "offset", options: r5, async fn(i4) {
    const { x: o3, y: a4 } = i4, l3 = await async function(r6, i5) {
      const { placement: o4, platform: a5, elements: l4 } = r6, s3 = await (null == a5.isRTL ? void 0 : a5.isRTL(l4.floating)), c4 = t(o4), f4 = e(o4), u4 = "x" === n(o4), m4 = ["left", "top"].includes(c4) ? -1 : 1, g4 = s3 && u4 ? -1 : 1, d4 = "function" == typeof i5 ? i5(r6) : i5;
      let { mainAxis: p4, crossAxis: h4, alignmentAxis: y4 } = "number" == typeof d4 ? { mainAxis: d4, crossAxis: 0, alignmentAxis: null } : __spreadValues({ mainAxis: 0, crossAxis: 0, alignmentAxis: null }, d4);
      return f4 && "number" == typeof y4 && (h4 = "end" === f4 ? -1 * y4 : y4), u4 ? { x: h4 * g4, y: p4 * m4 } : { x: p4 * m4, y: h4 * g4 };
    }(i4, r5);
    return { x: o3 + l3.x, y: a4 + l3.y, data: l3 };
  } };
};
function O(t2) {
  return "x" === t2 ? "y" : "x";
}
var D = function(e2) {
  return void 0 === e2 && (e2 = {}), { name: "shift", options: e2, async fn(r5) {
    const { x: i4, y: o3, placement: a4 } = r5, _a = e2, { mainAxis: l3 = true, crossAxis: c4 = false, limiter: f4 = { fn: (t2) => {
      let { x: e3, y: n4 } = t2;
      return { x: e3, y: n4 };
    } } } = _a, m4 = __objRest(_a, ["mainAxis", "crossAxis", "limiter"]), g4 = { x: i4, y: o3 }, d4 = await s(r5, m4), p4 = n(t(a4)), h4 = O(p4);
    let y4 = g4[p4], x3 = g4[h4];
    if (l3) {
      const t2 = "y" === p4 ? "bottom" : "right";
      y4 = u(y4 + d4["y" === p4 ? "top" : "left"], y4, y4 - d4[t2]);
    }
    if (c4) {
      const t2 = "y" === h4 ? "bottom" : "right";
      x3 = u(x3 + d4["y" === h4 ? "top" : "left"], x3, x3 - d4[t2]);
    }
    const w3 = f4.fn(__spreadProps(__spreadValues({}, r5), { [p4]: y4, [h4]: x3 }));
    return __spreadProps(__spreadValues({}, w3), { data: { x: w3.x - i4, y: w3.y - o3 } });
  } };
};

// node_modules/.pnpm/@floating-ui+dom@0.5.4/node_modules/@floating-ui/dom/dist/floating-ui.dom.browser.min.mjs
function n2(t2) {
  return t2 && t2.document && t2.location && t2.alert && t2.setInterval;
}
function o2(t2) {
  if (null == t2)
    return window;
  if (!n2(t2)) {
    const e2 = t2.ownerDocument;
    return e2 && e2.defaultView || window;
  }
  return t2;
}
function i2(t2) {
  return o2(t2).getComputedStyle(t2);
}
function r3(t2) {
  return n2(t2) ? "" : t2 ? (t2.nodeName || "").toLowerCase() : "";
}
function l2() {
  const t2 = navigator.userAgentData;
  return null != t2 && t2.brands ? t2.brands.map((t3) => t3.brand + "/" + t3.version).join(" ") : navigator.userAgent;
}
function c2(t2) {
  return t2 instanceof o2(t2).HTMLElement;
}
function f2(t2) {
  return t2 instanceof o2(t2).Element;
}
function s2(t2) {
  if ("undefined" == typeof ShadowRoot)
    return false;
  return t2 instanceof o2(t2).ShadowRoot || t2 instanceof ShadowRoot;
}
function u2(t2) {
  const { overflow: e2, overflowX: n4, overflowY: o3 } = i2(t2);
  return /auto|scroll|overlay|hidden/.test(e2 + o3 + n4);
}
function d2(t2) {
  return ["table", "td", "th"].includes(r3(t2));
}
function h2(t2) {
  const e2 = /firefox/i.test(l2()), n4 = i2(t2);
  return "none" !== n4.transform || "none" !== n4.perspective || "paint" === n4.contain || ["transform", "perspective"].includes(n4.willChange) || e2 && "filter" === n4.willChange || e2 && !!n4.filter && "none" !== n4.filter;
}
function a2() {
  return !/^((?!chrome|android).)*safari/i.test(l2());
}
var g2 = Math.min;
var p2 = Math.max;
var m2 = Math.round;
function w2(t2, e2, n4) {
  var i4, r5, l3, s3;
  void 0 === e2 && (e2 = false), void 0 === n4 && (n4 = false);
  const u4 = t2.getBoundingClientRect();
  let d4 = 1, h4 = 1;
  e2 && c2(t2) && (d4 = t2.offsetWidth > 0 && m2(u4.width) / t2.offsetWidth || 1, h4 = t2.offsetHeight > 0 && m2(u4.height) / t2.offsetHeight || 1);
  const g4 = f2(t2) ? o2(t2) : window, p4 = !a2() && n4, w3 = (u4.left + (p4 && null != (i4 = null == (r5 = g4.visualViewport) ? void 0 : r5.offsetLeft) ? i4 : 0)) / d4, v3 = (u4.top + (p4 && null != (l3 = null == (s3 = g4.visualViewport) ? void 0 : s3.offsetTop) ? l3 : 0)) / h4, y4 = u4.width / d4, x3 = u4.height / h4;
  return { width: y4, height: x3, top: v3, right: w3 + y4, bottom: v3 + x3, left: w3, x: w3, y: v3 };
}
function v2(t2) {
  return (e2 = t2, (e2 instanceof o2(e2).Node ? t2.ownerDocument : t2.document) || window.document).documentElement;
  var e2;
}
function y2(t2) {
  return f2(t2) ? { scrollLeft: t2.scrollLeft, scrollTop: t2.scrollTop } : { scrollLeft: t2.pageXOffset, scrollTop: t2.pageYOffset };
}
function x2(t2) {
  return w2(v2(t2)).left + y2(t2).scrollLeft;
}
function b2(t2, e2, n4) {
  const o3 = c2(e2), i4 = v2(e2), l3 = w2(t2, o3 && function(t3) {
    const e3 = w2(t3);
    return m2(e3.width) !== t3.offsetWidth || m2(e3.height) !== t3.offsetHeight;
  }(e2), "fixed" === n4);
  let f4 = { scrollLeft: 0, scrollTop: 0 };
  const s3 = { x: 0, y: 0 };
  if (o3 || !o3 && "fixed" !== n4)
    if (("body" !== r3(e2) || u2(i4)) && (f4 = y2(e2)), c2(e2)) {
      const t3 = w2(e2, true);
      s3.x = t3.x + e2.clientLeft, s3.y = t3.y + e2.clientTop;
    } else
      i4 && (s3.x = x2(i4));
  return { x: l3.left + f4.scrollLeft - s3.x, y: l3.top + f4.scrollTop - s3.y, width: l3.width, height: l3.height };
}
function L2(t2) {
  return "html" === r3(t2) ? t2 : t2.assignedSlot || t2.parentNode || (s2(t2) ? t2.host : null) || v2(t2);
}
function R(t2) {
  return c2(t2) && "fixed" !== getComputedStyle(t2).position ? t2.offsetParent : null;
}
function T2(t2) {
  const e2 = o2(t2);
  let n4 = R(t2);
  for (; n4 && d2(n4) && "static" === getComputedStyle(n4).position; )
    n4 = R(n4);
  return n4 && ("html" === r3(n4) || "body" === r3(n4) && "static" === getComputedStyle(n4).position && !h2(n4)) ? e2 : n4 || function(t3) {
    let e3 = L2(t3);
    for (s2(e3) && (e3 = e3.host); c2(e3) && !["html", "body"].includes(r3(e3)); ) {
      if (h2(e3))
        return e3;
      e3 = e3.parentNode;
    }
    return null;
  }(t2) || e2;
}
function W(t2) {
  if (c2(t2))
    return { width: t2.offsetWidth, height: t2.offsetHeight };
  const e2 = w2(t2);
  return { width: e2.width, height: e2.height };
}
function E2(t2) {
  const e2 = L2(t2);
  return ["html", "body", "#document"].includes(r3(e2)) ? t2.ownerDocument.body : c2(e2) && u2(e2) ? e2 : E2(e2);
}
function H(t2, e2) {
  var n4;
  void 0 === e2 && (e2 = []);
  const i4 = E2(t2), r5 = i4 === (null == (n4 = t2.ownerDocument) ? void 0 : n4.body), l3 = o2(i4), c4 = r5 ? [l3].concat(l3.visualViewport || [], u2(i4) ? i4 : []) : i4, f4 = e2.concat(c4);
  return r5 ? f4 : f4.concat(H(c4));
}
function C(e2, n4, r5) {
  return "viewport" === n4 ? l(function(t2, e3) {
    const n5 = o2(t2), i4 = v2(t2), r6 = n5.visualViewport;
    let l3 = i4.clientWidth, c4 = i4.clientHeight, f4 = 0, s3 = 0;
    if (r6) {
      l3 = r6.width, c4 = r6.height;
      const t3 = a2();
      (t3 || !t3 && "fixed" === e3) && (f4 = r6.offsetLeft, s3 = r6.offsetTop);
    }
    return { width: l3, height: c4, x: f4, y: s3 };
  }(e2, r5)) : f2(n4) ? function(t2, e3) {
    const n5 = w2(t2, false, "fixed" === e3), o3 = n5.top + t2.clientTop, i4 = n5.left + t2.clientLeft;
    return { top: o3, left: i4, x: i4, y: o3, right: i4 + t2.clientWidth, bottom: o3 + t2.clientHeight, width: t2.clientWidth, height: t2.clientHeight };
  }(n4, r5) : l(function(t2) {
    var e3;
    const n5 = v2(t2), o3 = y2(t2), r6 = null == (e3 = t2.ownerDocument) ? void 0 : e3.body, l3 = p2(n5.scrollWidth, n5.clientWidth, r6 ? r6.scrollWidth : 0, r6 ? r6.clientWidth : 0), c4 = p2(n5.scrollHeight, n5.clientHeight, r6 ? r6.scrollHeight : 0, r6 ? r6.clientHeight : 0);
    let f4 = -o3.scrollLeft + x2(t2);
    const s3 = -o3.scrollTop;
    return "rtl" === i2(r6 || n5).direction && (f4 += p2(n5.clientWidth, r6 ? r6.clientWidth : 0) - l3), { width: l3, height: c4, x: f4, y: s3 };
  }(v2(e2)));
}
function S(t2) {
  const e2 = H(t2), n4 = ["absolute", "fixed"].includes(i2(t2).position) && c2(t2) ? T2(t2) : t2;
  return f2(n4) ? e2.filter((t3) => f2(t3) && function(t4, e3) {
    const n5 = null == e3.getRootNode ? void 0 : e3.getRootNode();
    if (t4.contains(e3))
      return true;
    if (n5 && s2(n5)) {
      let n6 = e3;
      do {
        if (n6 && t4 === n6)
          return true;
        n6 = n6.parentNode || n6.host;
      } while (n6);
    }
    return false;
  }(t3, n4) && "body" !== r3(t3)) : [];
}
var D2 = { getClippingRect: function(t2) {
  let { element: e2, boundary: n4, rootBoundary: o3, strategy: i4 } = t2;
  const r5 = [..."clippingAncestors" === n4 ? S(e2) : [].concat(n4), o3], l3 = r5[0], c4 = r5.reduce((t3, n5) => {
    const o4 = C(e2, n5, i4);
    return t3.top = p2(o4.top, t3.top), t3.right = g2(o4.right, t3.right), t3.bottom = g2(o4.bottom, t3.bottom), t3.left = p2(o4.left, t3.left), t3;
  }, C(e2, l3, i4));
  return { width: c4.right - c4.left, height: c4.bottom - c4.top, x: c4.left, y: c4.top };
}, convertOffsetParentRelativeRectToViewportRelativeRect: function(t2) {
  let { rect: e2, offsetParent: n4, strategy: o3 } = t2;
  const i4 = c2(n4), l3 = v2(n4);
  if (n4 === l3)
    return e2;
  let f4 = { scrollLeft: 0, scrollTop: 0 };
  const s3 = { x: 0, y: 0 };
  if ((i4 || !i4 && "fixed" !== o3) && (("body" !== r3(n4) || u2(l3)) && (f4 = y2(n4)), c2(n4))) {
    const t3 = w2(n4, true);
    s3.x = t3.x + n4.clientLeft, s3.y = t3.y + n4.clientTop;
  }
  return __spreadProps(__spreadValues({}, e2), { x: e2.x - f4.scrollLeft + s3.x, y: e2.y - f4.scrollTop + s3.y });
}, isElement: f2, getDimensions: W, getOffsetParent: T2, getDocumentElement: v2, getElementRects: (t2) => {
  let { reference: e2, floating: n4, strategy: o3 } = t2;
  return { reference: b2(e2, T2(n4), o3), floating: __spreadProps(__spreadValues({}, W(n4)), { x: 0, y: 0 }) };
}, getClientRects: (t2) => Array.from(t2.getClientRects()), isRTL: (t2) => "rtl" === i2(t2).direction };
var z = (t2, n4, o3) => o(t2, n4, __spreadValues({ platform: D2 }, o3));

// node_modules/.pnpm/@warp-ds+core@1.0.2/node_modules/@warp-ds/core/dist/attention/utils/helpers.js
var TOP = "top";
var BOTTOM = "bottom";
var LEFT = "left";
var RIGHT = "right";
var opposites = {
  [TOP]: BOTTOM,
  [BOTTOM]: TOP,
  [LEFT]: RIGHT,
  [RIGHT]: LEFT
};
var arrowLabels = {
  [TOP]: "\u2191",
  [BOTTOM]: "\u2193",
  [LEFT]: "\u2190",
  [RIGHT]: "\u2192"
};
var rotation = {
  [LEFT]: -45,
  [TOP]: 45,
  [RIGHT]: 135,
  [BOTTOM]: -135
};
var middlePosition = "calc(50% - 7px)";
var isDirectionVertical = (name) => [TOP, BOTTOM].includes(name);
function computeCalloutArrow({ actualDirection, directionName, arrowEl }) {
  if (!arrowEl)
    return;
  actualDirection = directionName;
  const directionIsVertical = isDirectionVertical(directionName);
  arrowEl.style.left = directionIsVertical ? middlePosition : "";
  arrowEl.style.top = !directionIsVertical ? middlePosition : "";
}
async function useRecompute(state) {
  var _a, _b;
  if (!state.isShowing)
    return;
  await ((_a = state == null ? void 0 : state.waitForDOM) == null ? void 0 : _a.call(state));
  if (state.isCallout)
    return computeCalloutArrow(state);
  const position = await z(state.targetEl, state.attentionEl, {
    placement: state.directionName,
    middleware: [
      // Should we make this configurable, but have these as sane defaults?
      b(),
      T(8),
      D({ padding: 16 }),
      // @ts-ignore
      m({ element: state.noArrow ? void 0 : state.arrowEl })
      // FIXME
    ]
  });
  state.actualDirection = position.placement;
  Object.assign(((_b = state.attentionEl) == null ? void 0 : _b.style) || {}, {
    left: "0",
    top: "0",
    transform: `translate3d(${Math.round(position.x)}px, ${Math.round(position.y)}px, 0)`
  });
  let { x: x3, y: y4 } = position.middlewareData.arrow;
  if (state.arrowEl) {
    state.arrowEl.style.left = x3 ? x3 + "px" : "";
    state.arrowEl.style.top = y4 ? y4 + "px" : "";
  }
}

// packages/attention/src/locales/nb/messages.mjs
var messages9 = JSON.parse('{"attention.aria.callout":"Gr\xF8nn taleboble som introduserer noe nytt","attention.aria.close":"Lukk","attention.aria.highlight":"En uthevet taleboble med viktig informasjon","attention.aria.pointingDown":"peker ned","attention.aria.pointingLeft":"peker til venstre","attention.aria.pointingRight":"peker til h\xF8yre","attention.aria.pointingUp":"peker opp","attention.aria.popover":"En hvit taleboble som gir tilleggsinformasjon","attention.aria.tooltip":"En svart taleboble som forklarer konteksten"}');

// packages/attention/src/locales/en/messages.mjs
var messages10 = JSON.parse('{"attention.aria.callout":"A green speech bubble introducing something new","attention.aria.close":"Close","attention.aria.highlight":"An attention speech bubble with important information","attention.aria.pointingDown":"pointing down","attention.aria.pointingLeft":"pointing left","attention.aria.pointingRight":"pointing right","attention.aria.pointingUp":"pointing up","attention.aria.popover":"A white speech bubble providing additional information","attention.aria.tooltip":"A black speech bubble providing complementary information"}');

// packages/attention/src/locales/fi/messages.mjs
var messages11 = JSON.parse('{"attention.aria.callout":"Vihre\xE4 puhekupla, joka esittelee jotain uutta","attention.aria.close":"Sulje","attention.aria.highlight":"Puhekupla, joka sis\xE4lt\xE4\xE4 t\xE4rke\xE4\xE4 tietoa","attention.aria.pointingDown":"osoittaa alas","attention.aria.pointingLeft":"osoittaa vasemmalle","attention.aria.pointingRight":"osoittaa oikealle","attention.aria.pointingUp":"osoittaa yl\xF6s","attention.aria.popover":"Valkoinen puhekupla, joka tarjoaa lis\xE4tietoa","attention.aria.tooltip":"Musta puhekupla, joka tarjoaa t\xE4ydent\xE4v\xE4\xE4 tietoa"}');

// packages/i18n.ts
var supportedLocales7 = ["en", "nb", "fi"];
var defaultLocale8 = "en";
var getSupportedLocale7 = (usedLocale) => {
  return supportedLocales7.find(
    (locale) => usedLocale === locale || usedLocale.toLowerCase().includes(locale)
  ) || defaultLocale8;
};
function detectLocale7() {
  if (typeof window === "undefined") {
    const serverLocale = process.env.NMP_LANGUAGE || Intl.DateTimeFormat().resolvedOptions().locale;
    return getSupportedLocale7(serverLocale);
  }
  try {
    const htmlLocale = document.documentElement.lang;
    return getSupportedLocale7(htmlLocale);
  } catch (e2) {
    console.warn("could not detect locale, falling back to source locale", e2);
    return defaultLocale8;
  }
}
var getMessages7 = (locale, enMsg, nbMsg, fiMsg) => {
  if (locale === "nb")
    return nbMsg;
  if (locale === "fi")
    return fiMsg;
  return enMsg;
};
var activateI18n7 = (enMessages, nbMessages, fiMessages) => {
  const locale = detectLocale7();
  const messages64 = getMessages7(locale, enMessages, nbMessages, fiMessages);
  i18n.load(locale, messages64);
  i18n.activate(locale);
};

// packages/attention/src/component.tsx
var variantClasses = {
  callout: {
    wrapper: attention.callout,
    arrow: attention.arrowCallout
  },
  highlight: {
    wrapper: attention.highlight,
    arrow: attention.arrowHighlight
  },
  tooltip: {
    wrapper: attention.tooltip,
    arrow: attention.arrowTooltip
  },
  popover: {
    wrapper: attention.popover,
    arrow: attention.arrowPopover
  }
};
var getVariant = (variantProps) => {
  return Object.keys(variantClasses).find((b4) => !!variantProps[b4]) || "";
};
function Attention(props) {
  const _a = props, {
    noArrow,
    isShowing,
    children,
    role,
    "aria-label": ariaLabel,
    placement,
    targetEl,
    className,
    canClose,
    onDismiss
  } = _a, rest = __objRest(_a, [
    "noArrow",
    "isShowing",
    "children",
    "role",
    "aria-label",
    "placement",
    "targetEl",
    "className",
    "canClose",
    "onDismiss"
  ]);
  activateI18n7(messages10, messages9, messages11);
  const wrapperClasses = r(
    attention.base,
    variantClasses[getVariant(rest)].wrapper
  );
  const [actualDirection, setActualDirection] = useState3(placement);
  const [isVisible, setIsVisible] = useState3(false);
  const isMounted = useRef3(true);
  const attentionRef = useRef3(null);
  const arrowRef = useRef3(null);
  const attentionState = {
    get isShowing() {
      return isShowing;
    },
    get isCallout() {
      return rest.callout;
    },
    get actualDirection() {
      return actualDirection;
    },
    set actualDirection(v3) {
      setActualDirection(v3);
    },
    get directionName() {
      return placement;
    },
    get arrowEl() {
      return arrowRef.current;
    },
    get attentionEl() {
      return attentionRef.current;
    },
    set attentionEl(v3) {
      attentionRef.current = v3;
    },
    get targetEl() {
      return targetEl == null ? void 0 : targetEl.current;
    },
    get noArrow() {
      return props.noArrow;
    }
  };
  const pointingAtDirection = (() => {
    switch (opposites[actualDirection]) {
      case "top":
        return i18n._({
          id: "attention.aria.pointingUp",
          message: "pointing up",
          comment: "Default screenreader message for top direction in the attention component"
        });
      case "right":
        return i18n._({
          id: "attention.aria.pointingRight",
          message: "pointing right",
          comment: "Default screenreader message for right direction in the attention component"
        });
      case "bottom":
        return i18n._({
          id: "attention.aria.pointingDown",
          message: "pointing down",
          comment: "Default screenreader message for bottom direction in the attention component"
        });
      case "left":
        return i18n._({
          id: "attention.aria.pointingLeft",
          message: "pointing left",
          comment: "Default screenreader message for left direction in the attention component"
        });
      default:
        return "";
    }
  })();
  const activeAttentionType = (() => {
    switch (true) {
      case props.tooltip:
        return i18n._({
          id: "attention.aria.tooltip",
          message: "tooltip",
          comment: "Default screenreader message for tooltip in the attention component"
        });
      case props.callout:
        return i18n._({
          id: "attention.aria.callout",
          message: "callout speech bubble",
          comment: "Default screenreader message for callout speech bubble in the attention component"
        });
      case props.popover:
        return i18n._({
          id: "attention.aria.popover",
          message: "popover speech bubble",
          comment: "Default screenreader message for popover speech bubble in the attention component"
        });
      case props.highlight:
        return i18n._({
          id: "attention.aria.highlight",
          message: "highlighted speech bubble",
          comment: "Default screenreader message for highlighted speech bubble in the attention component"
        });
      default:
        return "";
    }
  })();
  const defaultAriaLabel = () => {
    return `${activeAttentionType} ${!props.noArrow ? pointingAtDirection : ""}`;
  };
  useEffect4(() => {
    useRecompute(attentionState);
  });
  useEffect4(() => {
    if (isMounted.current) {
      isMounted.current = false;
      if (isShowing === true || props.callout) {
        setIsVisible(isShowing);
      }
    } else {
      setIsVisible(isShowing);
    }
  }, [isShowing, props.callout]);
  return /* @__PURE__ */ React16.createElement(
    "div",
    {
      className: r(
        {
          [attention.notCallout]: !props.callout,
          invisible: !isVisible && !props.callout,
          hidden: !isVisible && !props.tooltip
        },
        className
      ),
      ref: attentionRef
    },
    /* @__PURE__ */ React16.createElement(
      "div",
      {
        role: props.role === "" ? void 0 : props.tooltip ? "tooltip" : "img",
        "aria-label": ariaLabel === "" ? void 0 : ariaLabel != null ? ariaLabel : defaultAriaLabel(),
        className: wrapperClasses,
        id: props.id
      },
      !props.noArrow && /* @__PURE__ */ React16.createElement(Arrow, __spreadProps(__spreadValues({}, props), { ref: arrowRef, direction: placement })),
      /* @__PURE__ */ React16.createElement("div", { className: attention.content }, props.children),
      canClose && /* @__PURE__ */ React16.createElement(
        "button",
        {
          type: "button",
          "aria-label": i18n._(
            /*i18n*/
            {
              id: "attention.aria.close",
              message: "Close",
              comment: "Aria label for the close button in attention"
            }
          ),
          onClick: onDismiss,
          onKeyDown: (event) => {
            if (!props.onDismiss)
              return;
            if (event.key === "Escape") {
              props.onDismiss();
            }
          },
          className: attention.closeBtn
        },
        /* @__PURE__ */ React16.createElement(close_16_default, null)
      )
    )
  );
}
var arrowDirectionClassname = (dir) => {
  const direction = dir.charAt(0).toUpperCase() + dir.slice(1);
  return `arrowDirection${direction}`;
};
var Arrow = forwardRef((_a, ref) => {
  var _b = _a, { direction } = _b, rest = __objRest(_b, ["direction"]);
  const arrowDirection = opposites[direction];
  const arrowClasses = r(
    attention.arrowBase,
    attention[arrowDirectionClassname(arrowDirection)],
    variantClasses[getVariant(rest)].arrow
  );
  return /* @__PURE__ */ React16.createElement(
    "div",
    {
      ref,
      className: arrowClasses,
      style: {
        // TW doesn't let us specify exactly one corner, only whole sides
        borderTopLeftRadius: "4px",
        zIndex: 1,
        // border alignment is off by a fraction of a pixel, this fixes it
        [`margin${arrowDirectionClassname(arrowDirection)}`]: "-0.5px",
        transform: `rotate(${rotation[arrowDirection]}deg)`
      }
    }
  );
});

// packages/badge/src/component.tsx
import React17 from "react";
function Badge(props) {
  const _a = props, {
    children,
    as = "div",
    variant = "neutral",
    position
  } = _a, rest = __objRest(_a, [
    "children",
    "as",
    "variant",
    "position"
  ]);
  return React17.createElement(
    as,
    __spreadProps(__spreadValues({}, rest), {
      className: r(
        badge.base,
        badge[variant],
        {
          [badge.positionBase]: !!position,
          [badge.positionTL]: position === "top-left",
          [badge.positionTR]: position === "top-right",
          [badge.positionBR]: position === "bottom-right",
          [badge.positionBL]: position === "bottom-left"
        },
        props.className
      )
    }),
    children
  );
}

// packages/box/src/component.tsx
import React18 from "react";
function Box(props) {
  const _a = props, {
    children,
    as = "div",
    bleed,
    clickable: clickable2,
    neutral,
    bordered,
    info,
    role
  } = _a, rest = __objRest(_a, [
    "children",
    "as",
    "bleed",
    "clickable",
    "neutral",
    "bordered",
    "info",
    "role"
  ]);
  return React18.createElement(
    as,
    __spreadProps(__spreadValues({}, rest), {
      role: role != null ? role : "region",
      className: r(
        box.box,
        {
          [box.bleed]: bleed,
          [box.info]: info,
          [box.neutral]: neutral,
          [box.bordered]: bordered,
          [box.infoClickable]: clickable2 && info,
          [box.neutralClickable]: clickable2 && neutral,
          [box.borderedClickable]: clickable2 && bordered
        },
        props.className
      )
    }),
    children
  );
}

// packages/breadcrumbs/src/component.tsx
import * as React19 from "react";

// node_modules/.pnpm/@warp-ds+core@1.0.2/node_modules/@warp-ds/core/dist/breadcrumbs/index.js
function interleave(array, separator) {
  return array.flatMap((el) => [el, separator]).slice(0, -1);
}

// packages/breadcrumbs/src/locales/en/messages.mjs
var messages12 = JSON.parse('{"breadcrumbs.ariaLabel":"You are here"}');

// packages/breadcrumbs/src/locales/nb/messages.mjs
var messages13 = JSON.parse('{"breadcrumbs.ariaLabel":"Her er du"}');

// packages/breadcrumbs/src/locales/fi/messages.mjs
var messages14 = JSON.parse('{"breadcrumbs.ariaLabel":"Olet t\xE4ss\xE4"}');

// packages/breadcrumbs/src/component.tsx
var Breadcrumbs = (props) => {
  const _a = props, { children, className } = _a, rest = __objRest(_a, ["children", "className"]);
  activateI18n7(messages12, messages13, messages14);
  const ariaLabel = props["aria-label"] || i18n._(
    /*i18n*/
    {
      id: "breadcrumbs.ariaLabel",
      message: "You are here",
      comment: "Default screenreader message for the breadcrumb component"
    }
  );
  const flattenedChildren = children.flat(Infinity);
  const styledChildren = flattenedChildren.map((child, index2) => {
    if (React19.isValidElement(child)) {
      const ccClasses = child.type === "a" ? breadcrumbs.link : breadcrumbs.text;
      const newClasses = child.props.className ? `${child.props.className} ${ccClasses}` : ccClasses;
      const styledChild = React19.cloneElement(
        child,
        { className: newClasses }
      );
      return styledChild;
    }
    const isLastEl = index2 === flattenedChildren.length - 1;
    return /* @__PURE__ */ React19.createElement(
      "span",
      {
        className: breadcrumbs.text,
        "aria-current": isLastEl ? "page" : void 0
      },
      child
    );
  });
  return /* @__PURE__ */ React19.createElement(
    "nav",
    __spreadValues({
      className,
      "aria-labelledby": "breadCrumbLabel"
    }, rest),
    /* @__PURE__ */ React19.createElement("h2", { id: "breadCrumbLabel", className: breadcrumbs.a11y }, ariaLabel),
    /* @__PURE__ */ React19.createElement("div", { className: breadcrumbs.wrapper }, interleave(
      styledChildren,
      /* @__PURE__ */ React19.createElement("span", { className: breadcrumbs.separator }, "/")
    ).map((element, index2) => /* @__PURE__ */ React19.createElement(React19.Fragment, { key: index2 }, element)))
  );
};

// packages/button/src/component.tsx
import React20, { forwardRef as forwardRef2 } from "react";

// packages/button/src/locales/en/messages.mjs
var messages15 = JSON.parse('{"button.aria.loading":"Loading..."}');

// packages/button/src/locales/nb/messages.mjs
var messages16 = JSON.parse('{"button.aria.loading":"Laster..."}');

// packages/button/src/locales/fi/messages.mjs
var messages17 = JSON.parse('{"button.aria.loading":"Ladataan\u2026"}');

// packages/button/src/component.tsx
var buttonVariants2 = [
  "primary",
  "secondary",
  "negative",
  "utility",
  "pill",
  "link"
];
var Button = forwardRef2((props, ref) => {
  const _a = props, {
    primary,
    secondary,
    negative,
    utility,
    quiet,
    small,
    link,
    pill: pill2,
    loading,
    fullWidth
  } = _a, rest = __objRest(_a, [
    "primary",
    "secondary",
    "negative",
    "utility",
    "quiet",
    "small",
    "link",
    "pill",
    "loading",
    "fullWidth"
  ]);
  const defaultVariant = secondary || !buttonVariants2.find((b4) => !!props[b4]);
  const classes = r(props.className, {
    [button.secondary]: defaultVariant && !small && !quiet && !loading && !props.disabled,
    [button.secondaryDisabled]: defaultVariant && !small && !quiet && !loading && props.disabled,
    [button.secondarySmall]: defaultVariant && small && !quiet && !loading && !props.disabled,
    [button.secondarySmallDisabled]: defaultVariant && small && !quiet && !loading && props.disabled,
    [button.secondarySmallLoading]: defaultVariant && small && !quiet && loading,
    [button.secondarySmallQuiet]: defaultVariant && small && quiet && !loading && !props.disabled,
    [button.secondarySmallQuietDisabled]: defaultVariant && small && quiet && !loading && props.disabled,
    [button.secondarySmallQuietLoading]: defaultVariant && small && quiet && loading,
    [button.secondaryQuiet]: defaultVariant && !small && quiet && !loading && !props.disabled,
    [button.secondaryQuietDisabled]: defaultVariant && !small && quiet && !loading && props.disabled,
    [button.secondaryQuietLoading]: defaultVariant && !small && quiet && loading,
    [button.secondaryLoading]: defaultVariant && !small && !quiet && loading,
    [button.primary]: primary && !small && !quiet && !loading && !props.disabled,
    [button.primaryDisabled]: primary && !small && !quiet && !loading && props.disabled,
    [button.primarySmall]: primary && small && !quiet && !loading && !props.disabled,
    [button.primarySmallDisabled]: primary && small && !quiet && !loading && props.disabled,
    [button.primarySmallQuiet]: primary && small && quiet && !loading && !props.disabled,
    [button.primarySmallQuietDisabled]: primary && small && quiet && !loading && props.disabled,
    [button.primarySmallLoading]: primary && small && !quiet && loading,
    [button.primarySmallQuietLoading]: primary && small && quiet && loading,
    [button.primaryQuiet]: primary && !small && quiet && !loading && !props.disabled,
    [button.primaryQuietDisabled]: primary && !small && quiet && !loading && props.disabled,
    [button.primaryQuietLoading]: primary && !small && quiet && loading,
    [button.primaryLoading]: primary && !small && !quiet && loading,
    [button.utility]: utility && !small && !quiet && !loading && !props.disabled,
    [button.utilityDisabled]: utility && !small && !quiet && !loading && props.disabled,
    [button.utilitySmall]: utility && small && !quiet && !loading && !props.disabled,
    [button.utilitySmallDisabled]: utility && small && !quiet && !loading && props.disabled,
    [button.utilitySmallQuiet]: utility && small && quiet && !loading && !props.disabled,
    [button.utilitySmallQuietDisabled]: utility && small && quiet && !loading && props.disabled,
    [button.utilitySmallLoading]: utility && small && !quiet && loading,
    [button.utilitySmallQuietLoading]: utility && small && quiet && loading,
    [button.utilityQuiet]: utility && !small && quiet && !loading && !props.disabled,
    [button.utilityQuietDisabled]: utility && !small && quiet && !loading && props.disabled,
    [button.utilityQuietLoading]: utility && !small && quiet && loading,
    [button.utilityLoading]: utility && !small && !quiet && loading,
    [button.negative]: negative && !small && !quiet && !loading && !props.disabled,
    [button.negativeDisabled]: negative && !small && !quiet && !loading && props.disabled,
    [button.negativeSmall]: negative && small && !quiet && !loading && !props.disabled,
    [button.negativeSmallDisabled]: negative && small && !quiet && !loading && props.disabled,
    [button.negativeSmallQuiet]: negative && small && quiet && !loading && !props.disabled,
    [button.negativeSmallQuietDisabled]: negative && small && quiet && !loading && props.disabled,
    [button.negativeSmallLoading]: negative && small && !quiet && loading,
    [button.negativeSmallQuietLoading]: negative && small && quiet && loading,
    [button.negativeQuiet]: negative && !small && quiet && !loading && !props.disabled,
    [button.negativeQuietDisabled]: negative && !small && quiet && !loading && props.disabled,
    [button.negativeQuietLoading]: negative && !small && quiet && loading,
    [button.negativeLoading]: negative && !small && !quiet && loading,
    [button.pill]: pill2 && !small && !loading,
    [button.pillSmall]: pill2 && small && !loading,
    [button.pillLoading]: pill2 && !small && loading,
    [button.pillSmallLoading]: pill2 && small && loading,
    [button.link]: link && !small,
    [button.linkSmall]: link && small,
    [button.linkAsButton]: !!props.href,
    [button.fullWidth]: fullWidth,
    [button.contentWidth]: !fullWidth
  });
  const handleClick = (e2) => {
    if (props.onClick) {
      props.onClick(e2);
    }
  };
  activateI18n7(messages15, messages16, messages17);
  const ariaValueTextLoading = i18n._(
    /*i18n*/
    {
      id: "button.aria.loading",
      message: "Loading...",
      comment: "Screenreader message for buttons that are loading"
    }
  );
  return /* @__PURE__ */ React20.createElement(React20.Fragment, null, props.href ? /* @__PURE__ */ React20.createElement(
    "a",
    {
      onClick: handleClick,
      "aria-current": props["aria-current"],
      href: props.disabled ? void 0 : props.href,
      target: props.target,
      rel: props.target === "_blank" ? props.rel || "noopener" : void 0,
      ref,
      className: classes,
      role: "button",
      "aria-disabled": props.disabled
    },
    props.children
  ) : /* @__PURE__ */ React20.createElement(
    "button",
    __spreadProps(__spreadValues({}, rest), {
      type: props.type || "button",
      ref,
      className: classes,
      role: props.link ? "link" : "button"
    }),
    props.children
  ), props.loading ? /* @__PURE__ */ React20.createElement(
    "span",
    {
      className: "sr-only",
      role: "progressbar",
      "aria-valuenow": 0,
      "aria-valuetext": ariaValueTextLoading
    }
  ) : null);
});

// packages/card/src/component.tsx
import React21 from "react";
function Card(props) {
  const _a = props, { as = "div", children, flat } = _a, rest = __objRest(_a, ["as", "children", "flat"]);
  useLogDeprecationWarning({
    condition: !!props.onClick,
    message: "'onClick' prop in Card is deprecated. Use Clickable component to handle click events in Cards."
  });
  return React21.createElement(
    as,
    __spreadProps(__spreadValues({}, rest), {
      className: r(props.className, {
        [card.card]: true,
        [card.cardShadow]: !props.flat,
        [props.selected ? card.cardSelected : card.cardUnselected]: !props.flat,
        [card.cardFlat]: props.flat,
        [props.selected ? card.cardFlatSelected : card.cardFlatUnselected]: props.flat
      }),
      // @balbinak(08.11.22): onClick support in Card is deprecated. Remove when Fabric React users are ready for this major change
      tabIndex: props.onClick ? 0 : void 0,
      onKeyDown: props.onClick ? (e2) => {
        if (typeof props.onClick === "function" && (e2.key === "Enter" || e2.key === " ")) {
          e2.preventDefault();
          props.onClick();
          return;
        }
      } : void 0
    }),
    /* @__PURE__ */ React21.createElement(React21.Fragment, null, props.onClick && /* @__PURE__ */ React21.createElement(
      "button",
      {
        className: "sr-only",
        "aria-pressed": props.selected,
        tabIndex: -1,
        type: "button"
      },
      "Velg"
    ), !props.flat && /* @__PURE__ */ React21.createElement(
      "div",
      {
        className: r({
          [card.cardOutline]: true,
          [props.selected ? card.cardOutlineSelected : card.cardOutlineUnselected]: true
        })
      }
    ), children)
  );
}

// packages/combobox/src/component.tsx
import React23, {
  forwardRef as forwardRef4,
  useEffect as useEffect5,
  useRef as useRef4,
  useState as useState4
} from "react";

// packages/textfield/src/component.tsx
import React22, { forwardRef as forwardRef3 } from "react";

// packages/textfield/src/locales/nb/messages.mjs
var messages18 = JSON.parse('{"textfield.label.optional":"(valgfritt)"}');

// packages/textfield/src/locales/en/messages.mjs
var messages19 = JSON.parse('{"textfield.label.optional":"(optional)"}');

// packages/textfield/src/locales/fi/messages.mjs
var messages20 = JSON.parse('{"textfield.label.optional":"(vapaaehtoinen)"}');

// packages/textfield/src/component.tsx
var TextField = forwardRef3(
  (props, ref) => {
    const _a = props, {
      className,
      disabled,
      id: providedId,
      children,
      invalid,
      error,
      helpText: helpText2,
      label: label2,
      readOnly,
      type = "text",
      style,
      optional
    } = _a, rest = __objRest(_a, [
      "className",
      "disabled",
      "id",
      "children",
      "invalid",
      "error",
      "helpText",
      "label",
      "readOnly",
      "type",
      "style",
      "optional"
    ]);
    activateI18n7(messages19, messages18, messages20);
    const id = useId(providedId);
    const helpId = helpText2 ? `${id}__hint` : void 0;
    const isInvalid = invalid || error;
    const suffix2 = React22.Children.toArray(children).find(
      (child) => React22.isValidElement(child) && child.props.suffix
    );
    const prefix2 = React22.Children.toArray(children).find(
      (child) => React22.isValidElement(child) && child.props.prefix
    );
    return /* @__PURE__ */ React22.createElement(
      "div",
      {
        className,
        style
      },
      /* @__PURE__ */ React22.createElement("style", null, `
              div+#${id}, button+#${id} {
                padding-left:var(--w-prefix-width, 40px);
              }
            `),
      label2 && /* @__PURE__ */ React22.createElement("label", { htmlFor: id, className: r({
        [label.label]: true,
        [label.labelInvalid]: isInvalid
      }) }, label2, optional && /* @__PURE__ */ React22.createElement("span", { className: label.optional }, i18n._(
        /*i18n*/
        {
          id: "textfield.label.optional",
          message: "(optional)",
          comment: "Shown behind label when marked as optional"
        }
      ))),
      /* @__PURE__ */ React22.createElement("div", { className: input.wrapper }, prefix2, /* @__PURE__ */ React22.createElement(
        "input",
        __spreadProps(__spreadValues({
          className: r({
            [input.default]: true,
            [input.invalid]: isInvalid,
            [input.disabled]: disabled,
            [input.readOnly]: readOnly,
            [input.placeholder]: !!props.placeholder,
            [input.suffix]: !!suffix2,
            [input.prefix]: !!prefix2
          })
        }, rest), {
          "aria-describedby": helpId,
          "aria-errormessage": isInvalid && helpId ? helpId : void 0,
          "aria-invalid": isInvalid,
          disabled,
          id,
          readOnly,
          ref,
          type
        })
      ), suffix2),
      helpText2 && /* @__PURE__ */ React22.createElement("div", { className: r({
        [helpText.helpText]: true,
        [helpText.helpTextInvalid]: isInvalid
      }), id: helpId }, helpText2)
    );
  }
);

// packages/combobox/src/utils.ts
function createOptionsWithIdAndMatch(options, currentInputValue) {
  return options.map((option) => __spreadProps(__spreadValues({}, option), {
    id: generateId(),
    currentInputValue
  }));
}
function getAriaText(options, value) {
  if (!options)
    return;
  const filteredOptionsByInputValue = options.filter(
    (option) => option.value.toLowerCase().includes(value.toLowerCase())
  );
  const pluralResults = i18n._(
    /*i18n*/
    {
      id: "combobox.aria.pluralResults",
      message: "{numResults, plural, one {# result} other {# results}}",
      comment: "Aria text for combobox when one or more results",
      values: { numResults: filteredOptionsByInputValue.length }
    }
  );
  const noResults = i18n._(
    /*i18n*/
    {
      id: "combobox.aria.noResults",
      message: "No results.....",
      comment: "Aria text for combobox when no results"
    }
  );
  return filteredOptionsByInputValue.length ? pluralResults : noResults;
}

// packages/combobox/src/locales/en/messages.mjs
var messages21 = JSON.parse('{"combobox.aria.pluralResults":[["numResults","plural",{"one":["#"," result"],"other":["#"," results"]}]],"combobox.aria.noResults":"No results"}');

// packages/combobox/src/locales/nb/messages.mjs
var messages27 = JSON.parse('{"combobox.aria.pluralResults":[["numResults","plural",{"one":["#"," resultat"],"other":["#"," resultater"]}]],"combobox.aria.noResults":"Ingen resultater"}');

// packages/combobox/src/locales/fi/messages.mjs
var messages28 = JSON.parse('{"combobox.aria.pluralResults":[["numResults","plural",{"one":["#"," tulos"],"other":["#"," tulosta"]}]],"combobox.aria.noResults":"Ei tuloksia"}');

// packages/combobox/src/component.tsx
var OPTION_CLASS_NAME = "w-react-combobox-option";
var MATCH_SEGMENTS_CLASS_NAME = "w-react-combobox-match";
var Combobox = forwardRef4(
  (_a, forwardRef9) => {
    var _b = _a, { id: pid } = _b, props = __objRest(_b, ["id"]);
    const id = useId(pid);
    const listboxId = `${id}-listbox`;
    const inputRef = useRef4(null);
    const inputContainerRef = useRef4(null);
    const containerRef = useRef4(null);
    activateI18n7(messages21, messages27, messages28);
    const [isOpen, setOpen] = useState4(false);
    const [navigationOption, setNavigationOption] = useState4(null);
    const [currentOptions, setCurrentOptions] = useState4([]);
    const _a2 = props, {
      options,
      value,
      label: label2,
      invalid,
      helpText: helpText2,
      placeholder,
      openOnFocus,
      selectOnBlur = true,
      className,
      listClassName,
      disableStaticFiltering = false,
      matchTextSegments,
      children,
      highlightValueMatch,
      onSelect,
      onChange,
      onFocus: onFocus3,
      onBlur: onBlur3,
      optional
    } = _a2, rest = __objRest(_a2, [
      "options",
      "value",
      "label",
      "invalid",
      "helpText",
      "placeholder",
      "openOnFocus",
      "selectOnBlur",
      "className",
      "listClassName",
      "disableStaticFiltering",
      "matchTextSegments",
      "children",
      "highlightValueMatch",
      "onSelect",
      "onChange",
      "onFocus",
      "onBlur",
      "optional"
    ]);
    const navigationValueOrInputValue = (navigationOption == null ? void 0 : navigationOption.value) || value;
    useEffect5(() => {
      setCurrentOptions(
        createOptionsWithIdAndMatch(options, value).filter(
          (option) => !disableStaticFiltering ? option.value.toLocaleLowerCase().includes(value.toLowerCase()) : true
        )
      );
    }, [options, disableStaticFiltering]);
    useEffect5(() => {
      if (disableStaticFiltering && currentOptions.length && currentOptions.length === 1 && !currentOptions.some((o3) => o3.value === value)) {
        setOpen(true);
      }
    }, [currentOptions, value, disableStaticFiltering]);
    function handlekeyDown(e2) {
      const isNavigationKey = [
        "ArrowDown",
        "ArrowUp",
        "PageUp",
        "PageDown",
        "Home",
        "End"
      ].includes(e2.key);
      const ignoreList = ["ArrowDown", "ArrowLeft", "ArrowUp", "ArrowRight"];
      if (isNavigationKey && !isOpen) {
        return setOpen(true);
      } else if (isNavigationKey && isOpen) {
        findAndSetActiveOption(e2, {
          setNavigationOption,
          navigationOption,
          currentOptions
        });
      } else if (e2.altKey || e2.ctrlKey || e2.metaKey || e2.shiftKey) {
        return;
      }
      switch (e2.key) {
        case "Enter":
          if (navigationOption) {
            e2.preventDefault();
            handleSelect(navigationOption);
          }
          setOpen(false);
          break;
        case "Tab":
        case "Delete":
          setOpen(false);
          break;
        case "Escape":
          if (isOpen) {
            setOpen(false);
          } else {
            onChange("");
          }
          setNavigationOption(null);
          break;
        case "Backspace":
          onChange(navigationValueOrInputValue);
          setNavigationOption(null);
          setOpen(true);
          break;
        default:
          if (ignoreList.includes(e2.key)) {
            break;
          }
          setOpen(true);
          if (navigationOption) {
            onChange(navigationOption.value);
            setNavigationOption(null);
          } else {
            onChange(value);
          }
          break;
      }
    }
    useEffect5(() => {
      if (!inputRef.current)
        return;
      const input2 = inputRef.current;
      input2.addEventListener("keydown", handlekeyDown);
      return () => {
        input2.removeEventListener("keydown", handlekeyDown);
      };
    });
    function handleSelect(option) {
      onSelect && onSelect(option.value);
      setOpen(false);
      setNavigationOption(null);
      if (disableStaticFiltering) {
        setCurrentOptions([]);
      }
    }
    const TextFieldProps = __spreadValues({
      id,
      value: navigationValueOrInputValue,
      label: label2,
      optional,
      invalid,
      helpText: helpText2,
      placeholder,
      role: "combobox",
      "aria-label": props["aria-label"],
      "aria-labelledby": props["aria-labelledby"],
      "aria-autocomplete": "list",
      "aria-expanded": isOpen && currentOptions.length !== 0,
      "aria-activedescendant": isOpen ? navigationOption == null ? void 0 : navigationOption.id : void 0,
      "aria-controls": listboxId,
      onChange: function(e2) {
        onChange(e2.target.value);
      },
      onFocus: function() {
        if (!openOnFocus)
          return;
        onFocus3 && onFocus3();
        setOpen(true);
      },
      onBlur: function(e2) {
        handleInputBlur(containerRef, inputContainerRef, e2, setOpen);
        selectOnBlur && (navigationOption || !navigationOption && currentOptions.findIndex((o3) => o3.value === value) !== -1) && onSelect && onSelect((navigationOption == null ? void 0 : navigationOption.value) || value);
        setNavigationOption(null);
        onBlur3 && onBlur3(navigationValueOrInputValue);
      },
      ref: function(node2) {
        inputRef.current = node2;
        if (forwardRef9) {
          if (typeof forwardRef9 === "function") {
            forwardRef9(node2);
          } else {
            forwardRef9.current = node2;
          }
        }
      }
    }, rest);
    return /* @__PURE__ */ React23.createElement(
      "div",
      {
        className: r(className, combobox.wrapper),
        onBlur: (e2) => handleContainerBlur(e2, setOpen),
        ref: containerRef
      },
      /* @__PURE__ */ React23.createElement("div", { ref: inputContainerRef }, children ? (
        // @ts-ignore
        /* @__PURE__ */ React23.createElement(TextField, __spreadValues({}, TextFieldProps), children)
      ) : (
        // @ts-ignore
        /* @__PURE__ */ React23.createElement(TextField, __spreadValues({}, TextFieldProps))
      )),
      /* @__PURE__ */ React23.createElement("span", { className: combobox.a11y, role: "status" }, getAriaText(currentOptions, value)),
      /* @__PURE__ */ React23.createElement(
        "div",
        {
          hidden: !isOpen || !currentOptions.length,
          className: r(
            listClassName,
            combobox.combobox
          ),
          style: {
            zIndex: 3
            // Force popover above misc. page content (mobile safari issue)
          }
        },
        /* @__PURE__ */ React23.createElement(
          "ul",
          {
            id: listboxId,
            role: "listbox",
            className: r(combobox.listbox, {
              [MATCH_SEGMENTS_CLASS_NAME]: matchTextSegments
            })
          },
          currentOptions.map((option) => {
            const display = option.label || option.value;
            let match = [];
            if (matchTextSegments && !highlightValueMatch) {
              const startIdx = display.toLowerCase().indexOf(option.currentInputValue.toLowerCase());
              if (startIdx !== -1) {
                const endIdx = startIdx + option.currentInputValue.length;
                match = /* @__PURE__ */ React23.createElement(React23.Fragment, null, display.substring(0, startIdx), /* @__PURE__ */ React23.createElement("span", { "data-combobox-text-match": true, className: combobox.textMatch }, display.substring(startIdx, endIdx)), display.substring(endIdx));
              } else {
                match = /* @__PURE__ */ React23.createElement("span", null, display);
              }
            } else if (highlightValueMatch) {
              match = highlightValueMatch(display, value);
            }
            return /* @__PURE__ */ React23.createElement(
              "li",
              {
                key: option.id,
                id: option.id,
                role: "option",
                "aria-selected": (navigationOption == null ? void 0 : navigationOption.id) === option.id,
                tabIndex: -1,
                onClick: () => {
                  new Promise((res) => res(setNavigationOption(option))).then(
                    () => {
                      handleSelect(option);
                    }
                  );
                },
                className: r({
                  [`${combobox.option} ${OPTION_CLASS_NAME}`]: true,
                  [combobox.optionSelected]: (navigationOption == null ? void 0 : navigationOption.id) === option.id
                })
              },
              matchTextSegments || highlightValueMatch ? match : display
            );
          })
        )
      )
    );
  }
);
function findAndSetActiveOption(e2, {
  setNavigationOption,
  navigationOption,
  currentOptions
}) {
  e2.preventDefault();
  const currIndex = currentOptions.findIndex(
    (option) => option.id === (navigationOption == null ? void 0 : navigationOption.id)
  );
  const nextIndex = currIndex + 1;
  const prevIndex = currIndex - 1;
  switch (e2.key) {
    case "ArrowDown":
      setNavigationOption(
        nextIndex > currentOptions.length ? null : currentOptions[nextIndex]
      );
      break;
    case "ArrowUp":
      setNavigationOption(
        prevIndex === -2 ? currentOptions[currentOptions.length - 1] : prevIndex < 0 ? null : currentOptions[prevIndex]
      );
      break;
    case "PageUp":
      setNavigationOption(
        currIndex - 10 < 0 ? currentOptions[0] : currentOptions[currIndex - 10]
      );
      break;
    case "PageDown":
      setNavigationOption(
        currIndex + 10 > currentOptions.length ? currentOptions[currentOptions.length - 1] : currentOptions[currIndex + 10]
      );
      break;
    case "Home":
      setNavigationOption(currentOptions[0]);
      break;
    case "End":
      setNavigationOption(currentOptions[currentOptions.length - 1]);
      break;
  }
}
function handleContainerBlur(e2, setOpen) {
  const isClickOutsideContainer = !e2.currentTarget.contains(e2.relatedTarget);
  if (isClickOutsideContainer) {
    setOpen(false);
  }
}
function handleInputBlur(containerRef, inputContainerRef, e2, setOpen) {
  var _a, _b;
  if (!containerRef.current)
    return;
  const isClickOutsideContainer = !((_a = containerRef.current) == null ? void 0 : _a.contains(e2.relatedTarget)) || ((_b = inputContainerRef.current) == null ? void 0 : _b.contains(e2.relatedTarget));
  if (isClickOutsideContainer) {
    setOpen(false);
  }
}

// packages/expandable/src/component.tsx
import React26 from "react";

// node_modules/.pnpm/@warp-ds+icons@2.0.0/node_modules/@warp-ds/icons/dist/react/chevron-down-16.js
import React24 from "react";
var __defProp9 = Object.defineProperty;
var __getOwnPropSymbols8 = Object.getOwnPropertySymbols;
var __hasOwnProp8 = Object.prototype.hasOwnProperty;
var __propIsEnum8 = Object.prototype.propertyIsEnumerable;
var __defNormalProp9 = (obj, key, value) => key in obj ? __defProp9(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues8 = (a4, b4) => {
  for (var prop in b4 || (b4 = {}))
    if (__hasOwnProp8.call(b4, prop))
      __defNormalProp9(a4, prop, b4[prop]);
  if (__getOwnPropSymbols8)
    for (var prop of __getOwnPropSymbols8(b4)) {
      if (__propIsEnum8.call(b4, prop))
        __defNormalProp9(a4, prop, b4[prop]);
    }
  return a4;
};
var messages29 = JSON.parse('{"icon.title.chevron-down":"Nedoverpil"}');
var messages210 = JSON.parse('{"icon.title.chevron-down":"Downward arrow"}');
var messages37 = JSON.parse('{"icon.title.chevron-down":"Nuoli alasp\xE4in"}');
var supportedLocales8 = ["en", "nb", "fi", "da", "sv"];
var defaultLocale9 = "en";
var detectByBrand7 = () => {
  let value;
  switch (process.env.NMP_BRAND) {
    case "FINN":
      value = "nb";
      break;
    case "TORI":
      value = "fi";
      break;
    case "BLOCKET":
      value = "sv";
      break;
    case "DBA":
      value = "da";
      break;
    default:
      value = "en";
  }
  return value;
};
var detectByHost7 = () => {
  var _a;
  const hostname = (_a = document == null ? void 0 : document.location) == null ? void 0 : _a.hostname;
  if (hostname.includes("finn")) {
    return "nb";
  } else if (hostname.includes("tori")) {
    return "fi";
  } else if (hostname.includes("blocket")) {
    return "sv";
  } else if (hostname.includes("dba")) {
    return "da";
  } else {
    return defaultLocale9;
  }
};
var getSupportedLocale8 = (usedLocale) => {
  return supportedLocales8.find(
    (locale) => usedLocale === locale || usedLocale.toLowerCase().includes(locale)
  ) || detectByHost7();
};
function detectLocale8() {
  var _a;
  if (typeof window === "undefined") {
    const serverLocale = detectByBrand7();
    return getSupportedLocale8(serverLocale);
  }
  try {
    const htmlLocale = (_a = document == null ? void 0 : document.documentElement) == null ? void 0 : _a.lang;
    const hostLocale = detectByHost7();
    if (!supportedLocales8.includes(htmlLocale)) {
      console.warn("Unsupported locale set in html lang tag, falling back to detection by hostname");
      return getSupportedLocale8(hostLocale);
    }
    return getSupportedLocale8(htmlLocale != null ? htmlLocale : hostLocale);
  } catch (e2) {
    console.warn("could not detect locale, falling back to source locale", e2);
    return defaultLocale9;
  }
}
var getMessages8 = (locale, enMsg, nbMsg, fiMsg) => {
  if (locale === "nb")
    return nbMsg;
  if (locale === "fi")
    return fiMsg;
  return enMsg;
};
var activateI18n8 = (enMessages, nbMessages, fiMessages) => {
  const locale = detectLocale8();
  const messages410 = getMessages8(locale, enMessages, nbMessages, fiMessages);
  i18n.load(locale, messages410);
  i18n.activate(locale);
};
activateI18n8(messages210, messages29, messages37);
var title7 = i18n.t({ message: `Downward arrow`, id: "icon.title.chevron-down", comment: "Title for chevron-down icon" });
var IconChevronDown16 = (attrs) => React24.createElement("svg", __spreadValues8({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", fill: "none", viewBox: "0 0 16 16", dangerouslySetInnerHTML: { __html: `<title>${title7}</title><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="m2.667 5.333 5.5 5.5 5.5-5.5"></path>` } }, attrs));
var chevron_down_16_default = IconChevronDown16;

// node_modules/.pnpm/@warp-ds+icons@2.0.0/node_modules/@warp-ds/icons/dist/react/chevron-up-16.js
import React25 from "react";
var __defProp10 = Object.defineProperty;
var __getOwnPropSymbols9 = Object.getOwnPropertySymbols;
var __hasOwnProp9 = Object.prototype.hasOwnProperty;
var __propIsEnum9 = Object.prototype.propertyIsEnumerable;
var __defNormalProp10 = (obj, key, value) => key in obj ? __defProp10(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues9 = (a4, b4) => {
  for (var prop in b4 || (b4 = {}))
    if (__hasOwnProp9.call(b4, prop))
      __defNormalProp10(a4, prop, b4[prop]);
  if (__getOwnPropSymbols9)
    for (var prop of __getOwnPropSymbols9(b4)) {
      if (__propIsEnum9.call(b4, prop))
        __defNormalProp10(a4, prop, b4[prop]);
    }
  return a4;
};
var messages30 = JSON.parse('{"icon.title.chevron-up":"Oppoverpil"}');
var messages211 = JSON.parse('{"icon.title.chevron-up":"Upward arrow"}');
var messages38 = JSON.parse('{"icon.title.chevron-up":"Nuoli yl\xF6sp\xE4in"}');
var supportedLocales9 = ["en", "nb", "fi", "da", "sv"];
var defaultLocale10 = "en";
var detectByBrand8 = () => {
  let value;
  switch (process.env.NMP_BRAND) {
    case "FINN":
      value = "nb";
      break;
    case "TORI":
      value = "fi";
      break;
    case "BLOCKET":
      value = "sv";
      break;
    case "DBA":
      value = "da";
      break;
    default:
      value = "en";
  }
  return value;
};
var detectByHost8 = () => {
  var _a;
  const hostname = (_a = document == null ? void 0 : document.location) == null ? void 0 : _a.hostname;
  if (hostname.includes("finn")) {
    return "nb";
  } else if (hostname.includes("tori")) {
    return "fi";
  } else if (hostname.includes("blocket")) {
    return "sv";
  } else if (hostname.includes("dba")) {
    return "da";
  } else {
    return defaultLocale10;
  }
};
var getSupportedLocale9 = (usedLocale) => {
  return supportedLocales9.find(
    (locale) => usedLocale === locale || usedLocale.toLowerCase().includes(locale)
  ) || detectByHost8();
};
function detectLocale9() {
  var _a;
  if (typeof window === "undefined") {
    const serverLocale = detectByBrand8();
    return getSupportedLocale9(serverLocale);
  }
  try {
    const htmlLocale = (_a = document == null ? void 0 : document.documentElement) == null ? void 0 : _a.lang;
    const hostLocale = detectByHost8();
    if (!supportedLocales9.includes(htmlLocale)) {
      console.warn("Unsupported locale set in html lang tag, falling back to detection by hostname");
      return getSupportedLocale9(hostLocale);
    }
    return getSupportedLocale9(htmlLocale != null ? htmlLocale : hostLocale);
  } catch (e2) {
    console.warn("could not detect locale, falling back to source locale", e2);
    return defaultLocale10;
  }
}
var getMessages9 = (locale, enMsg, nbMsg, fiMsg) => {
  if (locale === "nb")
    return nbMsg;
  if (locale === "fi")
    return fiMsg;
  return enMsg;
};
var activateI18n9 = (enMessages, nbMessages, fiMessages) => {
  const locale = detectLocale9();
  const messages410 = getMessages9(locale, enMessages, nbMessages, fiMessages);
  i18n.load(locale, messages410);
  i18n.activate(locale);
};
activateI18n9(messages211, messages30, messages38);
var title8 = i18n.t({ message: `Upward arrow`, id: "icon.title.chevron-up", comment: "Title for chevron-up icon" });
var IconChevronUp16 = (attrs) => React25.createElement("svg", __spreadValues9({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", fill: "none", viewBox: "0 0 16 16", dangerouslySetInnerHTML: { __html: `<title>${title8}</title><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M2.5 11 8 5.5l5.5 5.5"></path>` } }, attrs));
var chevron_up_16_default = IconChevronUp16;

// packages/expandable/src/component.tsx
function Expandable(props) {
  const _a = props, {
    children,
    expanded = false,
    title: title14 = "",
    info = false,
    box: box2 = false,
    bleed = false,
    buttonClass = "",
    contentClass = "",
    className,
    onChange,
    chevron = true,
    animated,
    headingLevel
  } = _a, rest = __objRest(_a, [
    "children",
    "expanded",
    "title",
    "info",
    "box",
    "bleed",
    "buttonClass",
    "contentClass",
    "className",
    "onChange",
    "chevron",
    "animated",
    "headingLevel"
  ]);
  const [stateExpanded, setStateExpanded] = React26.useState(expanded);
  const [showChevronUp, setShowChevronUp] = React26.useState(expanded);
  React26.useEffect(() => {
    setStateExpanded(expanded);
  }, [expanded]);
  const toggleExpandable = (state) => {
    setStateExpanded(!state);
    setTimeout(() => {
      setShowChevronUp(!state);
    }, 200);
    if (onChange)
      onChange(!state);
  };
  return /* @__PURE__ */ React26.createElement(
    "div",
    __spreadProps(__spreadValues({}, rest), {
      className: r(className, {
        [expandable.expandable]: true,
        [expandable.expandableBox]: box2,
        [expandable.expandableBleed]: bleed
      })
    }),
    /* @__PURE__ */ React26.createElement(UnstyledHeading, { level: headingLevel }, /* @__PURE__ */ React26.createElement(
      "button",
      {
        type: "button",
        "aria-expanded": stateExpanded,
        className: r({
          [buttonClass || ""]: true,
          [expandable.button]: true,
          [expandable.buttonBox]: box2
        }),
        onClick: () => toggleExpandable(stateExpanded)
      },
      /* @__PURE__ */ React26.createElement("div", { className: expandable.title }, typeof title14 === "string" ? /* @__PURE__ */ React26.createElement("span", { className: expandable.titleType }, title14) : title14, chevron && /* @__PURE__ */ React26.createElement(
        "div",
        {
          className: r({
            [expandable.chevron]: true,
            [expandable.chevronBox]: box2,
            [expandable.chevronNonBox]: !box2
          })
        },
        showChevronUp ? /* @__PURE__ */ React26.createElement(
          chevron_up_16_default,
          {
            className: r({
              [expandable.chevronTransform]: true,
              [expandable.chevronCollapse]: !stateExpanded && showChevronUp
            })
          }
        ) : /* @__PURE__ */ React26.createElement(
          chevron_down_16_default,
          {
            className: r({
              [expandable.chevronTransform]: true,
              [expandable.chevronExpand]: stateExpanded && !showChevronUp
            })
          }
        )
      ))
    )),
    /* @__PURE__ */ React26.createElement(ExpansionBehaviour, { animated, stateExpanded }, /* @__PURE__ */ React26.createElement(
      "div",
      {
        className: r({
          [contentClass || ""]: true,
          [box.box]: box2,
          [expandable.paddingTop]: box2 && title14
        })
      },
      children
    ))
  );
}
function ExpansionBehaviour({ animated, stateExpanded, children }) {
  return animated ? /* @__PURE__ */ React26.createElement(ExpandTransition, { show: stateExpanded }, children) : /* @__PURE__ */ React26.createElement(
    "div",
    {
      className: r({
        [expandable.expansion]: true,
        [expandable.expansionNotExpanded]: !stateExpanded
      }),
      "aria-hidden": !stateExpanded ? true : void 0
    },
    children
  );
}

// packages/modal/src/component.tsx
import React34, { useEffect as useEffect8, useRef as useRef6 } from "react";

// node_modules/.pnpm/@babel+runtime@7.23.9/node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i4;
  for (i4 = 0; i4 < sourceKeys.length; i4++) {
    key = sourceKeys[i4];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}

// node_modules/.pnpm/@babel+runtime@7.23.9/node_modules/@babel/runtime/helpers/esm/extends.js
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function(target) {
    for (var i4 = 1; i4 < arguments.length; i4++) {
      var source = arguments[i4];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

// node_modules/.pnpm/react-focus-lock@2.9.7_@types+react@18.2.55_react@18.2.0/node_modules/react-focus-lock/dist/es2015/Combination.js
import * as React32 from "react";

// node_modules/.pnpm/react-focus-lock@2.9.7_@types+react@18.2.55_react@18.2.0/node_modules/react-focus-lock/dist/es2015/Lock.js
var import_prop_types2 = __toESM(require_prop_types());
import * as React29 from "react";

// node_modules/.pnpm/focus-lock@1.0.0/node_modules/focus-lock/dist/es2015/constants.js
var FOCUS_GROUP = "data-focus-lock";
var FOCUS_DISABLED = "data-focus-lock-disabled";
var FOCUS_ALLOW = "data-no-focus-lock";
var FOCUS_AUTO = "data-autofocus-inside";
var FOCUS_NO_AUTOFOCUS = "data-no-autofocus";

// node_modules/.pnpm/use-callback-ref@1.3.1_@types+react@18.2.55_react@18.2.0/node_modules/use-callback-ref/dist/es2015/assignRef.js
function assignRef(ref, value) {
  if (typeof ref === "function") {
    ref(value);
  } else if (ref) {
    ref.current = value;
  }
  return ref;
}

// node_modules/.pnpm/use-callback-ref@1.3.1_@types+react@18.2.55_react@18.2.0/node_modules/use-callback-ref/dist/es2015/useRef.js
import { useState as useState5 } from "react";
function useCallbackRef(initialValue, callback) {
  var ref = useState5(function() {
    return {
      // value
      value: initialValue,
      // last callback
      callback,
      // "memoized" public interface
      facade: {
        get current() {
          return ref.value;
        },
        set current(value) {
          var last = ref.value;
          if (last !== value) {
            ref.value = value;
            ref.callback(value, last);
          }
        }
      }
    };
  })[0];
  ref.callback = callback;
  return ref.facade;
}

// node_modules/.pnpm/use-callback-ref@1.3.1_@types+react@18.2.55_react@18.2.0/node_modules/use-callback-ref/dist/es2015/useMergeRef.js
import * as React27 from "react";
var currentValues = /* @__PURE__ */ new WeakMap();
function useMergeRefs(refs, defaultValue) {
  var callbackRef = useCallbackRef(defaultValue || null, function(newValue) {
    return refs.forEach(function(ref) {
      return assignRef(ref, newValue);
    });
  });
  React27.useLayoutEffect(function() {
    var oldValue = currentValues.get(callbackRef);
    if (oldValue) {
      var prevRefs_1 = new Set(oldValue);
      var nextRefs_1 = new Set(refs);
      var current_1 = callbackRef.current;
      prevRefs_1.forEach(function(ref) {
        if (!nextRefs_1.has(ref)) {
          assignRef(ref, null);
        }
      });
      nextRefs_1.forEach(function(ref) {
        if (!prevRefs_1.has(ref)) {
          assignRef(ref, current_1);
        }
      });
    }
    currentValues.set(callbackRef, refs);
  }, [refs]);
  return callbackRef;
}

// node_modules/.pnpm/react-focus-lock@2.9.7_@types+react@18.2.55_react@18.2.0/node_modules/react-focus-lock/dist/es2015/Lock.js
import { useEffect as useEffect7 } from "react";

// node_modules/.pnpm/react-focus-lock@2.9.7_@types+react@18.2.55_react@18.2.0/node_modules/react-focus-lock/dist/es2015/FocusGuard.js
var import_prop_types = __toESM(require_prop_types());
import * as React28 from "react";
var hiddenGuard = {
  width: "1px",
  height: "0px",
  padding: 0,
  overflow: "hidden",
  position: "fixed",
  top: "1px",
  left: "1px"
};
var InFocusGuard = function InFocusGuard2(_ref2) {
  var _ref$children = _ref2.children, children = _ref$children === void 0 ? null : _ref$children;
  return /* @__PURE__ */ React28.createElement(React28.Fragment, null, /* @__PURE__ */ React28.createElement("div", {
    key: "guard-first",
    "data-focus-guard": true,
    "data-focus-auto-guard": true,
    style: hiddenGuard
  }), children, children && /* @__PURE__ */ React28.createElement("div", {
    key: "guard-last",
    "data-focus-guard": true,
    "data-focus-auto-guard": true,
    style: hiddenGuard
  }));
};
InFocusGuard.propTypes = true ? {
  children: import_prop_types.default.node
} : {};

// node_modules/.pnpm/tslib@2.6.2/node_modules/tslib/tslib.es6.mjs
var __assign = function() {
  __assign = Object.assign || function __assign2(t2) {
    for (var s3, i4 = 1, n4 = arguments.length; i4 < n4; i4++) {
      s3 = arguments[i4];
      for (var p4 in s3)
        if (Object.prototype.hasOwnProperty.call(s3, p4))
          t2[p4] = s3[p4];
    }
    return t2;
  };
  return __assign.apply(this, arguments);
};

// node_modules/.pnpm/use-sidecar@1.1.2_@types+react@18.2.55_react@18.2.0/node_modules/use-sidecar/dist/es2015/medium.js
function ItoI(a4) {
  return a4;
}
function innerCreateMedium(defaults, middleware) {
  if (middleware === void 0) {
    middleware = ItoI;
  }
  var buffer = [];
  var assigned = false;
  var medium = {
    read: function() {
      if (assigned) {
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      }
      if (buffer.length) {
        return buffer[buffer.length - 1];
      }
      return defaults;
    },
    useMedium: function(data) {
      var item = middleware(data, assigned);
      buffer.push(item);
      return function() {
        buffer = buffer.filter(function(x3) {
          return x3 !== item;
        });
      };
    },
    assignSyncMedium: function(cb) {
      assigned = true;
      while (buffer.length) {
        var cbs = buffer;
        buffer = [];
        cbs.forEach(cb);
      }
      buffer = {
        push: function(x3) {
          return cb(x3);
        },
        filter: function() {
          return buffer;
        }
      };
    },
    assignMedium: function(cb) {
      assigned = true;
      var pendingQueue = [];
      if (buffer.length) {
        var cbs = buffer;
        buffer = [];
        cbs.forEach(cb);
        pendingQueue = buffer;
      }
      var executeQueue = function() {
        var cbs2 = pendingQueue;
        pendingQueue = [];
        cbs2.forEach(cb);
      };
      var cycle = function() {
        return Promise.resolve().then(executeQueue);
      };
      cycle();
      buffer = {
        push: function(x3) {
          pendingQueue.push(x3);
          cycle();
        },
        filter: function(filter) {
          pendingQueue = pendingQueue.filter(filter);
          return buffer;
        }
      };
    }
  };
  return medium;
}
function createMedium(defaults, middleware) {
  if (middleware === void 0) {
    middleware = ItoI;
  }
  return innerCreateMedium(defaults, middleware);
}
function createSidecarMedium(options) {
  if (options === void 0) {
    options = {};
  }
  var medium = innerCreateMedium(null);
  medium.options = __assign({ async: true, ssr: false }, options);
  return medium;
}

// node_modules/.pnpm/react-focus-lock@2.9.7_@types+react@18.2.55_react@18.2.0/node_modules/react-focus-lock/dist/es2015/medium.js
var mediumFocus = createMedium({}, function(_ref2) {
  var target = _ref2.target, currentTarget = _ref2.currentTarget;
  return {
    target,
    currentTarget
  };
});
var mediumBlur = createMedium();
var mediumEffect = createMedium();
var mediumSidecar = createSidecarMedium({
  async: true
});

// node_modules/.pnpm/react-focus-lock@2.9.7_@types+react@18.2.55_react@18.2.0/node_modules/react-focus-lock/dist/es2015/Lock.js
var emptyArray = [];
var FocusLock = /* @__PURE__ */ React29.forwardRef(function FocusLockUI(props, parentRef) {
  var _extends2;
  var _React$useState = React29.useState(), realObserved = _React$useState[0], setObserved = _React$useState[1];
  var observed = React29.useRef();
  var isActive = React29.useRef(false);
  var originalFocusedElement = React29.useRef(null);
  var children = props.children, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, _props$noFocusGuards = props.noFocusGuards, noFocusGuards = _props$noFocusGuards === void 0 ? false : _props$noFocusGuards, _props$persistentFocu = props.persistentFocus, persistentFocus = _props$persistentFocu === void 0 ? false : _props$persistentFocu, _props$crossFrame = props.crossFrame, crossFrame = _props$crossFrame === void 0 ? true : _props$crossFrame, _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? true : _props$autoFocus, allowTextSelection = props.allowTextSelection, group = props.group, className = props.className, whiteList = props.whiteList, hasPositiveIndices = props.hasPositiveIndices, _props$shards = props.shards, shards = _props$shards === void 0 ? emptyArray : _props$shards, _props$as = props.as, Container = _props$as === void 0 ? "div" : _props$as, _props$lockProps = props.lockProps, containerProps = _props$lockProps === void 0 ? {} : _props$lockProps, SideCar = props.sideCar, _props$returnFocus = props.returnFocus, shouldReturnFocus = _props$returnFocus === void 0 ? false : _props$returnFocus, focusOptions = props.focusOptions, onActivationCallback = props.onActivation, onDeactivationCallback = props.onDeactivation;
  var _React$useState2 = React29.useState({}), id = _React$useState2[0];
  var onActivation = React29.useCallback(function() {
    originalFocusedElement.current = originalFocusedElement.current || document && document.activeElement;
    if (observed.current && onActivationCallback) {
      onActivationCallback(observed.current);
    }
    isActive.current = true;
  }, [onActivationCallback]);
  var onDeactivation = React29.useCallback(function() {
    isActive.current = false;
    if (onDeactivationCallback) {
      onDeactivationCallback(observed.current);
    }
  }, [onDeactivationCallback]);
  useEffect7(function() {
    if (!disabled) {
      originalFocusedElement.current = null;
    }
  }, []);
  var returnFocus = React29.useCallback(function(allowDefer) {
    var returnFocusTo = originalFocusedElement.current;
    if (returnFocusTo && returnFocusTo.focus) {
      var howToReturnFocus = typeof shouldReturnFocus === "function" ? shouldReturnFocus(returnFocusTo) : shouldReturnFocus;
      if (howToReturnFocus) {
        var returnFocusOptions = typeof howToReturnFocus === "object" ? howToReturnFocus : void 0;
        originalFocusedElement.current = null;
        if (allowDefer) {
          Promise.resolve().then(function() {
            return returnFocusTo.focus(returnFocusOptions);
          });
        } else {
          returnFocusTo.focus(returnFocusOptions);
        }
      }
    }
  }, [shouldReturnFocus]);
  var onFocus3 = React29.useCallback(function(event) {
    if (isActive.current) {
      mediumFocus.useMedium(event);
    }
  }, []);
  var onBlur3 = mediumBlur.useMedium;
  var setObserveNode = React29.useCallback(function(newObserved) {
    if (observed.current !== newObserved) {
      observed.current = newObserved;
      setObserved(newObserved);
    }
  }, []);
  if (true) {
    if (typeof allowTextSelection !== "undefined") {
      console.warn("React-Focus-Lock: allowTextSelection is deprecated and enabled by default");
    }
    React29.useEffect(function() {
      if (!observed.current && typeof Container !== "string") {
        console.error("FocusLock: could not obtain ref to internal node");
      }
    }, []);
  }
  var lockProps = _extends((_extends2 = {}, _extends2[FOCUS_DISABLED] = disabled && "disabled", _extends2[FOCUS_GROUP] = group, _extends2), containerProps);
  var hasLeadingGuards = noFocusGuards !== true;
  var hasTailingGuards = hasLeadingGuards && noFocusGuards !== "tail";
  var mergedRef = useMergeRefs([parentRef, setObserveNode]);
  return /* @__PURE__ */ React29.createElement(React29.Fragment, null, hasLeadingGuards && [
    /* @__PURE__ */ React29.createElement("div", {
      key: "guard-first",
      "data-focus-guard": true,
      tabIndex: disabled ? -1 : 0,
      style: hiddenGuard
    }),
    hasPositiveIndices ? /* @__PURE__ */ React29.createElement("div", {
      key: "guard-nearest",
      "data-focus-guard": true,
      tabIndex: disabled ? -1 : 1,
      style: hiddenGuard
    }) : null
  ], !disabled && /* @__PURE__ */ React29.createElement(SideCar, {
    id,
    sideCar: mediumSidecar,
    observed: realObserved,
    disabled,
    persistentFocus,
    crossFrame,
    autoFocus,
    whiteList,
    shards,
    onActivation,
    onDeactivation,
    returnFocus,
    focusOptions
  }), /* @__PURE__ */ React29.createElement(Container, _extends({
    ref: mergedRef
  }, lockProps, {
    className,
    onBlur: onBlur3,
    onFocus: onFocus3
  }), children), hasTailingGuards && /* @__PURE__ */ React29.createElement("div", {
    "data-focus-guard": true,
    tabIndex: disabled ? -1 : 0,
    style: hiddenGuard
  }));
});
FocusLock.propTypes = true ? {
  children: import_prop_types2.node,
  disabled: import_prop_types2.bool,
  returnFocus: (0, import_prop_types2.oneOfType)([import_prop_types2.bool, import_prop_types2.object, import_prop_types2.func]),
  focusOptions: import_prop_types2.object,
  noFocusGuards: import_prop_types2.bool,
  hasPositiveIndices: import_prop_types2.bool,
  allowTextSelection: import_prop_types2.bool,
  autoFocus: import_prop_types2.bool,
  persistentFocus: import_prop_types2.bool,
  crossFrame: import_prop_types2.bool,
  group: import_prop_types2.string,
  className: import_prop_types2.string,
  whiteList: import_prop_types2.func,
  shards: (0, import_prop_types2.arrayOf)(import_prop_types2.any),
  as: (0, import_prop_types2.oneOfType)([import_prop_types2.string, import_prop_types2.func, import_prop_types2.object]),
  lockProps: import_prop_types2.object,
  onActivation: import_prop_types2.func,
  onDeactivation: import_prop_types2.func,
  sideCar: import_prop_types2.any.isRequired
} : {};
var Lock_default = FocusLock;

// node_modules/.pnpm/react-focus-lock@2.9.7_@types+react@18.2.55_react@18.2.0/node_modules/react-focus-lock/dist/es2015/Trap.js
var import_prop_types3 = __toESM(require_prop_types());
import * as React31 from "react";

// node_modules/.pnpm/@babel+runtime@7.23.9/node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js
function _setPrototypeOf(o3, p4) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf2(o4, p5) {
    o4.__proto__ = p5;
    return o4;
  };
  return _setPrototypeOf(o3, p4);
}

// node_modules/.pnpm/@babel+runtime@7.23.9/node_modules/@babel/runtime/helpers/esm/inheritsLoose.js
function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  _setPrototypeOf(subClass, superClass);
}

// node_modules/.pnpm/@babel+runtime@7.23.9/node_modules/@babel/runtime/helpers/esm/typeof.js
function _typeof(o3) {
  "@babel/helpers - typeof";
  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o4) {
    return typeof o4;
  } : function(o4) {
    return o4 && "function" == typeof Symbol && o4.constructor === Symbol && o4 !== Symbol.prototype ? "symbol" : typeof o4;
  }, _typeof(o3);
}

// node_modules/.pnpm/@babel+runtime@7.23.9/node_modules/@babel/runtime/helpers/esm/toPrimitive.js
function toPrimitive(t2, r5) {
  if ("object" != _typeof(t2) || !t2)
    return t2;
  var e2 = t2[Symbol.toPrimitive];
  if (void 0 !== e2) {
    var i4 = e2.call(t2, r5 || "default");
    if ("object" != _typeof(i4))
      return i4;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r5 ? String : Number)(t2);
}

// node_modules/.pnpm/@babel+runtime@7.23.9/node_modules/@babel/runtime/helpers/esm/toPropertyKey.js
function toPropertyKey(t2) {
  var i4 = toPrimitive(t2, "string");
  return "symbol" == _typeof(i4) ? i4 : String(i4);
}

// node_modules/.pnpm/@babel+runtime@7.23.9/node_modules/@babel/runtime/helpers/esm/defineProperty.js
function _defineProperty(obj, key, value) {
  key = toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

// node_modules/.pnpm/react-clientside-effect@1.2.6_react@18.2.0/node_modules/react-clientside-effect/lib/index.es.js
import React30, { PureComponent } from "react";
function withSideEffect(reducePropsToState2, handleStateChangeOnClient2) {
  if (true) {
    if (typeof reducePropsToState2 !== "function") {
      throw new Error("Expected reducePropsToState to be a function.");
    }
    if (typeof handleStateChangeOnClient2 !== "function") {
      throw new Error("Expected handleStateChangeOnClient to be a function.");
    }
  }
  function getDisplayName(WrappedComponent) {
    return WrappedComponent.displayName || WrappedComponent.name || "Component";
  }
  return function wrap(WrappedComponent) {
    if (true) {
      if (typeof WrappedComponent !== "function") {
        throw new Error("Expected WrappedComponent to be a React component.");
      }
    }
    var mountedInstances = [];
    var state;
    function emitChange() {
      state = reducePropsToState2(mountedInstances.map(function(instance) {
        return instance.props;
      }));
      handleStateChangeOnClient2(state);
    }
    var SideEffect = /* @__PURE__ */ function(_PureComponent) {
      _inheritsLoose(SideEffect2, _PureComponent);
      function SideEffect2() {
        return _PureComponent.apply(this, arguments) || this;
      }
      SideEffect2.peek = function peek() {
        return state;
      };
      var _proto = SideEffect2.prototype;
      _proto.componentDidMount = function componentDidMount() {
        mountedInstances.push(this);
        emitChange();
      };
      _proto.componentDidUpdate = function componentDidUpdate() {
        emitChange();
      };
      _proto.componentWillUnmount = function componentWillUnmount() {
        var index2 = mountedInstances.indexOf(this);
        mountedInstances.splice(index2, 1);
        emitChange();
      };
      _proto.render = function render() {
        return /* @__PURE__ */ React30.createElement(WrappedComponent, this.props);
      };
      return SideEffect2;
    }(PureComponent);
    _defineProperty(SideEffect, "displayName", "SideEffect(" + getDisplayName(WrappedComponent) + ")");
    return SideEffect;
  };
}
var index_es_default = withSideEffect;

// node_modules/.pnpm/focus-lock@1.0.0/node_modules/focus-lock/dist/es2015/utils/array.js
var toArray = function(a4) {
  var ret = Array(a4.length);
  for (var i4 = 0; i4 < a4.length; ++i4) {
    ret[i4] = a4[i4];
  }
  return ret;
};
var asArray = function(a4) {
  return Array.isArray(a4) ? a4 : [a4];
};
var getFirst = function(a4) {
  return Array.isArray(a4) ? a4[0] : a4;
};

// node_modules/.pnpm/focus-lock@1.0.0/node_modules/focus-lock/dist/es2015/utils/is.js
var isElementHidden = function(node2) {
  if (node2.nodeType !== Node.ELEMENT_NODE) {
    return false;
  }
  var computedStyle = window.getComputedStyle(node2, null);
  if (!computedStyle || !computedStyle.getPropertyValue) {
    return false;
  }
  return computedStyle.getPropertyValue("display") === "none" || computedStyle.getPropertyValue("visibility") === "hidden";
};
var getParentNode = function(node2) {
  return node2.parentNode && node2.parentNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    node2.parentNode.host
  ) : node2.parentNode;
};
var isTopNode = function(node2) {
  return node2 === document || node2 && node2.nodeType === Node.DOCUMENT_NODE;
};
var isVisibleUncached = function(node2, checkParent) {
  return !node2 || isTopNode(node2) || !isElementHidden(node2) && checkParent(getParentNode(node2));
};
var isVisibleCached = function(visibilityCache, node2) {
  var cached = visibilityCache.get(node2);
  if (cached !== void 0) {
    return cached;
  }
  var result = isVisibleUncached(node2, isVisibleCached.bind(void 0, visibilityCache));
  visibilityCache.set(node2, result);
  return result;
};
var isAutoFocusAllowedUncached = function(node2, checkParent) {
  return node2 && !isTopNode(node2) ? isAutoFocusAllowed(node2) ? checkParent(getParentNode(node2)) : false : true;
};
var isAutoFocusAllowedCached = function(cache2, node2) {
  var cached = cache2.get(node2);
  if (cached !== void 0) {
    return cached;
  }
  var result = isAutoFocusAllowedUncached(node2, isAutoFocusAllowedCached.bind(void 0, cache2));
  cache2.set(node2, result);
  return result;
};
var getDataset = function(node2) {
  return node2.dataset;
};
var isHTMLButtonElement = function(node2) {
  return node2.tagName === "BUTTON";
};
var isHTMLInputElement = function(node2) {
  return node2.tagName === "INPUT";
};
var isRadioElement = function(node2) {
  return isHTMLInputElement(node2) && node2.type === "radio";
};
var notHiddenInput = function(node2) {
  return !((isHTMLInputElement(node2) || isHTMLButtonElement(node2)) && (node2.type === "hidden" || node2.disabled));
};
var isAutoFocusAllowed = function(node2) {
  var attribute = node2.getAttribute(FOCUS_NO_AUTOFOCUS);
  return ![true, "true", ""].includes(attribute);
};
var isGuard = function(node2) {
  var _a;
  return Boolean(node2 && ((_a = getDataset(node2)) === null || _a === void 0 ? void 0 : _a.focusGuard));
};
var isNotAGuard = function(node2) {
  return !isGuard(node2);
};
var isDefined = function(x3) {
  return Boolean(x3);
};

// node_modules/.pnpm/focus-lock@1.0.0/node_modules/focus-lock/dist/es2015/utils/tabOrder.js
var tabSort = function(a4, b4) {
  var tabDiff = a4.tabIndex - b4.tabIndex;
  var indexDiff = a4.index - b4.index;
  if (tabDiff) {
    if (!a4.tabIndex) {
      return 1;
    }
    if (!b4.tabIndex) {
      return -1;
    }
  }
  return tabDiff || indexDiff;
};
var orderByTabIndex = function(nodes, filterNegative, keepGuards) {
  return toArray(nodes).map(function(node2, index2) {
    return {
      node: node2,
      index: index2,
      tabIndex: keepGuards && node2.tabIndex === -1 ? (node2.dataset || {}).focusGuard ? 0 : -1 : node2.tabIndex
    };
  }).filter(function(data) {
    return !filterNegative || data.tabIndex >= 0;
  }).sort(tabSort);
};

// node_modules/.pnpm/focus-lock@1.0.0/node_modules/focus-lock/dist/es2015/utils/tabbables.js
var tabbables = [
  "button:enabled",
  "select:enabled",
  "textarea:enabled",
  "input:enabled",
  // elements with explicit roles will also use explicit tabindex
  // '[role="button"]',
  "a[href]",
  "area[href]",
  "summary",
  "iframe",
  "object",
  "embed",
  "audio[controls]",
  "video[controls]",
  "[tabindex]",
  "[contenteditable]",
  "[autofocus]"
];

// node_modules/.pnpm/focus-lock@1.0.0/node_modules/focus-lock/dist/es2015/utils/tabUtils.js
var queryTabbables = tabbables.join(",");
var queryGuardTabbables = "".concat(queryTabbables, ", [data-focus-guard]");
var getFocusablesWithShadowDom = function(parent, withGuards) {
  return toArray((parent.shadowRoot || parent).children).reduce(function(acc, child) {
    return acc.concat(child.matches(withGuards ? queryGuardTabbables : queryTabbables) ? [child] : [], getFocusablesWithShadowDom(child));
  }, []);
};
var getFocusablesWithIFrame = function(parent, withGuards) {
  var _a;
  if (parent instanceof HTMLIFrameElement && ((_a = parent.contentDocument) === null || _a === void 0 ? void 0 : _a.body)) {
    return getFocusables([parent.contentDocument.body], withGuards);
  }
  return [parent];
};
var getFocusables = function(parents, withGuards) {
  return parents.reduce(function(acc, parent) {
    var _a;
    var focusableWithShadowDom = getFocusablesWithShadowDom(parent, withGuards);
    var focusableWithIframes = (_a = []).concat.apply(_a, focusableWithShadowDom.map(function(node2) {
      return getFocusablesWithIFrame(node2, withGuards);
    }));
    return acc.concat(
      // add all tabbables inside and within shadow DOMs in DOM order
      focusableWithIframes,
      // add if node is tabbable itself
      parent.parentNode ? toArray(parent.parentNode.querySelectorAll(queryTabbables)).filter(function(node2) {
        return node2 === parent;
      }) : []
    );
  }, []);
};
var getParentAutofocusables = function(parent) {
  var parentFocus = parent.querySelectorAll("[".concat(FOCUS_AUTO, "]"));
  return toArray(parentFocus).map(function(node2) {
    return getFocusables([node2]);
  }).reduce(function(acc, nodes) {
    return acc.concat(nodes);
  }, []);
};

// node_modules/.pnpm/focus-lock@1.0.0/node_modules/focus-lock/dist/es2015/utils/DOMutils.js
var filterFocusable = function(nodes, visibilityCache) {
  return toArray(nodes).filter(function(node2) {
    return isVisibleCached(visibilityCache, node2);
  }).filter(function(node2) {
    return notHiddenInput(node2);
  });
};
var filterAutoFocusable = function(nodes, cache2) {
  if (cache2 === void 0) {
    cache2 = /* @__PURE__ */ new Map();
  }
  return toArray(nodes).filter(function(node2) {
    return isAutoFocusAllowedCached(cache2, node2);
  });
};
var getTabbableNodes = function(topNodes, visibilityCache, withGuards) {
  return orderByTabIndex(filterFocusable(getFocusables(topNodes, withGuards), visibilityCache), true, withGuards);
};
var getFocusableNodes = function(topNodes, visibilityCache) {
  return orderByTabIndex(filterFocusable(getFocusables(topNodes), visibilityCache), false);
};
var parentAutofocusables = function(topNode, visibilityCache) {
  return filterFocusable(getParentAutofocusables(topNode), visibilityCache);
};
var contains = function(scope, element) {
  if (scope.shadowRoot) {
    return contains(scope.shadowRoot, element);
  } else {
    if (Object.getPrototypeOf(scope).contains !== void 0 && Object.getPrototypeOf(scope).contains.call(scope, element)) {
      return true;
    }
    return toArray(scope.children).some(function(child) {
      var _a;
      if (child instanceof HTMLIFrameElement) {
        var iframeBody = (_a = child.contentDocument) === null || _a === void 0 ? void 0 : _a.body;
        if (iframeBody) {
          return contains(iframeBody, element);
        }
        return false;
      }
      return contains(child, element);
    });
  }
};

// node_modules/.pnpm/focus-lock@1.0.0/node_modules/focus-lock/dist/es2015/utils/all-affected.js
var filterNested = function(nodes) {
  var contained = /* @__PURE__ */ new Set();
  var l3 = nodes.length;
  for (var i4 = 0; i4 < l3; i4 += 1) {
    for (var j = i4 + 1; j < l3; j += 1) {
      var position = nodes[i4].compareDocumentPosition(nodes[j]);
      if ((position & Node.DOCUMENT_POSITION_CONTAINED_BY) > 0) {
        contained.add(j);
      }
      if ((position & Node.DOCUMENT_POSITION_CONTAINS) > 0) {
        contained.add(i4);
      }
    }
  }
  return nodes.filter(function(_, index2) {
    return !contained.has(index2);
  });
};
var getTopParent = function(node2) {
  return node2.parentNode ? getTopParent(node2.parentNode) : node2;
};
var getAllAffectedNodes = function(node2) {
  var nodes = asArray(node2);
  return nodes.filter(Boolean).reduce(function(acc, currentNode) {
    var group = currentNode.getAttribute(FOCUS_GROUP);
    acc.push.apply(acc, group ? filterNested(toArray(getTopParent(currentNode).querySelectorAll("[".concat(FOCUS_GROUP, '="').concat(group, '"]:not([').concat(FOCUS_DISABLED, '="disabled"])')))) : [currentNode]);
    return acc;
  }, []);
};

// node_modules/.pnpm/focus-lock@1.0.0/node_modules/focus-lock/dist/es2015/utils/safe.js
var safeProbe = function(cb) {
  try {
    return cb();
  } catch (e2) {
    return void 0;
  }
};

// node_modules/.pnpm/focus-lock@1.0.0/node_modules/focus-lock/dist/es2015/utils/getActiveElement.js
var getActiveElement = function(inDocument) {
  if (inDocument === void 0) {
    inDocument = document;
  }
  if (!inDocument || !inDocument.activeElement) {
    return void 0;
  }
  var activeElement = inDocument.activeElement;
  return activeElement.shadowRoot ? getActiveElement(activeElement.shadowRoot) : activeElement instanceof HTMLIFrameElement && safeProbe(function() {
    return activeElement.contentWindow.document;
  }) ? getActiveElement(activeElement.contentWindow.document) : activeElement;
};

// node_modules/.pnpm/focus-lock@1.0.0/node_modules/focus-lock/dist/es2015/focusInside.js
var focusInFrame = function(frame, activeElement) {
  return frame === activeElement;
};
var focusInsideIframe = function(topNode, activeElement) {
  return Boolean(toArray(topNode.querySelectorAll("iframe")).some(function(node2) {
    return focusInFrame(node2, activeElement);
  }));
};
var focusInside = function(topNode, activeElement) {
  if (activeElement === void 0) {
    activeElement = getActiveElement(getFirst(topNode).ownerDocument);
  }
  if (!activeElement || activeElement.dataset && activeElement.dataset.focusGuard) {
    return false;
  }
  return getAllAffectedNodes(topNode).some(function(node2) {
    return contains(node2, activeElement) || focusInsideIframe(node2, activeElement);
  });
};

// node_modules/.pnpm/focus-lock@1.0.0/node_modules/focus-lock/dist/es2015/focusIsHidden.js
var focusIsHidden = function(inDocument) {
  if (inDocument === void 0) {
    inDocument = document;
  }
  var activeElement = getActiveElement(inDocument);
  if (!activeElement) {
    return false;
  }
  return toArray(inDocument.querySelectorAll("[".concat(FOCUS_ALLOW, "]"))).some(function(node2) {
    return contains(node2, activeElement);
  });
};

// node_modules/.pnpm/focus-lock@1.0.0/node_modules/focus-lock/dist/es2015/utils/correctFocus.js
var findSelectedRadio = function(node2, nodes) {
  return nodes.filter(isRadioElement).filter(function(el) {
    return el.name === node2.name;
  }).filter(function(el) {
    return el.checked;
  })[0] || node2;
};
var correctNode = function(node2, nodes) {
  if (isRadioElement(node2) && node2.name) {
    return findSelectedRadio(node2, nodes);
  }
  return node2;
};
var correctNodes = function(nodes) {
  var resultSet = /* @__PURE__ */ new Set();
  nodes.forEach(function(node2) {
    return resultSet.add(correctNode(node2, nodes));
  });
  return nodes.filter(function(node2) {
    return resultSet.has(node2);
  });
};

// node_modules/.pnpm/focus-lock@1.0.0/node_modules/focus-lock/dist/es2015/utils/firstFocus.js
var pickFirstFocus = function(nodes) {
  if (nodes[0] && nodes.length > 1) {
    return correctNode(nodes[0], nodes);
  }
  return nodes[0];
};
var pickFocusable = function(nodes, index2) {
  if (nodes.length > 1) {
    return nodes.indexOf(correctNode(nodes[index2], nodes));
  }
  return index2;
};

// node_modules/.pnpm/focus-lock@1.0.0/node_modules/focus-lock/dist/es2015/solver.js
var NEW_FOCUS = "NEW_FOCUS";
var newFocus = function(innerNodes, outerNodes, activeElement, lastNode) {
  var cnt = innerNodes.length;
  var firstFocus = innerNodes[0];
  var lastFocus = innerNodes[cnt - 1];
  var isOnGuard = isGuard(activeElement);
  if (activeElement && innerNodes.indexOf(activeElement) >= 0) {
    return void 0;
  }
  var activeIndex = activeElement !== void 0 ? outerNodes.indexOf(activeElement) : -1;
  var lastIndex = lastNode ? outerNodes.indexOf(lastNode) : activeIndex;
  var lastNodeInside = lastNode ? innerNodes.indexOf(lastNode) : -1;
  var indexDiff = activeIndex - lastIndex;
  var firstNodeIndex = outerNodes.indexOf(firstFocus);
  var lastNodeIndex = outerNodes.indexOf(lastFocus);
  var correctedNodes = correctNodes(outerNodes);
  var correctedIndex = activeElement !== void 0 ? correctedNodes.indexOf(activeElement) : -1;
  var correctedIndexDiff = correctedIndex - (lastNode ? correctedNodes.indexOf(lastNode) : activeIndex);
  var returnFirstNode = pickFocusable(innerNodes, 0);
  var returnLastNode = pickFocusable(innerNodes, cnt - 1);
  if (activeIndex === -1 || lastNodeInside === -1) {
    return NEW_FOCUS;
  }
  if (!indexDiff && lastNodeInside >= 0) {
    return lastNodeInside;
  }
  if (activeIndex <= firstNodeIndex && isOnGuard && Math.abs(indexDiff) > 1) {
    return returnLastNode;
  }
  if (activeIndex >= lastNodeIndex && isOnGuard && Math.abs(indexDiff) > 1) {
    return returnFirstNode;
  }
  if (indexDiff && Math.abs(correctedIndexDiff) > 1) {
    return lastNodeInside;
  }
  if (activeIndex <= firstNodeIndex) {
    return returnLastNode;
  }
  if (activeIndex > lastNodeIndex) {
    return returnFirstNode;
  }
  if (indexDiff) {
    if (Math.abs(indexDiff) > 1) {
      return lastNodeInside;
    }
    return (cnt + lastNodeInside + indexDiff) % cnt;
  }
  return void 0;
};

// node_modules/.pnpm/focus-lock@1.0.0/node_modules/focus-lock/dist/es2015/utils/auto-focus.js
var findAutoFocused = function(autoFocusables) {
  return function(node2) {
    var _a;
    var autofocus = (_a = getDataset(node2)) === null || _a === void 0 ? void 0 : _a.autofocus;
    return (
      // @ts-expect-error
      node2.autofocus || //
      autofocus !== void 0 && autofocus !== "false" || //
      autoFocusables.indexOf(node2) >= 0
    );
  };
};
var pickAutofocus = function(nodesIndexes, orderedNodes, groups) {
  var nodes = nodesIndexes.map(function(_a) {
    var node2 = _a.node;
    return node2;
  });
  var autoFocusable = filterAutoFocusable(nodes.filter(findAutoFocused(groups)));
  if (autoFocusable && autoFocusable.length) {
    return pickFirstFocus(autoFocusable);
  }
  return pickFirstFocus(filterAutoFocusable(orderedNodes));
};

// node_modules/.pnpm/focus-lock@1.0.0/node_modules/focus-lock/dist/es2015/utils/parenting.js
var getParents = function(node2, parents) {
  if (parents === void 0) {
    parents = [];
  }
  parents.push(node2);
  if (node2.parentNode) {
    getParents(node2.parentNode.host || node2.parentNode, parents);
  }
  return parents;
};
var getCommonParent = function(nodeA, nodeB) {
  var parentsA = getParents(nodeA);
  var parentsB = getParents(nodeB);
  for (var i4 = 0; i4 < parentsA.length; i4 += 1) {
    var currentParent = parentsA[i4];
    if (parentsB.indexOf(currentParent) >= 0) {
      return currentParent;
    }
  }
  return false;
};
var getTopCommonParent = function(baseActiveElement, leftEntry, rightEntries) {
  var activeElements = asArray(baseActiveElement);
  var leftEntries = asArray(leftEntry);
  var activeElement = activeElements[0];
  var topCommon = false;
  leftEntries.filter(Boolean).forEach(function(entry) {
    topCommon = getCommonParent(topCommon || entry, entry) || topCommon;
    rightEntries.filter(Boolean).forEach(function(subEntry) {
      var common = getCommonParent(activeElement, subEntry);
      if (common) {
        if (!topCommon || contains(common, topCommon)) {
          topCommon = common;
        } else {
          topCommon = getCommonParent(common, topCommon);
        }
      }
    });
  });
  return topCommon;
};
var allParentAutofocusables = function(entries, visibilityCache) {
  return entries.reduce(function(acc, node2) {
    return acc.concat(parentAutofocusables(node2, visibilityCache));
  }, []);
};

// node_modules/.pnpm/focus-lock@1.0.0/node_modules/focus-lock/dist/es2015/focusSolver.js
var reorderNodes = function(srcNodes, dstNodes) {
  var remap = /* @__PURE__ */ new Map();
  dstNodes.forEach(function(entity) {
    return remap.set(entity.node, entity);
  });
  return srcNodes.map(function(node2) {
    return remap.get(node2);
  }).filter(isDefined);
};
var focusSolver = function(topNode, lastNode) {
  var activeElement = getActiveElement(asArray(topNode).length > 0 ? document : getFirst(topNode).ownerDocument);
  var entries = getAllAffectedNodes(topNode).filter(isNotAGuard);
  var commonParent = getTopCommonParent(activeElement || topNode, topNode, entries);
  var visibilityCache = /* @__PURE__ */ new Map();
  var anyFocusable = getFocusableNodes(entries, visibilityCache);
  var innerElements = getTabbableNodes(entries, visibilityCache).filter(function(_a) {
    var node2 = _a.node;
    return isNotAGuard(node2);
  });
  if (!innerElements[0]) {
    innerElements = anyFocusable;
    if (!innerElements[0]) {
      return void 0;
    }
  }
  var outerNodes = getFocusableNodes([commonParent], visibilityCache).map(function(_a) {
    var node2 = _a.node;
    return node2;
  });
  var orderedInnerElements = reorderNodes(outerNodes, innerElements);
  var innerNodes = orderedInnerElements.map(function(_a) {
    var node2 = _a.node;
    return node2;
  });
  var newId = newFocus(innerNodes, outerNodes, activeElement, lastNode);
  if (newId === NEW_FOCUS) {
    var focusNode = pickAutofocus(anyFocusable, innerNodes, allParentAutofocusables(entries, visibilityCache));
    if (focusNode) {
      return { node: focusNode };
    } else {
      console.warn("focus-lock: cannot find any node to move focus into");
      return void 0;
    }
  }
  if (newId === void 0) {
    return newId;
  }
  return orderedInnerElements[newId];
};

// node_modules/.pnpm/focus-lock@1.0.0/node_modules/focus-lock/dist/es2015/focusables.js
var expandFocusableNodes = function(topNode) {
  var entries = getAllAffectedNodes(topNode).filter(isNotAGuard);
  var commonParent = getTopCommonParent(topNode, topNode, entries);
  var visibilityCache = /* @__PURE__ */ new Map();
  var outerNodes = getTabbableNodes([commonParent], visibilityCache, true);
  var innerElements = getTabbableNodes(entries, visibilityCache).filter(function(_a) {
    var node2 = _a.node;
    return isNotAGuard(node2);
  }).map(function(_a) {
    var node2 = _a.node;
    return node2;
  });
  return outerNodes.map(function(_a) {
    var node2 = _a.node, index2 = _a.index;
    return {
      node: node2,
      index: index2,
      lockItem: innerElements.indexOf(node2) >= 0,
      guard: isGuard(node2)
    };
  });
};

// node_modules/.pnpm/focus-lock@1.0.0/node_modules/focus-lock/dist/es2015/commands.js
var focusOn = function(target, focusOptions) {
  if ("focus" in target) {
    target.focus(focusOptions);
  }
  if ("contentWindow" in target && target.contentWindow) {
    target.contentWindow.focus();
  }
};

// node_modules/.pnpm/focus-lock@1.0.0/node_modules/focus-lock/dist/es2015/moveFocusInside.js
var guardCount = 0;
var lockDisabled = false;
var moveFocusInside = function(topNode, lastNode, options) {
  if (options === void 0) {
    options = {};
  }
  var focusable = focusSolver(topNode, lastNode);
  if (lockDisabled) {
    return;
  }
  if (focusable) {
    if (guardCount > 2) {
      console.error("FocusLock: focus-fighting detected. Only one focus management system could be active. See https://github.com/theKashey/focus-lock/#focus-fighting");
      lockDisabled = true;
      setTimeout(function() {
        lockDisabled = false;
      }, 1);
      return;
    }
    guardCount++;
    focusOn(focusable.node, options.focusOptions);
    guardCount--;
  }
};

// node_modules/.pnpm/react-focus-lock@2.9.7_@types+react@18.2.55_react@18.2.0/node_modules/react-focus-lock/dist/es2015/util.js
function deferAction(action) {
  setTimeout(action, 1);
}

// node_modules/.pnpm/react-focus-lock@2.9.7_@types+react@18.2.55_react@18.2.0/node_modules/react-focus-lock/dist/es2015/Trap.js
var focusOnBody = function focusOnBody2() {
  return document && document.activeElement === document.body;
};
var isFreeFocus = function isFreeFocus2() {
  return focusOnBody() || focusIsHidden();
};
var lastActiveTrap = null;
var lastActiveFocus = null;
var lastPortaledElement = null;
var focusWasOutsideWindow = false;
var defaultWhitelist = function defaultWhitelist2() {
  return true;
};
var focusWhitelisted = function focusWhitelisted2(activeElement) {
  return (lastActiveTrap.whiteList || defaultWhitelist)(activeElement);
};
var recordPortal = function recordPortal2(observerNode, portaledElement) {
  lastPortaledElement = {
    observerNode,
    portaledElement
  };
};
var focusIsPortaledPair = function focusIsPortaledPair2(element) {
  return lastPortaledElement && lastPortaledElement.portaledElement === element;
};
function autoGuard(startIndex, end, step2, allNodes) {
  var lastGuard = null;
  var i4 = startIndex;
  do {
    var item = allNodes[i4];
    if (item.guard) {
      if (item.node.dataset.focusAutoGuard) {
        lastGuard = item;
      }
    } else if (item.lockItem) {
      if (i4 !== startIndex) {
        return;
      }
      lastGuard = null;
    } else {
      break;
    }
  } while ((i4 += step2) !== end);
  if (lastGuard) {
    lastGuard.node.tabIndex = 0;
  }
}
var extractRef = function extractRef2(ref) {
  return ref && "current" in ref ? ref.current : ref;
};
var focusWasOutside = function focusWasOutside2(crossFrameOption) {
  if (crossFrameOption) {
    return Boolean(focusWasOutsideWindow);
  }
  return focusWasOutsideWindow === "meanwhile";
};
var checkInHost = function checkInHost2(check, el, boundary) {
  return el && (el.host === check && (!el.activeElement || boundary.contains(el.activeElement)) || el.parentNode && checkInHost2(check, el.parentNode, boundary));
};
var withinHost = function withinHost2(activeElement, workingArea) {
  return workingArea.some(function(area) {
    return checkInHost(activeElement, area, area);
  });
};
var activateTrap = function activateTrap2() {
  var result = false;
  if (lastActiveTrap) {
    var _lastActiveTrap = lastActiveTrap, observed = _lastActiveTrap.observed, persistentFocus = _lastActiveTrap.persistentFocus, autoFocus = _lastActiveTrap.autoFocus, shards = _lastActiveTrap.shards, crossFrame = _lastActiveTrap.crossFrame, focusOptions = _lastActiveTrap.focusOptions;
    var workingNode = observed || lastPortaledElement && lastPortaledElement.portaledElement;
    var activeElement = document && document.activeElement;
    if (workingNode) {
      var workingArea = [workingNode].concat(shards.map(extractRef).filter(Boolean));
      if (!activeElement || focusWhitelisted(activeElement)) {
        if (persistentFocus || focusWasOutside(crossFrame) || !isFreeFocus() || !lastActiveFocus && autoFocus) {
          if (workingNode && !(focusInside(workingArea) || activeElement && withinHost(activeElement, workingArea) || focusIsPortaledPair(activeElement, workingNode))) {
            if (document && !lastActiveFocus && activeElement && !autoFocus) {
              if (activeElement.blur) {
                activeElement.blur();
              }
              document.body.focus();
            } else {
              result = moveFocusInside(workingArea, lastActiveFocus, {
                focusOptions
              });
              lastPortaledElement = {};
            }
          }
          focusWasOutsideWindow = false;
          lastActiveFocus = document && document.activeElement;
        }
      }
      if (document) {
        var newActiveElement = document && document.activeElement;
        var allNodes = expandFocusableNodes(workingArea);
        var focusedIndex = allNodes.map(function(_ref2) {
          var node2 = _ref2.node;
          return node2;
        }).indexOf(newActiveElement);
        if (focusedIndex > -1) {
          allNodes.filter(function(_ref2) {
            var guard = _ref2.guard, node2 = _ref2.node;
            return guard && node2.dataset.focusAutoGuard;
          }).forEach(function(_ref3) {
            var node2 = _ref3.node;
            return node2.removeAttribute("tabIndex");
          });
          autoGuard(focusedIndex, allNodes.length, 1, allNodes);
          autoGuard(focusedIndex, -1, -1, allNodes);
        }
      }
    }
  }
  return result;
};
var onTrap = function onTrap2(event) {
  if (activateTrap() && event) {
    event.stopPropagation();
    event.preventDefault();
  }
};
var onBlur = function onBlur2() {
  return deferAction(activateTrap);
};
var onFocus = function onFocus2(event) {
  var source = event.target;
  var currentNode = event.currentTarget;
  if (!currentNode.contains(source)) {
    recordPortal(currentNode, source);
  }
};
var FocusWatcher = function FocusWatcher2() {
  return null;
};
var FocusTrap = function FocusTrap2(_ref4) {
  var children = _ref4.children;
  return /* @__PURE__ */ React31.createElement("div", {
    onBlur,
    onFocus
  }, children);
};
FocusTrap.propTypes = true ? {
  children: import_prop_types3.default.node.isRequired
} : {};
var onWindowBlur = function onWindowBlur2() {
  focusWasOutsideWindow = "just";
  deferAction(function() {
    focusWasOutsideWindow = "meanwhile";
  });
};
var attachHandler = function attachHandler2() {
  document.addEventListener("focusin", onTrap);
  document.addEventListener("focusout", onBlur);
  window.addEventListener("blur", onWindowBlur);
};
var detachHandler = function detachHandler2() {
  document.removeEventListener("focusin", onTrap);
  document.removeEventListener("focusout", onBlur);
  window.removeEventListener("blur", onWindowBlur);
};
function reducePropsToState(propsList) {
  return propsList.filter(function(_ref5) {
    var disabled = _ref5.disabled;
    return !disabled;
  });
}
function handleStateChangeOnClient(traps) {
  var trap = traps.slice(-1)[0];
  if (trap && !lastActiveTrap) {
    attachHandler();
  }
  var lastTrap = lastActiveTrap;
  var sameTrap = lastTrap && trap && trap.id === lastTrap.id;
  lastActiveTrap = trap;
  if (lastTrap && !sameTrap) {
    lastTrap.onDeactivation();
    if (!traps.filter(function(_ref6) {
      var id = _ref6.id;
      return id === lastTrap.id;
    }).length) {
      lastTrap.returnFocus(!trap);
    }
  }
  if (trap) {
    lastActiveFocus = null;
    if (!sameTrap || lastTrap.observed !== trap.observed) {
      trap.onActivation();
    }
    activateTrap(true);
    deferAction(activateTrap);
  } else {
    detachHandler();
    lastActiveFocus = null;
  }
}
mediumFocus.assignSyncMedium(onFocus);
mediumBlur.assignMedium(onBlur);
mediumEffect.assignMedium(function(cb) {
  return cb({
    moveFocusInside,
    focusInside
  });
});
var Trap_default = index_es_default(reducePropsToState, handleStateChangeOnClient)(FocusWatcher);

// node_modules/.pnpm/react-focus-lock@2.9.7_@types+react@18.2.55_react@18.2.0/node_modules/react-focus-lock/dist/es2015/Combination.js
var FocusLockCombination = /* @__PURE__ */ React32.forwardRef(function FocusLockUICombination(props, ref) {
  return /* @__PURE__ */ React32.createElement(Lock_default, _extends({
    sideCar: Trap_default,
    ref
  }, props));
});
var _ref = Lock_default.propTypes || {};
var sideCar = _ref.sideCar;
var propTypes = _objectWithoutPropertiesLoose(_ref, ["sideCar"]);
FocusLockCombination.propTypes = true ? propTypes : {};
var Combination_default = FocusLockCombination;

// node_modules/.pnpm/react-focus-lock@2.9.7_@types+react@18.2.55_react@18.2.0/node_modules/react-focus-lock/dist/es2015/index.js
var es2015_default = Combination_default;

// node_modules/.pnpm/scroll-doctor@2.0.2/node_modules/scroll-doctor/dist/scroll-doctor.js
var n3 = [];
var c3 = { documentElement: {}, body: {} };
var i3 = Object.freeze({
  // html
  documentElement: {
    "scrollbar-gutter": "stable"
  },
  body: {
    overflow: "hidden",
    position: "relative",
    height: "100%"
  }
});
var r4 = (t2) => {
  var _a;
  t2.touches.length > 1 || ((_a = t2.preventDefault) == null ? void 0 : _a.call(t2));
};
var h3 = (t2) => ([e2, s3]) => {
  c3[t2][e2] = document[t2].style[e2], document[t2].style[e2] = s3;
};
var a3 = () => Object.entries(i3).forEach(([t2, e2]) => {
  Object.entries(e2).forEach(h3(t2));
});
var d3 = (t2) => ([e2, s3]) => {
  document[t2].style[e2] = c3[t2][e2];
};
var f3 = () => Object.entries(c3).forEach(([t2, e2]) => {
  Object.entries(e2).forEach(d3(t2));
});
var m3 = (t2) => t2.scrollHeight - Math.abs(t2.scrollTop) === t2.clientHeight;
function y3(t2) {
  let e2 = -1;
  const s3 = (o3) => {
    if (o3.targetTouches.length !== 1)
      return;
    const l3 = o3.targetTouches[0].clientY - e2;
    return t2.scrollTop === 0 && l3 > 0 || m3(t2) && l3 < 0 ? r4(o3) : (o3.stopPropagation(), true);
  };
  t2.ontouchstart = (o3) => {
    o3.targetTouches.length === 1 && (e2 = o3.targetTouches[0].clientY);
  }, t2.ontouchmove = s3;
}
function p3(t2) {
  t2.ontouchstart = null, t2.ontouchmove = null;
}
var u3 = (t2) => () => document[t2 ? "addEventListener" : "removeEventListener"]("touchmove", r4, { passive: false });
var b3 = u3(true);
var g3 = u3();
function E3(t2) {
  if (!t2)
    throw Error("Could not run setup, an element must be provided");
  n3.some((e2) => e2 === t2) || (n3.length || (a3(), b3()), y3(t2), n3.push(t2));
}
function T3() {
  n3.forEach(p3), g3(), f3(), n3 = [];
}

// packages/modal/src/locales/nb/messages.mjs
var messages31 = JSON.parse('{"modal.aria.back":"Tilbake","modal.aria.close":"Lukk"}');

// packages/modal/src/locales/en/messages.mjs
var messages39 = JSON.parse('{"modal.aria.back":"Back","modal.aria.close":"Close"}');

// packages/modal/src/locales/fi/messages.mjs
var messages40 = JSON.parse('{"modal.aria.back":"Takaisin","modal.aria.close":"Sulje"}');

// node_modules/.pnpm/@warp-ds+icons@2.0.0/node_modules/@warp-ds/icons/dist/react/arrow-left-16.js
import React33 from "react";
var __defProp11 = Object.defineProperty;
var __getOwnPropSymbols10 = Object.getOwnPropertySymbols;
var __hasOwnProp10 = Object.prototype.hasOwnProperty;
var __propIsEnum10 = Object.prototype.propertyIsEnumerable;
var __defNormalProp11 = (obj, key, value) => key in obj ? __defProp11(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues10 = (a4, b4) => {
  for (var prop in b4 || (b4 = {}))
    if (__hasOwnProp10.call(b4, prop))
      __defNormalProp11(a4, prop, b4[prop]);
  if (__getOwnPropSymbols10)
    for (var prop of __getOwnPropSymbols10(b4)) {
      if (__propIsEnum10.call(b4, prop))
        __defNormalProp11(a4, prop, b4[prop]);
    }
  return a4;
};
var messages41 = JSON.parse('{"icon.title.arrow-left":"Pil som peker mot venstre"}');
var messages212 = JSON.parse('{"icon.title.arrow-left":"Leftward-pointing arrow"}');
var messages310 = JSON.parse('{"icon.title.arrow-left":"Vasemmalle osoittava nuoli"}');
var supportedLocales10 = ["en", "nb", "fi", "da", "sv"];
var defaultLocale11 = "en";
var detectByBrand9 = () => {
  let value;
  switch (process.env.NMP_BRAND) {
    case "FINN":
      value = "nb";
      break;
    case "TORI":
      value = "fi";
      break;
    case "BLOCKET":
      value = "sv";
      break;
    case "DBA":
      value = "da";
      break;
    default:
      value = "en";
  }
  return value;
};
var detectByHost9 = () => {
  var _a;
  const hostname = (_a = document == null ? void 0 : document.location) == null ? void 0 : _a.hostname;
  if (hostname.includes("finn")) {
    return "nb";
  } else if (hostname.includes("tori")) {
    return "fi";
  } else if (hostname.includes("blocket")) {
    return "sv";
  } else if (hostname.includes("dba")) {
    return "da";
  } else {
    return defaultLocale11;
  }
};
var getSupportedLocale10 = (usedLocale) => {
  return supportedLocales10.find(
    (locale) => usedLocale === locale || usedLocale.toLowerCase().includes(locale)
  ) || detectByHost9();
};
function detectLocale10() {
  var _a;
  if (typeof window === "undefined") {
    const serverLocale = detectByBrand9();
    return getSupportedLocale10(serverLocale);
  }
  try {
    const htmlLocale = (_a = document == null ? void 0 : document.documentElement) == null ? void 0 : _a.lang;
    const hostLocale = detectByHost9();
    if (!supportedLocales10.includes(htmlLocale)) {
      console.warn("Unsupported locale set in html lang tag, falling back to detection by hostname");
      return getSupportedLocale10(hostLocale);
    }
    return getSupportedLocale10(htmlLocale != null ? htmlLocale : hostLocale);
  } catch (e2) {
    console.warn("could not detect locale, falling back to source locale", e2);
    return defaultLocale11;
  }
}
var getMessages10 = (locale, enMsg, nbMsg, fiMsg) => {
  if (locale === "nb")
    return nbMsg;
  if (locale === "fi")
    return fiMsg;
  return enMsg;
};
var activateI18n10 = (enMessages, nbMessages, fiMessages) => {
  const locale = detectLocale10();
  const messages410 = getMessages10(locale, enMessages, nbMessages, fiMessages);
  i18n.load(locale, messages410);
  i18n.activate(locale);
};
activateI18n10(messages212, messages41, messages310);
var title9 = i18n.t({ message: `Leftward-pointing arrow`, id: "icon.title.arrow-left", comment: "Title for table arrow left icon" });
var IconArrowLeft16 = (attrs) => React33.createElement("svg", __spreadValues10({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", fill: "none", viewBox: "0 0 16 16", dangerouslySetInnerHTML: { __html: `<title>${title9}</title><path stroke="currentColor" stroke-linecap="round" stroke-width="1.5" d="M5.222 8h6.667"></path><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M7.444 11.75 4.111 8l3.333-3.75"></path>` } }, attrs));
var arrow_left_16_default = IconArrowLeft16;

// packages/modal/src/component.tsx
var Modal = (_a) => {
  var _b = _a, {
    "aria-label": ariaLabel,
    "aria-labelledby": ariaLabelledBy
  } = _b, props = __objRest(_b, [
    "aria-label",
    "aria-labelledby"
  ]);
  const contentRef = useRef6(null);
  const id = useId(props.id);
  const closeButtonRef = useRef6(null);
  activateI18n7(messages39, messages31, messages40);
  useEffect8(() => {
    return () => T3();
  }, []);
  useEffect8(() => {
    T3();
    if (!contentRef.current)
      return;
    props.open && E3(contentRef.current);
  }, [props.open, contentRef]);
  useEffect8(() => {
    var _a2, _b2;
    if (!props.initialFocusRef) {
      props.right && ((_a2 = closeButtonRef.current) == null ? void 0 : _a2.focus());
    } else {
      (_b2 = props.initialFocusRef.current) == null ? void 0 : _b2.focus();
    }
  }, [props.open, props.initialFocusRef, props.right]);
  if (!props.open)
    return /* @__PURE__ */ React34.createElement(React34.Fragment, null);
  return /* @__PURE__ */ React34.createElement(es2015_default, null, /* @__PURE__ */ React34.createElement(
    "div",
    {
      onClick: props.onDismiss,
      className: r(
        props.className,
        modal.backdrop
      ),
      style: __spreadValues({}, props.style)
    },
    /* @__PURE__ */ React34.createElement(
      "div",
      {
        role: "dialog",
        "aria-modal": "true",
        id,
        onClick: (e2) => {
          e2.stopPropagation();
        },
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledBy != null ? ariaLabelledBy : props.title && !ariaLabel ? `${id}__title` : void 0,
        onKeyDown: (event) => {
          if (!props.onDismiss)
            return;
          if (event.key === "Escape") {
            props.onDismiss();
          }
        },
        className: modal.modal,
        tabIndex: -1
      },
      /* @__PURE__ */ React34.createElement("div", { className: modal.title }, typeof props.left === "boolean" && props.left ? /* @__PURE__ */ React34.createElement(
        "button",
        {
          type: "button",
          "aria-label": i18n._(
            /*i18n*/
            {
              id: "modal.aria.back",
              message: "Back",
              comment: "Aria label for the back button in modal"
            }
          ),
          className: r(
            modal.transitionTitle,
            modal.titleButton,
            modal.titleButtonLeft
          ),
          onClick: props.onLeftClick ? props.onLeftClick : props.onDismiss
        },
        /* @__PURE__ */ React34.createElement(
          arrow_left_16_default,
          {
            className: r(modal.titleButtonIcon)
          }
        )
      ) : props.left, /* @__PURE__ */ React34.createElement(
        "div",
        {
          id: `${id}__title`,
          className: r(
            modal.transitionTitle,
            !!props.left ? modal.transitionTitleCenter : modal.transitionTitleColSpan
          )
        },
        typeof props.title === "string" ? /* @__PURE__ */ React34.createElement("h1", { className: modal.titleText }, props.title) : props.title
      ), typeof props.right === "boolean" && props.right ? /* @__PURE__ */ React34.createElement(
        "button",
        {
          ref: closeButtonRef,
          type: "button",
          "aria-label": i18n._(
            /*i18n*/
            {
              id: "modal.aria.close",
              message: "Close",
              comment: "Aria label for the close button in modal"
            }
          ),
          onClick: props.onDismiss,
          className: r(
            modal.transitionTitle,
            modal.titleButton,
            modal.titleButtonRight
          )
        },
        /* @__PURE__ */ React34.createElement(close_16_default, { className: modal.titleButtonIcon })
      ) : props.right),
      /* @__PURE__ */ React34.createElement("div", { ref: contentRef, className: modal.content }, props.children),
      !!props.footer && /* @__PURE__ */ React34.createElement("div", { className: modal.footer }, props.footer)
    )
  ));
};

// packages/pill/src/component.tsx
import React35 from "react";

// packages/pill/src/locales/nb/messages.mjs
var messages42 = JSON.parse('{"pill.aria.openFilter":"\xC5pne filter","pill.aria.removeFilter":["Fjern filter ",["label"]]}');

// packages/pill/src/locales/en/messages.mjs
var messages43 = JSON.parse('{"pill.aria.openFilter":"Open filter","pill.aria.removeFilter":["Remove filter ",["label"]]}');

// packages/pill/src/locales/fi/messages.mjs
var messages44 = JSON.parse('{"pill.aria.openFilter":"Avaa suodatin","pill.aria.removeFilter":["Tyhjenn\xE4 suodatin ",["label"]]}');

// packages/pill/src/component.tsx
function Pill(props) {
  activateI18n7(messages43, messages42, messages44);
  return /* @__PURE__ */ React35.createElement("div", { className: pill.pill }, /* @__PURE__ */ React35.createElement(
    "button",
    {
      type: "button",
      onClick: props.onClick,
      className: r(!props.canClose ? props.className : "", {
        [pill.button]: true,
        [props.suggestion ? pill.suggestion : pill.filter]: true,
        [pill.label]: true,
        [props.canClose ? pill.labelWithClose : pill.labelWithoutClose]: true
      })
    },
    /* @__PURE__ */ React35.createElement("span", { className: pill.a11y }, props.openSRLabel || i18n._(
      /*i18n*/
      {
        id: "pill.aria.openFilter",
        message: "Open filter",
        comment: "Fallback screenreader message for open filter",
        values: { label: props.label }
      }
    )),
    props.icon || /* @__PURE__ */ React35.createElement("span", null, props.label)
  ), props.canClose && /* @__PURE__ */ React35.createElement(
    "button",
    {
      type: "button",
      className: r(props.className, {
        [pill.button]: true,
        [props.suggestion ? pill.suggestion : pill.filter]: true,
        [pill.close]: true
      }),
      onClick: props.onClose
    },
    /* @__PURE__ */ React35.createElement("span", { className: pill.a11y }, props.closeSRLabel || i18n._(
      /*i18n*/
      {
        id: "pill.aria.removeFilter",
        message: "Remove filter {label}",
        comment: "Fallback screenreader message for removal of the filter",
        values: { label: props.label }
      }
    )),
    /* @__PURE__ */ React35.createElement(close_16_default, null)
  ));
}

// packages/select/src/component.tsx
import * as React36 from "react";

// packages/select/src/locales/nb/messages.mjs
var messages45 = JSON.parse('{"select.label.optional":"(valgfritt)"}');

// packages/select/src/locales/en/messages.mjs
var messages46 = JSON.parse('{"select.label.optional":"(optional)"}');

// packages/select/src/locales/fi/messages.mjs
var messages47 = JSON.parse('{"select.label.optional":"(vapaaehtoinen)"}');

// packages/select/src/component.tsx
var setup = (props) => {
  const _a = props, {
    className,
    invalid,
    id,
    hint,
    always,
    label: label2,
    style,
    optional,
    readOnly,
    disabled
  } = _a, rest = __objRest(_a, [
    "className",
    "invalid",
    "id",
    "hint",
    "always",
    "label",
    "style",
    "optional",
    "readOnly",
    "disabled"
  ]);
  activateI18n7(messages46, messages45, messages47);
  const helpId = hint ? `${id}__hint` : void 0;
  return {
    attrs: {
      div: {
        style
      },
      label: {
        htmlFor: id,
        children: label2
      },
      select: __spreadProps(__spreadValues({}, rest), {
        "aria-describedby": helpId,
        "aria-errormessage": invalid && helpId ? helpId : void 0,
        "aria-invalid": invalid,
        disabled,
        id
      }),
      optional,
      help: always || invalid ? {
        children: hint,
        id: helpId
      } : null
    },
    wrapperClasses: r(select.wrapper, className),
    selectClasses: r({
      [select.default]: true,
      [select.invalid]: invalid,
      [select.disabled]: disabled,
      [select.readOnly]: readOnly
    }),
    selectWrapperClasses: r({
      [select.selectWrapper]: true
    }),
    helpTextClasses: r({
      [helpText.helpText]: true,
      [helpText.helpTextInvalid]: invalid
    }),
    labelClasses: r({
      [label.label]: true,
      [label.labelInvalid]: invalid
    }),
    chevronClasses: r({
      [select.chevron]: true,
      [select.chevronDisabled]: disabled
    })
  };
};
function Select(props, ref) {
  const id = useId(props.id);
  const { attrs, wrapperClasses, selectClasses, selectWrapperClasses, helpTextClasses, labelClasses, chevronClasses } = setup(__spreadProps(__spreadValues({}, props), { id }));
  const { div, label: label2, select: select2, help, optional } = attrs;
  return /* @__PURE__ */ React36.createElement("div", __spreadValues({ className: wrapperClasses }, div), label2.children && /* @__PURE__ */ React36.createElement("label", { htmlFor: label2.htmlFor, className: labelClasses }, label2.children, optional && /* @__PURE__ */ React36.createElement("span", { className: label.optional }, i18n._(
    /*i18n*/
    {
      id: "select.label.optional",
      message: "(optional)",
      comment: "Shown behind label when marked as optional"
    }
  ))), /* @__PURE__ */ React36.createElement("div", { className: selectWrapperClasses }, /* @__PURE__ */ React36.createElement("select", __spreadProps(__spreadValues({ ref }, select2), { className: selectClasses })), /* @__PURE__ */ React36.createElement(
    "div",
    {
      className: r(chevronClasses)
    },
    /* @__PURE__ */ React36.createElement(chevron_down_16_default, null)
  )), help && /* @__PURE__ */ React36.createElement("div", __spreadValues({ className: helpTextClasses }, help)));
}
var _Select = React36.forwardRef(Select);

// node_modules/.pnpm/@warp-ds+core@1.0.2/node_modules/@warp-ds/core/dist/slider/utils/helpers.js
var useDimensions = () => {
  let observer;
  const useOnResize = (updateDimensions) => (entries) => {
    const { left, width: w3 } = entries[0].target.getBoundingClientRect();
    updateDimensions({ left, width: w3 - 24 });
  };
  const mountedHook = (sliderLineEl, updateDimensions) => {
    updateDimensions(sliderLineEl.getBoundingClientRect());
    observer = new ResizeObserver(useOnResize(updateDimensions));
    observer.observe(sliderLineEl);
  };
  const unmountedHook = () => {
    observer.disconnect();
  };
  return { mountedHook, unmountedHook };
};
var validKeys = Object.freeze({
  up: "ArrowUp",
  down: "ArrowDown",
  left: "ArrowLeft",
  right: "ArrowRight",
  end: "End",
  home: "Home",
  pageup: "PageUp",
  pagedown: "PageDown"
});
var validKeyCodes = Object.values(validKeys);
var eventOptions = { passive: true };
function roundDecimals(n4, decimals = 2) {
  const rounding = decimals ? Math.pow(10, decimals) : 1;
  return Math.round(n4 * rounding) / rounding;
}
var isNumber = (e2) => Number.isFinite(parseFloat(e2));
var clamp = (v3, { min, max }) => isNumber(v3) ? Math.min(Math.max(Number(v3), min), max) : min;

// node_modules/.pnpm/@warp-ds+core@1.0.2/node_modules/@warp-ds/core/dist/slider/utils/handlers.js
function createHandlers({ props, sliderState }) {
  const clampedChange = (n4) => clamp(n4, { max: props.max, min: props.min });
  function getCoordinates(e2) {
    const { left: offsetLeft, width: trackWidth } = sliderState.dimensions;
    const clientX = "touches" in e2 ? e2.touches[0].clientX : e2.clientX;
    let left = Math.min(Math.max((clientX - offsetLeft - 16) / trackWidth, 0), 1) || 0;
    const value = props.min + left * (props.max - props.min);
    return { value };
  }
  const getThumbPosition = () => (sliderState.position - props.min) / (props.max - props.min) * 100;
  const getThumbTransform = () => getThumbPosition() / 100 * sliderState.dimensions.width;
  const getShiftedChange = (n4) => {
    const r5 = 1 / sliderState.step;
    return Math.floor(n4 * r5) / r5;
  };
  const keydownRepeat = {
    counter: 0,
    repeatsBeforeAcceleration: 3
  };
  function handleKeyDown(e2) {
    const key = e2.key;
    if (props.disabled || !validKeyCodes.includes(key))
      return;
    e2.preventDefault();
    switch (key) {
      case validKeys.left:
      case validKeys.right:
      case validKeys.up:
      case validKeys.down: {
        const direction = key === validKeys.right || key === validKeys.up ? 1 : -1;
        let stepsToMove = sliderState.step;
        if (!props.preventAcceleration) {
          if (e2.repeat) {
            keydownRepeat.counter++;
            const acceleratedStepPercentage = Math.min((keydownRepeat.counter - keydownRepeat.repeatsBeforeAcceleration) / 100, 0.2);
            stepsToMove = Math.max(sliderState.step, Math.ceil((direction > 0 ? props.max - sliderState.val : sliderState.val - props.min) * acceleratedStepPercentage));
          } else {
            keydownRepeat.counter = 0;
          }
        }
        sliderState.position = clampedChange(sliderState.val + direction * stepsToMove);
        break;
      }
      case validKeys.home:
        sliderState.position = props.min;
        break;
      case validKeys.end:
        sliderState.position = props.max;
        break;
      case validKeys.pageup:
      case validKeys.pagedown: {
        const direction = key === validKeys.pageup ? 1 : -1;
        const minStepMultiplier = 2;
        const maxStepMultiplier = 50;
        sliderState.position = clampedChange(sliderState.val + direction * sliderState.step * Math.max(minStepMultiplier, Math.min(maxStepMultiplier, Math.ceil((props.max - props.min) / 10 / sliderState.step))));
        break;
      }
      default:
        break;
    }
  }
  function handleFocus() {
  }
  function handleBlur() {
  }
  function handleMouseDown(e2) {
    sliderState.sliderPressed = true;
    if ("touches" in e2) {
      window.addEventListener("touchmove", handleMouseChange, eventOptions);
      window.addEventListener("touchend", handleMouseUp, { once: true });
    } else {
      window.addEventListener("mousemove", handleMouseChange, eventOptions);
      window.addEventListener("mouseup", handleMouseUp, { once: true });
    }
    e2.stopPropagation();
    e2.preventDefault();
  }
  function handleMouseUp() {
    sliderState.sliderPressed = false;
    window.removeEventListener("touchmove", handleMouseChange);
    window.removeEventListener("mousemove", handleMouseChange);
  }
  function handleClick(e2) {
    handleMouseChange(e2);
  }
  function handleMouseChange(e2) {
    var _a;
    const { value } = getCoordinates(e2);
    const n4 = roundDecimals(value);
    (_a = sliderState.thumbEl) == null ? void 0 : _a.focus();
    if (sliderState.position !== n4)
      sliderState.position = n4;
  }
  return {
    handleKeyDown,
    handleFocus,
    handleBlur,
    handleMouseDown,
    handleClick,
    getThumbPosition,
    getThumbTransform,
    getShiftedChange
  };
}

// packages/slider/src/component.tsx
import React37, { useEffect as useEffect9, useMemo, useRef as useRef7, useState as useState7 } from "react";
function Slider(_a) {
  var _b = _a, { min = 0, max = 100 } = _b, rest = __objRest(_b, ["min", "max"]);
  const { disabled, onChange } = rest;
  const sliderLine = useRef7(null);
  const thumbRef = useRef7(null);
  const { mountedHook, unmountedHook } = useDimensions();
  useEffect9(() => {
    if (!sliderLine.current)
      return;
    mountedHook(sliderLine.current, setDimensions);
    return () => unmountedHook();
  }, [sliderLine]);
  const [value, setValue] = useState7(rest.value);
  const [position, setPosition] = useState7(rest.value);
  const [dimensions, setDimensions] = useState7({ left: 0, width: 0 });
  const [sliderPressed, setSliderPressed] = useState7(false);
  useEffect9(() => {
    onChange && onChange(value);
  }, [value, onChange]);
  const step2 = useMemo(() => rest.step || 1, [rest]);
  const sliderState = {
    get position() {
      return position;
    },
    set position(v3) {
      setPosition(v3);
    },
    get sliderPressed() {
      return sliderPressed;
    },
    set sliderPressed(v3) {
      setSliderPressed(v3);
    },
    get val() {
      return value;
    },
    set val(v3) {
      setValue(v3);
    },
    get thumbEl() {
      return thumbRef.current;
    },
    get dimensions() {
      return dimensions;
    },
    get step() {
      return step2;
    }
  };
  const {
    handleKeyDown,
    handleFocus,
    handleBlur,
    handleMouseDown,
    handleClick,
    getThumbPosition,
    getThumbTransform,
    getShiftedChange
  } = createHandlers({ props: __spreadValues({ min, max }, rest), sliderState });
  const thumbPosition = useMemo(getThumbPosition, [getThumbPosition]);
  const sliderActiveStyle = useMemo(
    () => ({
      left: 0,
      right: 100 - thumbPosition + "%"
    }),
    [thumbPosition]
  );
  const transformValue = useMemo(getThumbTransform, [getThumbTransform]);
  const thumbStyles = useMemo(
    () => ({
      transform: "translateX(" + transformValue + "px)"
    }),
    [transformValue]
  );
  useEffect9(() => {
    if (position === rest.value)
      return;
    const n4 = rest.step ? getShiftedChange(position) : position;
    if (value === n4)
      return;
    setValue(n4);
  }, [position, rest.value, rest.step]);
  useEffect9(() => {
    if (sliderPressed || position === rest.value || value === rest.value)
      return;
    setPosition(rest.value);
  }, [sliderPressed, rest.value]);
  return /* @__PURE__ */ React37.createElement("div", { className: slider.wrapper }, /* @__PURE__ */ React37.createElement(
    "div",
    {
      ref: sliderLine,
      className: r({
        [slider.track]: true,
        [slider.trackDisabled]: disabled
      }),
      onClick: handleClick
    }
  ), /* @__PURE__ */ React37.createElement(
    "div",
    {
      className: r({
        [slider.activeTrack]: !disabled,
        [slider.activeTrackDisabled]: disabled
      }),
      style: sliderActiveStyle,
      onClick: handleClick
    }
  ), /* @__PURE__ */ React37.createElement(
    "div",
    {
      role: "slider",
      tabIndex: 0,
      className: r({
        [slider.thumb]: true,
        [slider.thumbDisabled]: disabled,
        [slider.thumbEnabled]: !disabled
      }),
      ref: thumbRef,
      style: thumbStyles,
      "aria-label": rest["aria-label"],
      "aria-labelledby": rest["aria-labelledby"],
      "aria-valuemin": min,
      "aria-valuemax": max,
      "aria-valuenow": value,
      "aria-valuetext": rest["aria-valuetext"],
      onMouseDown: (e2) => {
        handleMouseDown(e2);
      },
      onTouchStart: (e2) => {
        handleMouseDown(e2);
      },
      onBlur: handleBlur,
      onFocus: handleFocus,
      onKeyDown: (e2) => {
        handleKeyDown(e2);
      }
    }
  ));
}

// packages/steps/src/component.tsx
import React38, { createContext } from "react";
var StepsContext = createContext({
  horizontal: void 0,
  right: void 0
});
function Steps({ horizontal, right, className, children }) {
  return /* @__PURE__ */ React38.createElement(
    StepsContext.Provider,
    {
      value: {
        horizontal,
        right
      }
    },
    /* @__PURE__ */ React38.createElement(
      "ul",
      {
        className: r(className, {
          [steps.steps]: true,
          [steps.stepsHorizontal]: horizontal
        })
      },
      children
    )
  );
}

// packages/steps/src/step.tsx
import React40 from "react";
import { useContext } from "react";

// node_modules/.pnpm/@warp-ds+icons@2.0.0/node_modules/@warp-ds/icons/dist/react/check-16.js
import React39 from "react";
var __defProp12 = Object.defineProperty;
var __getOwnPropSymbols11 = Object.getOwnPropertySymbols;
var __hasOwnProp11 = Object.prototype.hasOwnProperty;
var __propIsEnum11 = Object.prototype.propertyIsEnumerable;
var __defNormalProp12 = (obj, key, value) => key in obj ? __defProp12(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues11 = (a4, b4) => {
  for (var prop in b4 || (b4 = {}))
    if (__hasOwnProp11.call(b4, prop))
      __defNormalProp12(a4, prop, b4[prop]);
  if (__getOwnPropSymbols11)
    for (var prop of __getOwnPropSymbols11(b4)) {
      if (__propIsEnum11.call(b4, prop))
        __defNormalProp12(a4, prop, b4[prop]);
    }
  return a4;
};
var messages48 = JSON.parse('{"icon.title.check":"Sjekkmerke"}');
var messages213 = JSON.parse('{"icon.title.check":"Checkmark"}');
var messages311 = JSON.parse('{"icon.title.check":"Valintamerkki"}');
var supportedLocales11 = ["en", "nb", "fi", "da", "sv"];
var defaultLocale12 = "en";
var detectByBrand10 = () => {
  let value;
  switch (process.env.NMP_BRAND) {
    case "FINN":
      value = "nb";
      break;
    case "TORI":
      value = "fi";
      break;
    case "BLOCKET":
      value = "sv";
      break;
    case "DBA":
      value = "da";
      break;
    default:
      value = "en";
  }
  return value;
};
var detectByHost10 = () => {
  var _a;
  const hostname = (_a = document == null ? void 0 : document.location) == null ? void 0 : _a.hostname;
  if (hostname.includes("finn")) {
    return "nb";
  } else if (hostname.includes("tori")) {
    return "fi";
  } else if (hostname.includes("blocket")) {
    return "sv";
  } else if (hostname.includes("dba")) {
    return "da";
  } else {
    return defaultLocale12;
  }
};
var getSupportedLocale11 = (usedLocale) => {
  return supportedLocales11.find(
    (locale) => usedLocale === locale || usedLocale.toLowerCase().includes(locale)
  ) || detectByHost10();
};
function detectLocale11() {
  var _a;
  if (typeof window === "undefined") {
    const serverLocale = detectByBrand10();
    return getSupportedLocale11(serverLocale);
  }
  try {
    const htmlLocale = (_a = document == null ? void 0 : document.documentElement) == null ? void 0 : _a.lang;
    const hostLocale = detectByHost10();
    if (!supportedLocales11.includes(htmlLocale)) {
      console.warn("Unsupported locale set in html lang tag, falling back to detection by hostname");
      return getSupportedLocale11(hostLocale);
    }
    return getSupportedLocale11(htmlLocale != null ? htmlLocale : hostLocale);
  } catch (e2) {
    console.warn("could not detect locale, falling back to source locale", e2);
    return defaultLocale12;
  }
}
var getMessages11 = (locale, enMsg, nbMsg, fiMsg) => {
  if (locale === "nb")
    return nbMsg;
  if (locale === "fi")
    return fiMsg;
  return enMsg;
};
var activateI18n11 = (enMessages, nbMessages, fiMessages) => {
  const locale = detectLocale11();
  const messages410 = getMessages11(locale, enMessages, nbMessages, fiMessages);
  i18n.load(locale, messages410);
  i18n.activate(locale);
};
activateI18n11(messages213, messages48, messages311);
var title10 = i18n.t({ message: `Checkmark`, id: "icon.title.check", comment: "Title for check icon" });
var IconCheck16 = (attrs) => React39.createElement("svg", __spreadValues11({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", fill: "none", viewBox: "0 0 16 16", dangerouslySetInnerHTML: { __html: `<title>${title10}</title><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M3.83 7.667 7.163 11l5.334-6"></path>` } }, attrs));
var check_16_default = IconCheck16;

// packages/steps/src/locales/nb/messages.mjs
var messages49 = JSON.parse('{"steps.aria.emptyCircle":"Tom sirkel","steps.aria.active":"Stegindikator aktiv sirkel","steps.aria.completed":"Stegindikator hel sirkel"}');

// packages/steps/src/locales/en/messages.mjs
var messages50 = JSON.parse('{"steps.aria.emptyCircle":"Empty circle","steps.aria.active":"Step indicator active circle","steps.aria.completed":"Step indicator completed circle"}');

// packages/steps/src/locales/fi/messages.mjs
var messages51 = JSON.parse('{"steps.aria.emptyCircle":"Tyhj\xE4 ympyr\xE4","steps.aria.active":"Vaiheilmaisin aktiivinen ympyr\xE4","steps.aria.completed":"Vaiheilmaisin valmis ympyr\xE4"}');

// packages/steps/src/step.tsx
var availableAriaLabels = {
  completed: i18n._(
    /*i18n*/
    {
      id: "steps.aria.completed",
      message: "Step indicator completed circle",
      comment: "Completed circle"
    }
  ),
  active: i18n._(
    /*i18n*/
    {
      id: "steps.aria.active",
      message: "Step indicator active circle",
      comment: "Active circle"
    }
  ),
  default: i18n._(
    /*i18n*/
    {
      id: "steps.aria.emptyCircle",
      message: "Empty circle",
      comment: "Empty circle"
    }
  )
};
var getAriaLabel = (props) => {
  const ariaLabel = Object.keys(availableAriaLabels).find((a4) => props[a4]);
  return ariaLabel ? availableAriaLabels[ariaLabel] : availableAriaLabels.default;
};
function Step(props) {
  activateI18n7(messages50, messages49, messages51);
  const { active, completed, children } = props;
  const StepsProps = useContext(StepsContext);
  const vertical = !StepsProps.horizontal;
  const left = !StepsProps.right;
  const stepClasses = r({
    [step.stepVertical]: vertical,
    [step.stepVerticalLeft]: vertical && left,
    [step.stepVerticalRight]: vertical && !left,
    [step.stepHorizontal]: !vertical
  });
  const stepLineHorizontalClasses = r({
    [step.stepLine]: true,
    [step.stepLineHorizontalLeft]: true,
    [step.stepLineHorizontal]: !vertical,
    [step.stepLineIncomplete]: !active && !completed,
    [step.stepLineComplete]: active || completed
  });
  const stepDotClasses = r({
    [step.stepDot]: true,
    [step.stepDotVerticalRight]: vertical && !left,
    [step.stepDotHorizontal]: !vertical,
    [step.stepDotIncomplete]: !(active || completed),
    [step.stepDotActive]: active || completed
  });
  const stepLineClasses = r({
    [step.stepLine]: true,
    [step.stepLineHorizontalRight]: true,
    [step.stepLineVertical]: vertical,
    [step.stepLineVerticalRight]: vertical && !left,
    [step.stepLineHorizontal]: !vertical,
    [step.stepLineIncomplete]: !completed,
    [step.stepLineComplete]: completed
  });
  const stepContentClasses = r({
    [step.content]: true,
    [step.contentVertical]: vertical,
    [step.contentHorizontal]: !vertical
  });
  return /* @__PURE__ */ React40.createElement("li", { className: stepClasses }, !vertical && /* @__PURE__ */ React40.createElement("div", { className: stepLineHorizontalClasses }), /* @__PURE__ */ React40.createElement(
    "div",
    __spreadValues({
      className: stepDotClasses,
      role: "img",
      "aria-label": getAriaLabel(props)
    }, active && { "aria-current": "step" }),
    completed && /* @__PURE__ */ React40.createElement(check_16_default, null)
  ), /* @__PURE__ */ React40.createElement("div", { className: stepLineClasses }), /* @__PURE__ */ React40.createElement("div", { className: stepContentClasses }, children));
}

// packages/switch/src/component.tsx
import React41 from "react";
function Switch(_a) {
  var _b = _a, {
    id,
    value,
    onClick,
    "aria-label": ariaLabel,
    "aria-labelledby": ariaLabelledBy
  } = _b, attrs = __objRest(_b, [
    "id",
    "value",
    "onClick",
    "aria-label",
    "aria-labelledby"
  ]);
  const switchFocus = "focusable rounded-full";
  return /* @__PURE__ */ React41.createElement("div", { className: switchToggle.switch }, /* @__PURE__ */ React41.createElement(
    "button",
    __spreadValues({
      id,
      type: "button",
      role: "switch",
      "aria-label": ariaLabel,
      "aria-labelledby": ariaLabelledBy,
      "aria-checked": value,
      onClick,
      className: r([switchToggle.label, switchFocus])
    }, attrs),
    /* @__PURE__ */ React41.createElement(
      "span",
      {
        className: r([switchToggle.track, value ? switchToggle.trackActive : switchToggle.trackInactive])
      }
    ),
    /* @__PURE__ */ React41.createElement(
      "span",
      {
        className: r([switchToggle.handle, switchToggle.handleNotDisabled], {
          [switchToggle.handleSelected]: value
        })
      }
    )
  ));
}

// packages/tabs/src/component-tab.tsx
import React42 from "react";
var setup2 = (_a) => {
  var _b = _a, { className, isActive, setActive } = _b, rest = __objRest(_b, ["className", "isActive", "setActive"]);
  return {
    tab: r(tab.tab, {
      [className]: !!className,
      [tab.tabActive]: isActive
    }),
    icon: r(tab.icon, {
      [tab.iconUnderlinedActive]: isActive
    }),
    content: r(tab.contentUnderlined, {
      [tab.contentUnderlinedActive]: isActive
    }),
    attrs: __spreadValues({}, rest)
  };
};
function Tab(props) {
  const {
    children,
    label: label2,
    setActive = () => {
    },
    name,
    onClick,
    isActive
  } = props;
  const { tab: tab2, icon, content, attrs } = setup2(props);
  const _a = attrs, { over } = _a, rest = __objRest(_a, ["over"]);
  const handleClick = (e2) => {
    setActive(name);
    onClick && onClick(e2);
  };
  return /* @__PURE__ */ React42.createElement(
    "button",
    __spreadProps(__spreadValues({
      type: "button"
    }, rest), {
      role: "tab",
      "aria-selected": isActive ? "true" : "false",
      "aria-controls": isActive ? `warp-tabpanel-${name}` : void 0,
      id: `warp-tab-${name}`,
      tabIndex: isActive ? 0 : -1,
      className: tab2,
      onClick: handleClick
    }),
    !children && /* @__PURE__ */ React42.createElement("span", { className: content }, label2),
    children && over && /* @__PURE__ */ React42.createElement(React42.Fragment, null, /* @__PURE__ */ React42.createElement("span", { className: icon }, children), /* @__PURE__ */ React42.createElement("span", { className: content }, label2)),
    children && !over && /* @__PURE__ */ React42.createElement("div", { className: tab.content }, children, label2)
  );
}

// packages/tabs/src/component-tab-panel.tsx
import React43 from "react";
function TabPanel(props) {
  var _b, _c;
  const _a = props, { children, name, hidden } = _a, rest = __objRest(_a, ["children", "name", "hidden"]);
  return /* @__PURE__ */ React43.createElement(
    "div",
    __spreadProps(__spreadValues({
      tabIndex: -1
    }, rest), {
      role: "tabpanel",
      "aria-labelledby": `warp-tab-${name}`,
      id: `warp-tabpanel-${name}`,
      hidden: hidden === void 0 && typeof document === "object" ? !((_c = (_b = document == null ? void 0 : document.getElementById(`warp-tab-${name}`)) == null ? void 0 : _b.classList) == null ? void 0 : _c.contains(tab.tabActive)) : hidden
    }),
    children
  );
}

// packages/tabs/src/component-tabs.tsx
import React44, {
  useState as useState8,
  useRef as useRef8,
  useEffect as useEffect10,
  cloneElement as cloneElement2,
  Children
} from "react";

// packages/tabs/src/utils.ts
function debounce(func2, wait = 200, immediate = false) {
  let timeout;
  return function() {
    var later = () => {
      timeout = null;
      if (!immediate)
        func2.apply(this, arguments);
    };
    let callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow)
      func2.apply(this, arguments);
  };
}

// packages/tabs/src/component-tabs.tsx
var setup3 = (_a, tabsRef, wunderbarRef) => {
  var _b = _a, { className, children, onClick, active } = _b, rest = __objRest(_b, ["className", "children", "onClick", "active"]);
  return {
    nav: r(tabs.wrapperUnderlined, {
      [className]: !!className
    }),
    div: r(tabs.tabContainer, {
      [gridLayout[`cols${children.length}`]]: true
    }),
    wunderbar: r(tabs.wunderbar),
    attrs: rest,
    updateWunderbar: () => {
      window.requestAnimationFrame(() => {
        if (tabsRef.current && wunderbarRef.current) {
          const activeEl = tabsRef.current.querySelector(
            'button[role="tab"][aria-selected="true"]'
          );
          if (activeEl) {
            const parentLeft = tabsRef.current.getBoundingClientRect().left;
            const { left, width } = activeEl.getBoundingClientRect();
            wunderbarRef.current.style.left = `${left - parentLeft}px`;
            wunderbarRef.current.style.width = `${width}px`;
          }
        }
      });
    }
  };
};
var Tabs = (props) => {
  const isBrowser2 = Boolean(
    typeof document === "object" && (document == null ? void 0 : document.createElement)
  );
  const tabsRef = useRef8(null);
  const wunderbarRef = useRef8(null);
  const { children, onChange } = props;
  const { nav, div, wunderbar, attrs, updateWunderbar } = setup3(
    props,
    tabsRef,
    wunderbarRef
  );
  useEffect10(() => {
    isBrowser2 && updatePanels();
    updateWunderbar();
    const updateDebounced = debounce(updateWunderbar, 100);
    window.addEventListener("resize", updateDebounced);
    return () => window.removeEventListener("resize", updateDebounced);
  });
  const findActive = () => {
    var _a;
    if (props.active) {
      return String(props.active);
    } else if (Children.count(children) > 0) {
      const childrenArray = Children.toArray(children);
      const activeChild = (childrenArray == null ? void 0 : childrenArray.find(
        // @ts-ignore: semantic error
        (child) => {
          var _a2;
          return (_a2 = child == null ? void 0 : child.props) == null ? void 0 : _a2.isActive;
        }
      )) || childrenArray[0];
      return String(((_a = activeChild == null ? void 0 : activeChild.props) == null ? void 0 : _a.name) || "");
    }
    return "";
  };
  const [active, setActive] = useState8(findActive());
  const updatePanels = () => {
    Children.forEach(children, (child) => {
      var _a, _b;
      if (typeof child === "object") {
        const panel = document.getElementById(
          // @ts-ignore: semantic error
          `warp-tabpanel-${(_a = child == null ? void 0 : child.props) == null ? void 0 : _a.name}`
        );
        if (panel) {
          panel.hidden = ((_b = child == null ? void 0 : child.props) == null ? void 0 : _b.name) !== active;
        }
      }
    });
  };
  const change = (name) => {
    setActive(name);
    updateWunderbar();
    onChange && onChange(name);
  };
  const handleKeyDown = (event) => {
    var _a, _b, _c;
    if (!event.altKey && !event.ctrlKey && !event.shiftKey && ["ArrowLeft", "ArrowRight", "Home", "End"].includes(event.key)) {
      const tabs2 = Array.from((_b = (_a = tabsRef == null ? void 0 : tabsRef.current) == null ? void 0 : _a.querySelectorAll('button[role="tab"]')) != null ? _b : []);
      const activeTabIndex = tabs2.findIndex((tab2) => tab2.name === active);
      if (activeTabIndex >= 0) {
        const nextIndex = (() => {
          switch (event.key) {
            case "Home":
              return 0;
            case "End":
              return tabs2.length - 1;
            case "ArrowLeft":
              return Math.max(0, activeTabIndex - 1);
            case "ArrowRight":
              return Math.min(tabs2.length - 1, activeTabIndex + 1);
            default:
              return activeTabIndex;
          }
        })();
        if (activeTabIndex !== nextIndex && ((_c = tabs2[nextIndex]) == null ? void 0 : _c.name)) {
          event.preventDefault();
          change(tabs2[nextIndex].name);
          tabs2[nextIndex].focus();
        }
      }
    }
  };
  return /* @__PURE__ */ React44.createElement("div", __spreadProps(__spreadValues({}, attrs), { className: nav }), /* @__PURE__ */ React44.createElement(
    "div",
    {
      role: "tablist",
      className: div,
      ref: tabsRef,
      onKeyDown: handleKeyDown
    },
    Children.map(children, (child) => {
      var _a;
      return child && cloneElement2(child, {
        setActive: change,
        isActive: ((_a = child == null ? void 0 : child.props) == null ? void 0 : _a.name) === active
      });
    }),
    /* @__PURE__ */ React44.createElement("span", { className: wunderbar, ref: wunderbarRef })
  ));
};

// packages/textarea/src/component.tsx
import React46, { forwardRef as forwardRef8, useRef as useRef10 } from "react";

// packages/textarea/src/useTextAreaHeight.ts
import { useEffect as useEffect11, useRef as useRef9 } from "react";
function useTextAreaHeight({
  ref,
  value,
  minimumRows,
  maximumRows
}) {
  const minHeight = useRef9(-Infinity);
  const maxHeight = useRef9(Infinity);
  const isControlled = value !== void 0;
  function resize(textarea) {
    textarea.style.setProperty("height", "auto");
    let height = Math.max(minHeight.current, textarea.scrollHeight);
    height = Math.min(maxHeight.current, height);
    textarea.style.setProperty("height", height + "px");
  }
  useLayoutEffect(() => {
    if (ref.current && (minimumRows || maximumRows)) {
      const style = getComputedStyle(ref.current);
      const lineHeight = parseFloat(style.getPropertyValue("line-height"));
      const topPadding = parseFloat(style.getPropertyValue("padding-top"));
      const bottomPadding = parseFloat(
        style.getPropertyValue("padding-bottom")
      );
      const bottomBorder = parseFloat(
        style.getPropertyValue("border-bottom-width")
      );
      const offset = topPadding + bottomPadding + bottomBorder;
      if (minimumRows) {
        minHeight.current = lineHeight * minimumRows + offset;
      }
      if (maximumRows) {
        maxHeight.current = lineHeight * maximumRows + offset;
      }
    }
  }, [ref, maximumRows, minimumRows]);
  useLayoutEffect(() => {
    if (ref.current) {
      resize(ref.current);
    }
  }, [ref, value]);
  useEffect11(() => {
    if (!ref.current && isControlled)
      return;
    const textarea = ref.current;
    const handleInput = () => {
      resize(textarea);
    };
    textarea.addEventListener("input", handleInput);
    return () => textarea.removeEventListener("input", handleInput);
  }, [ref, isControlled]);
}

// packages/textarea/src/locales/nb/messages.mjs
var messages52 = JSON.parse('{"textarea.label.optional":"(valgfritt)"}');

// packages/textarea/src/locales/en/messages.mjs
var messages53 = JSON.parse('{"textarea.label.optional":"(optional)"}');

// packages/textarea/src/locales/fi/messages.mjs
var messages54 = JSON.parse('{"textarea.label.optional":"(valinnainen)"}');

// packages/textarea/src/component.tsx
var TextArea = forwardRef8(
  (props, forwardRef9) => {
    const _a = props, {
      className,
      disabled,
      error,
      helpText: helpText2,
      id: providedId,
      invalid,
      label: label2,
      maximumRows,
      minimumRows,
      readOnly,
      style,
      value,
      optional,
      placeholder
    } = _a, rest = __objRest(_a, [
      "className",
      "disabled",
      "error",
      "helpText",
      "id",
      "invalid",
      "label",
      "maximumRows",
      "minimumRows",
      "readOnly",
      "style",
      "value",
      "optional",
      "placeholder"
    ]);
    activateI18n7(messages53, messages52, messages54);
    const id = useId(providedId);
    const ref = useRef10(null);
    const helpId = helpText2 ? `${id}__hint` : void 0;
    const isInvalid = invalid != null ? invalid : error;
    useTextAreaHeight({
      ref,
      value,
      maximumRows,
      minimumRows
    });
    return /* @__PURE__ */ React46.createElement(
      "div",
      {
        className,
        style
      },
      label2 && /* @__PURE__ */ React46.createElement("label", { htmlFor: id, className: r({
        [label.label]: true,
        [label.labelInvalid]: isInvalid
      }) }, label2, optional && /* @__PURE__ */ React46.createElement("span", { className: label.optional }, i18n._(
        /*i18n*/
        {
          id: "textarea.label.optional",
          message: "(optional)",
          comment: "Shown behind label when marked as optional"
        }
      ))),
      /* @__PURE__ */ React46.createElement(
        "textarea",
        __spreadProps(__spreadValues({
          className: r({
            [`${input.default} ${input.textArea}`]: true,
            [input.placeholder]: !!placeholder,
            [input.invalid]: isInvalid,
            [input.disabled]: disabled,
            [input.readOnly]: readOnly
          })
        }, rest), {
          placeholder,
          "aria-describedby": helpId,
          "aria-errormessage": isInvalid && helpId ? helpId : void 0,
          "aria-invalid": isInvalid,
          disabled,
          id,
          ref: (node2) => {
            ref.current = node2;
            if (forwardRef9) {
              if (typeof forwardRef9 === "function") {
                forwardRef9(node2);
              } else {
                forwardRef9.current = node2;
              }
            }
          },
          readOnly,
          value
        })
      ),
      helpText2 && /* @__PURE__ */ React46.createElement(
        "div",
        {
          className: r({
            [helpText.helpText]: true,
            [helpText.helpTextInvalid]: isInvalid
          }),
          id: helpId
        },
        helpText2
      )
    );
  }
);

// packages/toggle/src/component.tsx
import React47 from "react";

// packages/toggle/src/locales/nb/messages.mjs
var messages55 = JSON.parse('{"toggle.label.optional":"(valgfritt)"}');

// packages/toggle/src/locales/en/messages.mjs
var messages56 = JSON.parse('{"toggle.label.optional":"(optional)"}');

// packages/toggle/src/locales/fi/messages.mjs
var messages57 = JSON.parse('{"toggle.label.optional":"(vapaaehtoinen)"}');

// packages/toggle/src/component.tsx
function Title({ id, isInvalid, title: title14, optional }) {
  activateI18n7(messages56, messages55, messages57);
  return /* @__PURE__ */ React47.createElement(
    "legend",
    {
      id: `${id}__title`,
      className: r({
        [label.label]: true,
        [label.labelInvalid]: isInvalid
      })
    },
    title14,
    optional && /* @__PURE__ */ React47.createElement("span", { className: label.optional }, i18n._(
      /*i18n*/
      {
        id: "toggle.label.optional",
        message: "(optional)",
        comment: "Shown behind label when marked as optional"
      }
    ))
  );
}
function HelpText({ isInvalid, helpId, helpText: helpText2 }) {
  return /* @__PURE__ */ React47.createElement(
    "div",
    {
      id: helpId,
      className: r({
        [helpText.helpText]: true,
        [helpText.helpTextInvalid]: isInvalid
      })
    },
    helpText2
  );
}
function Toggle(props) {
  const id = useId();
  const helpId = props.helpText ? `${id}__hint` : void 0;
  const isRadio = props.type === "radio";
  const isCheckbox = props.type === "checkbox";
  const isRadioButton = props.type === "radio-button";
  const isRadioGroup = isRadio || isRadioButton;
  const isIndeterminate = isCheckbox && props.indeterminate;
  const isInvalid = props.invalid;
  const isDisabled = !isRadioButton && props.disabled;
  const isControlled = props.selected !== void 0 || props.checked !== void 0;
  const labelClasses = r({
    [toggle.label]: !isRadioButton,
    [toggle.labelBefore]: !isRadioButton && !isIndeterminate,
    [toggle.checkbox]: isCheckbox && !isIndeterminate && !isInvalid && !isDisabled,
    [toggle.checkboxInvalid]: isCheckbox && !isIndeterminate && isInvalid && !isDisabled,
    [toggle.checkboxDisabled]: isCheckbox && !isIndeterminate && !isInvalid && isDisabled,
    [toggle.indeterminate]: isCheckbox && isIndeterminate && !isInvalid && !isDisabled,
    [toggle.indeterminateInvalid]: isCheckbox && isIndeterminate && isInvalid && !isDisabled,
    [toggle.indeterminateDisabled]: isCheckbox && isIndeterminate && !isInvalid && isDisabled,
    [toggle.radio]: isRadio && !isInvalid && !isDisabled,
    [toggle.radioInvalid]: isRadio && isInvalid && !isDisabled,
    [toggle.radioDisabled]: isRadio && !isInvalid && isDisabled,
    [toggle.radioButtonsLabel]: isRadioButton,
    [toggle.radioButtonsRegular]: isRadioButton && !props.small,
    [toggle.radioButtonsSmall]: isRadioButton && props.small
  });
  const inputClasses = r({
    [toggle.input]: true,
    [toggle.a11y]: true
  });
  const wrapperClasses = r(props.className, {
    [toggle.wrapper]: true,
    [toggle.wrapperRadioButtons]: isRadioButton && !props.equalWidth,
    [toggle.wrapperRadioButtonsJustified]: isRadioButton && props.equalWidth
  });
  const groupClasses = r({
    [toggle.radioButtonsGroup]: true,
    [toggle.radioButtonsGroupJustified]: props.equalWidth
  });
  return /* @__PURE__ */ React47.createElement(
    "fieldset",
    {
      role: isRadioGroup ? "radiogroup" : void 0,
      "aria-invalid": isRadioGroup ? isInvalid : void 0,
      "aria-errormessage": isRadioGroup && isInvalid ? helpId : void 0,
      "aria-describedby": helpId,
      className: toggle.field
    },
    props.title && /* @__PURE__ */ React47.createElement(
      Title,
      {
        id,
        title: props.title,
        isInvalid,
        optional: props.optional
      }
    ),
    /* @__PURE__ */ React47.createElement(
      "div",
      {
        className: wrapperClasses
      },
      !props.options && props.label ? /* @__PURE__ */ React47.createElement(
        Item,
        {
          controlled: isControlled,
          label: props.label,
          inputClassName: inputClasses,
          labelClassName: labelClasses,
          checked: props.checked,
          defaultChecked: props.defaultChecked,
          indeterminate: props.indeterminate,
          onChange: (e2) => props.onChange(e2),
          name: `${id}:toggle`,
          key: `${id + props.type}`,
          invalid: isInvalid,
          disabled: isDisabled,
          helpId,
          type: isRadioGroup ? "radio" : "checkbox",
          noVisibleLabel: props.noVisibleLabel
        }
      ) : props.options && props.options.map((option, i4) => {
        var _a, _b;
        return /* @__PURE__ */ React47.createElement(
          Item,
          {
            controlled: isControlled,
            checked: (_a = props.selected) == null ? void 0 : _a.some((s3) => s3.value === option.value),
            defaultChecked: (_b = props.defaultSelected) == null ? void 0 : _b.some(
              (s3) => s3.value === option.value
            ),
            inputClassName: inputClasses,
            labelClassName: labelClasses,
            groupClassName: groupClasses,
            option,
            onChange: (e2) => props.onChange(e2),
            name: `${id}:toggle`,
            key: `${id + i4 + props.type}`,
            invalid: isInvalid,
            disabled: isDisabled,
            helpId,
            type: isRadioGroup ? "radio" : "checkbox",
            noVisibleLabel: props.noVisibleLabel,
            multiple: true
          }
        );
      })
    ),
    props.helpText && /* @__PURE__ */ React47.createElement(
      HelpText,
      {
        helpId,
        helpText: props.helpText,
        isInvalid
      }
    )
  );
}

// packages/pagination/src/locales/en/messages.mjs
var messages58 = JSON.parse('{"pagination.aria.first-page":"First page","pagination.aria.icon-suffix":"icon","pagination.aria.next-page":"Next page","pagination.label.current-page":["Page ",["currentPage"]],"pagination.aria.page":["Page ",["currentPage"]],"pagination.aria.pagination":"Pages","pagination.aria.prev-page":"Previous page"}');

// packages/pagination/src/locales/fi/messages.mjs
var messages59 = JSON.parse('{"pagination.aria.first-page":"Ensimm\xE4inen sivu","pagination.aria.icon-suffix":"kuvake","pagination.aria.next-page":"Seuraava sivu","pagination.label.current-page":["Sivu ",["currentPage"]],"pagination.aria.page":["Sivu ",["currentPage"]],"pagination.aria.pagination":"Sivut","pagination.aria.prev-page":"Edellinen sivu"}');

// packages/pagination/src/locales/nb/messages.mjs
var messages60 = JSON.parse('{"pagination.aria.first-page":"F\xF8rste side","pagination.aria.icon-suffix":"ikon","pagination.aria.next-page":"Neste side","pagination.label.current-page":["Side ",["currentPage"]],"pagination.aria.page":["Side ",["currentPage"]],"pagination.aria.pagination":"Sider","pagination.aria.prev-page":"Forrige side"}');

// packages/pagination/src/PaginationContainer.tsx
import React48 from "react";
var PaginationContext = React48.createContext({
  currentPage: 0,
  lastPage: 0
});
var usePagination = () => React48.useContext(PaginationContext);
var PaginationContainer = React48.forwardRef(
  (_a, ref) => {
    var _b = _a, {
      children,
      className,
      currentPage,
      lastPage,
      "aria-labelledby": ariaLabelledBy = "pagination-heading"
    } = _b, props = __objRest(_b, [
      "children",
      "className",
      "currentPage",
      "lastPage",
      "aria-labelledby"
    ]);
    var _a2;
    if (!Number.isInteger(currentPage)) {
      throw new TypeError(
        `Invalid currentPage: ${JSON.stringify(currentPage)}`
      );
    }
    if (!Number.isInteger(lastPage)) {
      throw new TypeError(`Invalid lastPage: ${JSON.stringify(lastPage)}`);
    }
    const context = React48.useMemo(
      () => ({
        currentPage: Math.max(1, Math.min(currentPage, lastPage)),
        lastPage: Math.max(1, lastPage)
      }),
      [currentPage, lastPage]
    );
    const ariaLabel = (_a2 = props["aria-label"]) != null ? _a2 : i18n._({
      id: "pagination.aria.pagination",
      message: "Pages",
      comment: "Default screenreader message for pagination container in the pagination component"
    });
    return /* @__PURE__ */ React48.createElement(
      "nav",
      __spreadProps(__spreadValues({}, props), {
        className: r(
          pagination.containerNav,
          className
        ),
        "aria-labelledby": ariaLabelledBy,
        ref
      }),
      /* @__PURE__ */ React48.createElement("h1", { className: pagination.a11y, id: ariaLabelledBy }, ariaLabel),
      /* @__PURE__ */ React48.createElement(PaginationContext.Provider, { value: context }, children)
    );
  }
);
var PaginationContainer_default = PaginationContainer;

// packages/pagination/src/CurrentPage.tsx
import React49 from "react";
var CurrentPage = React49.forwardRef(
  (_a, ref) => {
    var _b = _a, { children, className } = _b, props = __objRest(_b, ["children", "className"]);
    const { currentPage } = usePagination();
    const label2 = children != null ? children : i18n._({
      id: "pagination.label.current-page",
      message: "Page {currentPage}",
      values: { currentPage },
      comment: "Default message for current page label in the pagination component"
    });
    return /* @__PURE__ */ React49.createElement(
      "span",
      __spreadProps(__spreadValues({}, props), {
        className: r(pagination.currentPage, className),
        ref
      }),
      label2
    );
  }
);
var CurrentPage_default = CurrentPage;

// node_modules/.pnpm/@warp-ds+icons@2.0.0/node_modules/@warp-ds/icons/dist/react/chevron-double-left-16.js
import React50 from "react";
var __defProp13 = Object.defineProperty;
var __getOwnPropSymbols12 = Object.getOwnPropertySymbols;
var __hasOwnProp12 = Object.prototype.hasOwnProperty;
var __propIsEnum12 = Object.prototype.propertyIsEnumerable;
var __defNormalProp13 = (obj, key, value) => key in obj ? __defProp13(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues12 = (a4, b4) => {
  for (var prop in b4 || (b4 = {}))
    if (__hasOwnProp12.call(b4, prop))
      __defNormalProp13(a4, prop, b4[prop]);
  if (__getOwnPropSymbols12)
    for (var prop of __getOwnPropSymbols12(b4)) {
      if (__propIsEnum12.call(b4, prop))
        __defNormalProp13(a4, prop, b4[prop]);
    }
  return a4;
};
var messages61 = JSON.parse('{"icon.title.chevron-double-left":"Dobbel pil til venstre"}');
var messages214 = JSON.parse('{"icon.title.chevron-double-left":"Double leftward arrow"}');
var messages312 = JSON.parse('{"icon.title.chevron-double-left":"Kaksi nuolta vasemmalle"}');
var supportedLocales12 = ["en", "nb", "fi", "da", "sv"];
var defaultLocale13 = "en";
var detectByBrand11 = () => {
  let value;
  switch (process.env.NMP_BRAND) {
    case "FINN":
      value = "nb";
      break;
    case "TORI":
      value = "fi";
      break;
    case "BLOCKET":
      value = "sv";
      break;
    case "DBA":
      value = "da";
      break;
    default:
      value = "en";
  }
  return value;
};
var detectByHost11 = () => {
  var _a;
  const hostname = (_a = document == null ? void 0 : document.location) == null ? void 0 : _a.hostname;
  if (hostname.includes("finn")) {
    return "nb";
  } else if (hostname.includes("tori")) {
    return "fi";
  } else if (hostname.includes("blocket")) {
    return "sv";
  } else if (hostname.includes("dba")) {
    return "da";
  } else {
    return defaultLocale13;
  }
};
var getSupportedLocale12 = (usedLocale) => {
  return supportedLocales12.find(
    (locale) => usedLocale === locale || usedLocale.toLowerCase().includes(locale)
  ) || detectByHost11();
};
function detectLocale12() {
  var _a;
  if (typeof window === "undefined") {
    const serverLocale = detectByBrand11();
    return getSupportedLocale12(serverLocale);
  }
  try {
    const htmlLocale = (_a = document == null ? void 0 : document.documentElement) == null ? void 0 : _a.lang;
    const hostLocale = detectByHost11();
    if (!supportedLocales12.includes(htmlLocale)) {
      console.warn("Unsupported locale set in html lang tag, falling back to detection by hostname");
      return getSupportedLocale12(hostLocale);
    }
    return getSupportedLocale12(htmlLocale != null ? htmlLocale : hostLocale);
  } catch (e2) {
    console.warn("could not detect locale, falling back to source locale", e2);
    return defaultLocale13;
  }
}
var getMessages12 = (locale, enMsg, nbMsg, fiMsg) => {
  if (locale === "nb")
    return nbMsg;
  if (locale === "fi")
    return fiMsg;
  return enMsg;
};
var activateI18n12 = (enMessages, nbMessages, fiMessages) => {
  const locale = detectLocale12();
  const messages410 = getMessages12(locale, enMessages, nbMessages, fiMessages);
  i18n.load(locale, messages410);
  i18n.activate(locale);
};
activateI18n12(messages214, messages61, messages312);
var title11 = i18n.t({ message: `Double leftward arrow`, id: "icon.title.chevron-double-left", comment: "Title for chevron-double-left icon" });
var IconChevronDoubleLeft16 = (attrs) => React50.createElement("svg", __spreadValues12({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", fill: "none", viewBox: "0 0 16 16", dangerouslySetInnerHTML: { __html: `<title>${title11}</title><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M7 13 2 8l5-5m7 10L9 8l5-5"></path>` } }, attrs));
var chevron_double_left_16_default = IconChevronDoubleLeft16;

// packages/pagination/src/FirstPage.tsx
import React51 from "react";
var FirstPage = React51.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  var _a2;
  const { currentPage } = usePagination();
  if (currentPage <= 2) {
    return null;
  }
  const ariaLabel = (_a2 = props["aria-label"]) != null ? _a2 : i18n._({
    id: "pagination.aria.first-page",
    message: "First page",
    comment: "Default screenreader message for first page link in the pagination component"
  });
  const iconSuffix = i18n._({
    id: "pagination.aria.icon-suffix",
    message: "icon",
    comment: "Suffix added at the end of icon titles when img semantics are lost on an html element"
  });
  return /* @__PURE__ */ React51.createElement(
    "a",
    __spreadProps(__spreadValues({
      ref
    }, props), {
      className: r(className, pagination.link, pagination.icon),
      rel: "start"
    }),
    /* @__PURE__ */ React51.createElement("span", { className: pagination.a11y }, ariaLabel, ","),
    /* @__PURE__ */ React51.createElement(chevron_double_left_16_default, null),
    /* @__PURE__ */ React51.createElement("span", { className: pagination.a11y }, iconSuffix)
  );
});
var FirstPage_default = FirstPage;

// node_modules/.pnpm/@warp-ds+icons@2.0.0/node_modules/@warp-ds/icons/dist/react/chevron-right-16.js
import React52 from "react";
var __defProp14 = Object.defineProperty;
var __getOwnPropSymbols13 = Object.getOwnPropertySymbols;
var __hasOwnProp13 = Object.prototype.hasOwnProperty;
var __propIsEnum13 = Object.prototype.propertyIsEnumerable;
var __defNormalProp14 = (obj, key, value) => key in obj ? __defProp14(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues13 = (a4, b4) => {
  for (var prop in b4 || (b4 = {}))
    if (__hasOwnProp13.call(b4, prop))
      __defNormalProp14(a4, prop, b4[prop]);
  if (__getOwnPropSymbols13)
    for (var prop of __getOwnPropSymbols13(b4)) {
      if (__propIsEnum13.call(b4, prop))
        __defNormalProp14(a4, prop, b4[prop]);
    }
  return a4;
};
var messages62 = JSON.parse('{"icon.title.chevron-right":"Pil til h\xF8yre"}');
var messages215 = JSON.parse('{"icon.title.chevron-right":"Rightward arrow"}');
var messages313 = JSON.parse('{"icon.title.chevron-right":"Nuoli oikealle"}');
var supportedLocales13 = ["en", "nb", "fi", "da", "sv"];
var defaultLocale14 = "en";
var detectByBrand12 = () => {
  let value;
  switch (process.env.NMP_BRAND) {
    case "FINN":
      value = "nb";
      break;
    case "TORI":
      value = "fi";
      break;
    case "BLOCKET":
      value = "sv";
      break;
    case "DBA":
      value = "da";
      break;
    default:
      value = "en";
  }
  return value;
};
var detectByHost12 = () => {
  var _a;
  const hostname = (_a = document == null ? void 0 : document.location) == null ? void 0 : _a.hostname;
  if (hostname.includes("finn")) {
    return "nb";
  } else if (hostname.includes("tori")) {
    return "fi";
  } else if (hostname.includes("blocket")) {
    return "sv";
  } else if (hostname.includes("dba")) {
    return "da";
  } else {
    return defaultLocale14;
  }
};
var getSupportedLocale13 = (usedLocale) => {
  return supportedLocales13.find(
    (locale) => usedLocale === locale || usedLocale.toLowerCase().includes(locale)
  ) || detectByHost12();
};
function detectLocale13() {
  var _a;
  if (typeof window === "undefined") {
    const serverLocale = detectByBrand12();
    return getSupportedLocale13(serverLocale);
  }
  try {
    const htmlLocale = (_a = document == null ? void 0 : document.documentElement) == null ? void 0 : _a.lang;
    const hostLocale = detectByHost12();
    if (!supportedLocales13.includes(htmlLocale)) {
      console.warn("Unsupported locale set in html lang tag, falling back to detection by hostname");
      return getSupportedLocale13(hostLocale);
    }
    return getSupportedLocale13(htmlLocale != null ? htmlLocale : hostLocale);
  } catch (e2) {
    console.warn("could not detect locale, falling back to source locale", e2);
    return defaultLocale14;
  }
}
var getMessages13 = (locale, enMsg, nbMsg, fiMsg) => {
  if (locale === "nb")
    return nbMsg;
  if (locale === "fi")
    return fiMsg;
  return enMsg;
};
var activateI18n13 = (enMessages, nbMessages, fiMessages) => {
  const locale = detectLocale13();
  const messages410 = getMessages13(locale, enMessages, nbMessages, fiMessages);
  i18n.load(locale, messages410);
  i18n.activate(locale);
};
activateI18n13(messages215, messages62, messages313);
var title12 = i18n.t({ message: `Rightward arrow`, id: "icon.title.chevron-right", comment: "Title for chevron-right icon" });
var IconChevronRight16 = (attrs) => React52.createElement("svg", __spreadValues13({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", fill: "none", viewBox: "0 0 16 16", dangerouslySetInnerHTML: { __html: `<title>${title12}</title><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="m5.5 13.75 5.5-5.5-5.5-5.5"></path>` } }, attrs));
var chevron_right_16_default = IconChevronRight16;

// packages/pagination/src/NextPage.tsx
import React53 from "react";
var NextPage = React53.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  var _a2;
  const { currentPage, lastPage } = usePagination();
  if (currentPage >= lastPage) {
    return null;
  }
  const ariaLabel = (_a2 = props["aria-label"]) != null ? _a2 : i18n._({
    id: "pagination.aria.next-page",
    message: "Next page",
    comment: "Default screenreader message for next page link in the pagination component"
  });
  const iconSuffix = i18n._({
    id: "pagination.aria.icon-suffix",
    message: "icon",
    comment: "Suffix added at the end of icon titles when img semantics are lost on an html element"
  });
  return /* @__PURE__ */ React53.createElement(React53.Fragment, null, /* @__PURE__ */ React53.createElement(
    "a",
    __spreadProps(__spreadValues({}, props), {
      ref,
      rel: "next nofollow",
      className: r(className, pagination.link, pagination.icon)
    }),
    /* @__PURE__ */ React53.createElement("span", { className: pagination.a11y }, ariaLabel, ","),
    /* @__PURE__ */ React53.createElement(chevron_right_16_default, null),
    /* @__PURE__ */ React53.createElement("span", { className: pagination.a11y }, iconSuffix)
  ));
});
var NextPage_default = NextPage;

// packages/pagination/src/Page.tsx
import React54 from "react";
var Page = React54.forwardRef((_a, ref) => {
  var _b = _a, { page = 1, className, currentPage } = _b, props = __objRest(_b, ["page", "className", "currentPage"]);
  var _a2;
  const isCurrentPage = page === currentPage;
  const ariaLabel = (_a2 = props["aria-label"]) != null ? _a2 : i18n._({
    id: "pagination.aria.page",
    message: "Page {currentPage}",
    values: { currentPage: page },
    comment: "Default screenreader message for page link in the pagination component"
  });
  return /* @__PURE__ */ React54.createElement(
    "a",
    __spreadProps(__spreadValues({
      "aria-label": ariaLabel
    }, props), {
      ref,
      rel: "nofollow",
      "aria-current": isCurrentPage ? "page" : void 0,
      className: r(className, pagination.link, [isCurrentPage ? pagination.active : pagination.notActive])
    }),
    page
  );
});
var Page_default = Page;

// packages/pagination/src/Pages.tsx
import React55 from "react";
var Pages = React55.forwardRef(
  (_a, ref) => {
    var _b = _a, { children, numPages = 7, className } = _b, props = __objRest(_b, ["children", "numPages", "className"]);
    const { currentPage, lastPage } = usePagination();
    const from = Math.max(currentPage - 3, 0);
    const to = Math.min(from + numPages, lastPage);
    const pages = Array.from(Array(to - from).keys()).map(
      (_, i4) => from + i4 + 1
    );
    return /* @__PURE__ */ React55.createElement(
      "div",
      __spreadProps(__spreadValues({}, props), {
        className: r(pagination.pages, className),
        ref
      }),
      pages.map(
        (page) => React55.cloneElement(children(page), {
          key: page,
          page,
          currentPage
        })
      )
    );
  }
);
var Pages_default = Pages;

// node_modules/.pnpm/@warp-ds+icons@2.0.0/node_modules/@warp-ds/icons/dist/react/chevron-left-16.js
import React56 from "react";
var __defProp15 = Object.defineProperty;
var __getOwnPropSymbols14 = Object.getOwnPropertySymbols;
var __hasOwnProp14 = Object.prototype.hasOwnProperty;
var __propIsEnum14 = Object.prototype.propertyIsEnumerable;
var __defNormalProp15 = (obj, key, value) => key in obj ? __defProp15(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues14 = (a4, b4) => {
  for (var prop in b4 || (b4 = {}))
    if (__hasOwnProp14.call(b4, prop))
      __defNormalProp15(a4, prop, b4[prop]);
  if (__getOwnPropSymbols14)
    for (var prop of __getOwnPropSymbols14(b4)) {
      if (__propIsEnum14.call(b4, prop))
        __defNormalProp15(a4, prop, b4[prop]);
    }
  return a4;
};
var messages63 = JSON.parse('{"icon.title.chevron-left":"Pil til venstre"}');
var messages216 = JSON.parse('{"icon.title.chevron-left":"Leftward arrow"}');
var messages314 = JSON.parse('{"icon.title.chevron-left":"Nuoli vasemmalle"}');
var supportedLocales14 = ["en", "nb", "fi", "da", "sv"];
var defaultLocale15 = "en";
var detectByBrand13 = () => {
  let value;
  switch (process.env.NMP_BRAND) {
    case "FINN":
      value = "nb";
      break;
    case "TORI":
      value = "fi";
      break;
    case "BLOCKET":
      value = "sv";
      break;
    case "DBA":
      value = "da";
      break;
    default:
      value = "en";
  }
  return value;
};
var detectByHost13 = () => {
  var _a;
  const hostname = (_a = document == null ? void 0 : document.location) == null ? void 0 : _a.hostname;
  if (hostname.includes("finn")) {
    return "nb";
  } else if (hostname.includes("tori")) {
    return "fi";
  } else if (hostname.includes("blocket")) {
    return "sv";
  } else if (hostname.includes("dba")) {
    return "da";
  } else {
    return defaultLocale15;
  }
};
var getSupportedLocale14 = (usedLocale) => {
  return supportedLocales14.find(
    (locale) => usedLocale === locale || usedLocale.toLowerCase().includes(locale)
  ) || detectByHost13();
};
function detectLocale14() {
  var _a;
  if (typeof window === "undefined") {
    const serverLocale = detectByBrand13();
    return getSupportedLocale14(serverLocale);
  }
  try {
    const htmlLocale = (_a = document == null ? void 0 : document.documentElement) == null ? void 0 : _a.lang;
    const hostLocale = detectByHost13();
    if (!supportedLocales14.includes(htmlLocale)) {
      console.warn("Unsupported locale set in html lang tag, falling back to detection by hostname");
      return getSupportedLocale14(hostLocale);
    }
    return getSupportedLocale14(htmlLocale != null ? htmlLocale : hostLocale);
  } catch (e2) {
    console.warn("could not detect locale, falling back to source locale", e2);
    return defaultLocale15;
  }
}
var getMessages14 = (locale, enMsg, nbMsg, fiMsg) => {
  if (locale === "nb")
    return nbMsg;
  if (locale === "fi")
    return fiMsg;
  return enMsg;
};
var activateI18n14 = (enMessages, nbMessages, fiMessages) => {
  const locale = detectLocale14();
  const messages410 = getMessages14(locale, enMessages, nbMessages, fiMessages);
  i18n.load(locale, messages410);
  i18n.activate(locale);
};
activateI18n14(messages216, messages63, messages314);
var title13 = i18n.t({ message: `Leftward arrow`, id: "icon.title.chevron-left", comment: "Title for chevron-left icon" });
var IconChevronLeft16 = (attrs) => React56.createElement("svg", __spreadValues14({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", fill: "none", viewBox: "0 0 16 16", dangerouslySetInnerHTML: { __html: `<title>${title13}</title><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M10.5 13.75 5 8.25l5.5-5.5"></path>` } }, attrs));
var chevron_left_16_default = IconChevronLeft16;

// packages/pagination/src/PrevPage.tsx
import React57 from "react";
var PrevPage = React57.forwardRef((_a, ref) => {
  var _b = _a, { className } = _b, props = __objRest(_b, ["className"]);
  var _a2;
  const { currentPage } = usePagination();
  if (currentPage === 1) {
    return null;
  }
  const ariaLabel = (_a2 = props["aria-label"]) != null ? _a2 : i18n._({
    id: "pagination.aria.prev-page",
    message: "Previous page",
    comment: "Default screenreader message for previous page link in the pagination component"
  });
  const iconSuffix = i18n._({
    id: "pagination.aria.icon-suffix",
    message: "icon",
    comment: "Suffix added at the end of icon titles when img semantics are lost on an html element"
  });
  return /* @__PURE__ */ React57.createElement(
    "a",
    __spreadProps(__spreadValues({}, props), {
      ref,
      className: r(className, pagination.link, pagination.icon),
      rel: "prev nofollow"
    }),
    /* @__PURE__ */ React57.createElement("span", { className: pagination.a11y }, ariaLabel, ","),
    /* @__PURE__ */ React57.createElement(chevron_left_16_default, null),
    /* @__PURE__ */ React57.createElement("span", { className: pagination.a11y }, iconSuffix)
  );
});
var PrevPage_default = PrevPage;

// packages/pagination/src/Pagination.tsx
import React58 from "react";
var Pagination = React58.forwardRef(
  (_a, ref) => {
    var _b = _a, {
      currentPage,
      numPages,
      lastPage,
      createHref,
      className,
      onChange
    } = _b, props = __objRest(_b, [
      "currentPage",
      "numPages",
      "lastPage",
      "createHref",
      "className",
      "onChange"
    ]);
    activateI18n7(messages58, messages60, messages59);
    if (!createHref) {
      throw new TypeError("createHref is undefined");
    }
    const handleClick = (page) => (event) => {
      if (onChange) {
        event.preventDefault();
        onChange(page);
      }
    };
    return /* @__PURE__ */ React58.createElement(
      PaginationContainer_default,
      __spreadProps(__spreadValues({}, props), {
        ref,
        currentPage,
        lastPage,
        className
      }),
      /* @__PURE__ */ React58.createElement(FirstPage_default, { href: createHref(1), onClick: handleClick(1) }),
      /* @__PURE__ */ React58.createElement(
        PrevPage_default,
        {
          href: createHref(currentPage - 1),
          onClick: handleClick(currentPage - 1)
        }
      ),
      /* @__PURE__ */ React58.createElement(Pages_default, { numPages }, (page) => /* @__PURE__ */ React58.createElement(Page_default, { href: createHref(page), onClick: handleClick(page) })),
      /* @__PURE__ */ React58.createElement(CurrentPage_default, null),
      /* @__PURE__ */ React58.createElement(
        NextPage_default,
        {
          href: createHref(currentPage + 1),
          onClick: handleClick(currentPage + 1)
        }
      )
    );
  }
);
export {
  Affix,
  Alert,
  Attention,
  Badge,
  Box,
  Breadcrumbs,
  Button,
  Card,
  Clickable,
  Combobox,
  CurrentPage_default as CurrentPage,
  DeadToggle,
  ExpandTransition,
  Expandable,
  FirstPage_default as FirstPage,
  Modal,
  NextPage_default as NextPage,
  Page_default as Page,
  Pages_default as Pages,
  Pagination,
  PaginationContainer_default as PaginationContainer,
  Pill,
  PrevPage_default as PrevPage,
  _Select as Select,
  Slider,
  Step,
  Steps,
  Switch,
  Tab,
  TabPanel,
  Tabs,
  TextArea,
  TextField,
  Toggle,
  UnstyledHeading,
  usePagination
};
/*! Bundled license information:

react-is/cjs/react-is.development.js:
  (** @license React v16.13.1
   * react-is.development.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   *)

object-assign/index.js:
  (*
  object-assign
  (c) Sindre Sorhus
  @license MIT
  *)
*/
//# sourceMappingURL=index.js.map
